import { useState, useEffect, useRef, useCallback } from "react";


// ─── TRANSLATIONS (i18n) ────────────────────────────────────────────────────
const LANGUAGES = [
  { code:"nl", label:"Nederlands", flag:"🇳🇱" },
  { code:"en", label:"English",    flag:"🇬🇧" },
  { code:"de", label:"Deutsch",    flag:"🇩🇪" },
  { code:"fr", label:"Français",   flag:"🇫🇷" },
  { code:"es", label:"Español",    flag:"🇪🇸" },
  { code:"pt", label:"Português",  flag:"🇵🇹" },
];

const T = {
  nl: {
    welcomeBack:"Welkom terug", loginSub:"Log in om te beginnen met notuleren",
    registerTitle:"Account aanmaken", registerSub:"Gratis aan de slag — geen creditcard vereist",
    email:"E-mailadres", password:"Wachtwoord", fullName:"Volledige naam",
    login:"Inloggen", register:"Registreren", loginBtn:"Inloggen →", registerBtn:"Account aanmaken →",
    noAccount:"Nog geen account?", alreadyAccount:"Al een account?", registerFree:"Registreer gratis", loginLink:"Inloggen",
    wrongCredentials:"E-mailadres of wachtwoord klopt niet.",
    fillAll:"Vul alle velden in.", fillName:"Vul uw naam in.",
    weakPassword:"Kies een sterker wachtwoord (min. 8 tekens, hoofdletter en cijfer).",
    confirmEmail:"Bevestig eerst uw e-mailadres via de verificatielink in uw inbox.",
    emailPlaceholder:"jij@bedrijf.nl", passwordPlaceholder:"••••••••",
    namePlaceholder:"Jan de Vries", minChars:"Min. 8 tekens",
    checkInbox:"Controleer uw inbox", verifySubA:"Een verificatielink is verstuurd naar",
    verifySubB:"Klik op de link om uw account te activeren. Controleer ook uw spammap.",
    toLogin:"Naar inloggen →", resend:"📧 Opnieuw versturen",
    resendCool:"Opnieuw versturen", resendOk:"Verificatiemail opnieuw verzonden.",
    meeting:"Meeting", archive:"Archief", plans:"Abonnementen", account:"Account",
    newMeeting:"Nieuwe Meeting", micAccess:"Microfoon toegang",
    meetingActive:"Meeting Actief", transcribing:"Transcriberen…",
    generatingNotes:"Notulen schrijven…", meetingDone:"Meeting Afgerond ✓",
    startSub:"Tik op Start om de opname te beginnen",
    permSub:"Microfoon toegang wordt gevraagd…",
    recordingSub:"Opname loopt — druk op Stop als de meeting klaar is",
    transcribingSub:"Audio wordt omgezet naar tekst via AI",
    generatingSub:"Claude AI schrijft uw notulen…",
    doneSub:"Notulen zijn klaar — bewerk, exporteer of start nieuw",
    meetingName:"Naam van de meeting (optioneel)",
    startMeeting:"🎙️ Start Meeting", stopMeeting:"■ Stop & Maak Notulen",
    cancel:"Annuleren", cancelShort:"✕",
    recordingActive:"Opname actief — max.",
    micActive:"Microfoon actief", readyToStart:"Klaar om te starten",
    waitingSound:"Wacht op geluid…", soundDetected:"Geluid gedetecteerd ✓",
    recording:"Opname", transcription:"Transcriptie", notes:"Notulen",
    speechToText:"Spraak omzetten naar tekst…", patience:"Even geduld, dit kan een moment duren",
    claudeWriting:"Claude schrijft de notulen…", composing:"Notulen worden opgesteld",
    transcriptReady:"📝 Transcriptie gereed",
    edit:"✏️ Bewerken", editDone:"✓ Klaar",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Kopieer", newSession:"+ Nieuw",
    generatedBy:"Claude AI",
    archiveTitle:"Archief", archiveSub:"Overzicht van uw opgeslagen notule-sessies",
    view:"Bekijk", participants:"deelnemers",
    avgNote:"AVG: Opgeslagen notulen worden maximaal 12 maanden bewaard. Audio-opnames worden direct na transcriptie verwijderd.",
    plansTitle:"Abonnementen", plansSub:"Kies het pakket dat bij uw gebruik past",
    selectPlan:"Selecteer pakket", currentPlan:"✓ Huidig pakket",
    contactUs:"Neem contact op →", startFree:"Start nu →",
    perMonth:"/maand", users:"gebruikers", sessionPerMonth:"sessies per maand",
    maxPerSession:"Max.", perSession:"per sessie",
    plansNote:"Alle abonnementen zijn maandelijks opzegbaar · Prijzen excl. BTW · Betaling via Stripe",
    accountTitle:"Account & Huisstijl", accountSub:"Stel uw bedrijfslogo en kleur in voor PDF en Word export",
    logo:"📎 Bedrijfslogo", clickToUpload:"Klik om logo te uploaden", maxSize:"PNG, JPG of SVG · Max 2MB",
    logoLoaded:"Logo geladen", removeLogo:"✕ Verwijderen",
    companyInfo:"🏢 Bedrijfsgegevens", name:"Naam", emailLabel:"E-mail",
    organization:"Organisatie", orgPlaceholder:"Naam van uw bedrijf",
    accentColor:"Accentkleur exports",
    exportPreview:"👁️ Export Voorbeeld", previewHint:"💡 Wijzig kleur of logo — het voorbeeld wordt direct bijgewerkt",
    saveSettings:"Opslaan", saved:"✓ Opgeslagen!",
    saveNote:"Instellingen worden gebruikt voor alle PDF en Word exports.",
    privacy:"🔒 Privacy & AVG", yourRights:"✅ Uw privacyrechten (AVG / GDPR)",
    rightInspect:"Recht op inzage — vraag een overzicht aan van uw opgeslagen gegevens via privacy@notulistai.com",
    rightCorrect:"Recht op correctie — laat onjuiste persoonsgegevens aanpassen",
    rightDelete:"Recht op verwijdering — verzoek tot definitieve verwijdering van uw account en alle data",
    rightPortability:"Recht op dataportabiliteit — ontvang uw gegevens in een machineleesbaar formaat",
    audioDeleted:"Audio-opnames worden direct na transcriptie verwijderd (nooit langer dan 24 uur bewaard)",
    deleteData:"🗑️ Gegevens verwijderen (AVG)", privacyContact:"✉️ Privacy contact",
    logoutBtn:"↩ Uit", logoutMobile:"↩ Uitloggen",
    logoutTitle:"Uitloggen?", logoutSub:"U wordt uitgelogd. Niet-opgeslagen notulen gaan verloren.",
    logoutConfirm:"Uitloggen", logoutCancel:"Annuleren",
    avgTitle:"📋 Privacyverklaring & AVG-toestemming",
    avgSub:"Lees en accepteer ons privacybeleid om door te gaan",
    avgScrollHint:"↓ Scroll naar beneden om alle informatie te lezen",
    avgRead:"✓ Privacyverklaring gelezen",
    avgDecline:"Weigeren", avgAccept:"Accepteren & Registreren",
    deleteTitle:"🗑️ Gegevens verwijderen (AVG)",
    deleteStep1:"U kunt gebruik maken van uw recht op verwijdering (artikel 17 AVG). Alle gegevens gekoppeld aan uw account worden permanent verwijderd.",
    deleteContinue:"Doorgaan", deleteCancel:"Annuleren",
    deleteConfirmTitle:"⚠️ Definitief verwijderen",
    deleteConfirmText:"Dit kan niet ongedaan worden gemaakt. Uw account en alle bijbehorende gegevens worden binnen 30 dagen definitief verwijderd conform de AVG.",
    deleteConfirmBtn:"Ja, verwijder alles",
    deleteSuccessTitle:"✓ Verzoek ontvangen",
    deleteSuccessText:"Uw verwijderverzoek is ingediend. U ontvangt binnen 72 uur een bevestiging per e-mail.",
    deleteClose:"Sluiten",
    sessionsLeft:"sessies resterend",
    limitReachedTitle:"Sessielimiet bereikt",
    limitReachedSub:"Uw abonnement staat",
    limitReachedSub2:"sessies per maand toe.",
    upgrade:"Upgrade →",
    tooShort:"Opname te kort. Probeer opnieuw.",
    genError:"Fout:",
    micNeeded:"Microfoon toegang nodig",
    micSub:"Tik op de knop hieronder en sta microfoon toe wanneer uw browser hierom vraagt.",
    micDenied:"Microfoon toegang geweigerd. Sta toegang toe in uw browser.",
    micNotFound:"Geen microfoon gevonden.",
    micError:"Microfoon fout:",
    micGrant:"🎙️ Sta microfoon toe",
    iosHint:"📱 iOS: Instellingen → Safari → Microfoon → Toestaan",
    androidHint:"🤖 Android: Tik 🔒 adresbalk → Microfoon → Toestaan",
  },
  en: {
    welcomeBack:"Welcome back", loginSub:"Log in to get started",
    registerTitle:"Create account", registerSub:"Free to start — no credit card required",
    email:"Email address", password:"Password", fullName:"Full name",
    login:"Login", register:"Register", loginBtn:"Log in →", registerBtn:"Create account →",
    noAccount:"No account yet?", alreadyAccount:"Already have an account?", registerFree:"Register free", loginLink:"Log in",
    wrongCredentials:"Email address or password is incorrect.",
    fillAll:"Please fill in all fields.", fillName:"Please enter your name.",
    weakPassword:"Choose a stronger password (min. 8 chars, uppercase and number).",
    confirmEmail:"Please confirm your email address via the verification link in your inbox.",
    emailPlaceholder:"you@company.com", passwordPlaceholder:"••••••••",
    namePlaceholder:"John Smith", minChars:"Min. 8 characters",
    checkInbox:"Check your inbox", verifySubA:"A verification link has been sent to",
    verifySubB:"Click the link to activate your account. Also check your spam folder.",
    toLogin:"Go to login →", resend:"📧 Resend email",
    resendCool:"Resend", resendOk:"Verification email resent.",
    meeting:"Meeting", archive:"Archive", plans:"Plans", account:"Account",
    newMeeting:"New Meeting", micAccess:"Microphone access",
    meetingActive:"Meeting Active", transcribing:"Transcribing…",
    generatingNotes:"Writing notes…", meetingDone:"Meeting Completed ✓",
    startSub:"Tap Start to begin recording",
    permSub:"Microphone permission is being requested…",
    recordingSub:"Recording — press Stop when the meeting is done",
    transcribingSub:"Audio is being converted to text via AI",
    generatingSub:"Claude AI is writing your minutes…",
    doneSub:"Minutes are ready — edit, export or start new",
    meetingName:"Meeting name (optional)",
    startMeeting:"🎙️ Start Meeting", stopMeeting:"■ Stop & Generate Minutes",
    cancel:"Cancel", cancelShort:"✕",
    recordingActive:"Recording active — max.",
    micActive:"Microphone active", readyToStart:"Ready to start",
    waitingSound:"Waiting for sound…", soundDetected:"Sound detected ✓",
    recording:"Recording", transcription:"Transcription", notes:"Minutes",
    speechToText:"Converting speech to text…", patience:"Please wait a moment",
    claudeWriting:"Claude is writing the minutes…", composing:"Minutes are being composed",
    transcriptReady:"📝 Transcript ready",
    edit:"✏️ Edit", editDone:"✓ Done",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Copy", newSession:"+ New",
    generatedBy:"Claude AI",
    archiveTitle:"Archive", archiveSub:"Overview of your saved meeting minutes",
    view:"View", participants:"participants",
    avgNote:"GDPR: Saved minutes are stored for a maximum of 12 months. Audio recordings are deleted immediately after transcription.",
    plansTitle:"Plans", plansSub:"Choose the plan that suits your usage",
    selectPlan:"Select plan", currentPlan:"✓ Current plan",
    contactUs:"Contact us →", startFree:"Start now →",
    perMonth:"/month", users:"users", sessionPerMonth:"sessions per month",
    maxPerSession:"Max.", perSession:"per session",
    plansNote:"All plans are monthly cancellable · Prices excl. VAT · Payment via Stripe",
    accountTitle:"Account & Branding", accountSub:"Set your company logo and color for PDF and Word exports",
    logo:"📎 Company logo", clickToUpload:"Click to upload logo", maxSize:"PNG, JPG or SVG · Max 2MB",
    logoLoaded:"Logo loaded", removeLogo:"✕ Remove",
    companyInfo:"🏢 Company details", name:"Name", emailLabel:"Email",
    organization:"Organization", orgPlaceholder:"Your company name",
    accentColor:"Accent color for exports",
    exportPreview:"👁️ Export Preview", previewHint:"💡 Change color or logo — preview updates instantly",
    saveSettings:"Save", saved:"✓ Saved!",
    saveNote:"Settings are applied to all PDF and Word exports.",
    privacy:"🔒 Privacy & GDPR", yourRights:"✅ Your rights (GDPR)",
    rightInspect:"Right of access — request an overview of your stored data via privacy@notulistai.com",
    rightCorrect:"Right of rectification — have incorrect personal data corrected",
    rightDelete:"Right to erasure — request permanent deletion of your account and all data",
    rightPortability:"Right to data portability — receive your data in a machine-readable format",
    audioDeleted:"Audio recordings are deleted immediately after transcription (never stored longer than 24 hours)",
    deleteData:"🗑️ Delete data (GDPR)", privacyContact:"✉️ Privacy contact",
    logoutBtn:"↩ Out", logoutMobile:"↩ Log out",
    logoutTitle:"Log out?", logoutSub:"You will be logged out. Unsaved minutes will be lost.",
    logoutConfirm:"Log out", logoutCancel:"Cancel",
    avgTitle:"📋 Privacy Policy & GDPR Consent",
    avgSub:"Read and accept our privacy policy to continue",
    avgScrollHint:"↓ Scroll down to read all information",
    avgRead:"✓ Privacy policy read",
    avgDecline:"Decline", avgAccept:"Accept & Register",
    deleteTitle:"🗑️ Delete data (GDPR)",
    deleteStep1:"You can exercise your right to erasure (Article 17 GDPR). All data linked to your account will be permanently deleted.",
    deleteContinue:"Continue", deleteCancel:"Cancel",
    deleteConfirmTitle:"⚠️ Permanent deletion",
    deleteConfirmText:"This cannot be undone. Your account and all associated data will be permanently deleted within 30 days.",
    deleteConfirmBtn:"Yes, delete everything",
    deleteSuccessTitle:"✓ Request received",
    deleteSuccessText:"Your deletion request has been submitted. You will receive a confirmation email within 72 hours.",
    deleteClose:"Close",
    sessionsLeft:"sessions remaining",
    limitReachedTitle:"Session limit reached",
    limitReachedSub:"Your plan allows",
    limitReachedSub2:"sessions per month.",
    upgrade:"Upgrade →",
    tooShort:"Recording too short. Please try again.",
    genError:"Error generating:",
    micNeeded:"Microphone access needed",
    micSub:"Tap the button below and allow microphone access when your browser asks.",
    micDenied:"Microphone access denied. Please allow access in your browser.",
    micNotFound:"No microphone found.",
    micError:"Microphone error:",
    micGrant:"🎙️ Allow microphone",
    iosHint:"📱 iOS: Settings → Safari → Microphone → Allow",
    androidHint:"🤖 Android: Tap 🔒 in address bar → Microphone → Allow",
  },
  de: {
    welcomeBack:"Willkommen zurück", loginSub:"Melden Sie sich an, um zu beginnen",
    registerTitle:"Konto erstellen", registerSub:"Kostenlos starten — keine Kreditkarte erforderlich",
    email:"E-Mail-Adresse", password:"Passwort", fullName:"Vollständiger Name",
    login:"Anmelden", register:"Registrieren", loginBtn:"Anmelden →", registerBtn:"Konto erstellen →",
    noAccount:"Noch kein Konto?", alreadyAccount:"Bereits ein Konto?", registerFree:"Kostenlos registrieren", loginLink:"Anmelden",
    wrongCredentials:"E-Mail-Adresse oder Passwort ist falsch.",
    fillAll:"Bitte alle Felder ausfüllen.", fillName:"Bitte geben Sie Ihren Namen ein.",
    weakPassword:"Wählen Sie ein stärkeres Passwort (min. 8 Zeichen, Großbuchstabe und Zahl).",
    confirmEmail:"Bitte bestätigen Sie Ihre E-Mail-Adresse über den Verifizierungslink in Ihrem Posteingang.",
    emailPlaceholder:"sie@unternehmen.de", passwordPlaceholder:"••••••••",
    namePlaceholder:"Max Mustermann", minChars:"Mind. 8 Zeichen",
    checkInbox:"Überprüfen Sie Ihren Posteingang", verifySubA:"Ein Verifizierungslink wurde gesendet an",
    verifySubB:"Klicken Sie auf den Link, um Ihr Konto zu aktivieren. Überprüfen Sie auch Ihren Spam-Ordner.",
    toLogin:"Zur Anmeldung →", resend:"📧 Erneut senden",
    resendCool:"Erneut senden", resendOk:"Bestätigungsmail erneut gesendet.",
    meeting:"Meeting", archive:"Archiv", plans:"Abonnements", account:"Konto",
    newMeeting:"Neues Meeting", micAccess:"Mikrofon-Zugriff",
    meetingActive:"Meeting aktiv", transcribing:"Transkribieren…",
    generatingNotes:"Protokoll erstellen…", meetingDone:"Meeting abgeschlossen ✓",
    startSub:"Tippen Sie auf Start, um die Aufnahme zu beginnen",
    permSub:"Mikrofon-Berechtigung wird angefragt…",
    recordingSub:"Aufnahme läuft — drücken Sie Stop, wenn das Meeting beendet ist",
    transcribingSub:"Audio wird per KI in Text umgewandelt",
    generatingSub:"Claude KI schreibt Ihr Protokoll…",
    doneSub:"Protokoll ist fertig — bearbeiten, exportieren oder neu starten",
    meetingName:"Meeting-Name (optional)",
    startMeeting:"🎙️ Meeting starten", stopMeeting:"■ Stop & Protokoll erstellen",
    cancel:"Abbrechen", cancelShort:"✕",
    recordingActive:"Aufnahme aktiv — max.",
    micActive:"Mikrofon aktiv", readyToStart:"Bereit zum Starten",
    waitingSound:"Warte auf Ton…", soundDetected:"Ton erkannt ✓",
    recording:"Aufnahme", transcription:"Transkription", notes:"Protokoll",
    speechToText:"Sprache in Text umwandeln…", patience:"Bitte einen Moment warten",
    claudeWriting:"Claude erstellt das Protokoll…", composing:"Protokoll wird erstellt",
    transcriptReady:"📝 Transkription fertig",
    edit:"✏️ Bearbeiten", editDone:"✓ Fertig",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Kopieren", newSession:"+ Neu",
    generatedBy:"Claude KI",
    archiveTitle:"Archiv", archiveSub:"Übersicht Ihrer gespeicherten Protokolle",
    view:"Ansehen", participants:"Teilnehmer",
    avgNote:"DSGVO: Gespeicherte Protokolle werden maximal 12 Monate aufbewahrt. Audio-Aufnahmen werden direkt nach der Transkription gelöscht.",
    plansTitle:"Abonnements", plansSub:"Wählen Sie das passende Paket",
    selectPlan:"Paket wählen", currentPlan:"✓ Aktuelles Paket",
    contactUs:"Kontakt aufnehmen →", startFree:"Jetzt starten →",
    perMonth:"/Monat", users:"Benutzer", sessionPerMonth:"Sitzungen pro Monat",
    maxPerSession:"Max.", perSession:"pro Sitzung",
    plansNote:"Alle Abonnements monatlich kündbar · Preise zzgl. MwSt. · Zahlung über Stripe",
    accountTitle:"Konto & Corporate Design", accountSub:"Legen Sie Ihr Firmenlogo und Farbe für PDF- und Word-Exporte fest",
    logo:"📎 Firmenlogo", clickToUpload:"Logo hochladen", maxSize:"PNG, JPG oder SVG · Max. 2 MB",
    logoLoaded:"Logo geladen", removeLogo:"✕ Entfernen",
    companyInfo:"🏢 Unternehmensdaten", name:"Name", emailLabel:"E-Mail",
    organization:"Organisation", orgPlaceholder:"Ihr Unternehmensname",
    accentColor:"Akzentfarbe für Exporte",
    exportPreview:"👁️ Export-Vorschau", previewHint:"💡 Farbe oder Logo ändern — Vorschau wird sofort aktualisiert",
    saveSettings:"Speichern", saved:"✓ Gespeichert!",
    saveNote:"Einstellungen werden für alle PDF- und Word-Exporte verwendet.",
    privacy:"🔒 Datenschutz & DSGVO", yourRights:"✅ Ihre Rechte (DSGVO)",
    rightInspect:"Auskunftsrecht — Fordern Sie eine Übersicht Ihrer gespeicherten Daten an",
    rightCorrect:"Berichtigungsrecht — Lassen Sie falsche personenbezogene Daten korrigieren",
    rightDelete:"Recht auf Löschung — Beantragen Sie die endgültige Löschung Ihres Kontos",
    rightPortability:"Recht auf Datenübertragbarkeit — Erhalten Sie Ihre Daten in einem maschinenlesbaren Format",
    audioDeleted:"Audio-Aufnahmen werden direkt nach der Transkription gelöscht (nie länger als 24 Stunden gespeichert)",
    deleteData:"🗑️ Daten löschen (DSGVO)", privacyContact:"✉️ Datenschutz-Kontakt",
    logoutBtn:"↩ Aus", logoutMobile:"↩ Abmelden",
    logoutTitle:"Abmelden?", logoutSub:"Sie werden abgemeldet. Nicht gespeicherte Protokolle gehen verloren.",
    logoutConfirm:"Abmelden", logoutCancel:"Abbrechen",
    avgTitle:"📋 Datenschutzerklärung & DSGVO-Zustimmung",
    avgSub:"Lesen und akzeptieren Sie unsere Datenschutzrichtlinie um fortzufahren",
    avgScrollHint:"↓ Nach unten scrollen, um alle Informationen zu lesen",
    avgRead:"✓ Datenschutzerklärung gelesen",
    avgDecline:"Ablehnen", avgAccept:"Akzeptieren & Registrieren",
    deleteTitle:"🗑️ Daten löschen (DSGVO)",
    deleteStep1:"Sie können Ihr Recht auf Löschung ausüben (Art. 17 DSGVO). Alle mit Ihrem Konto verknüpften Daten werden dauerhaft gelöscht.",
    deleteContinue:"Weiter", deleteCancel:"Abbrechen",
    deleteConfirmTitle:"⚠️ Endgültige Löschung",
    deleteConfirmText:"Dies kann nicht rückgängig gemacht werden. Ihr Konto wird innerhalb von 30 Tagen gemäß DSGVO gelöscht.",
    deleteConfirmBtn:"Ja, alles löschen",
    deleteSuccessTitle:"✓ Anfrage erhalten",
    deleteSuccessText:"Ihre Löschanfrage wurde eingereicht. Sie erhalten innerhalb von 72 Stunden eine Bestätigungsmail.",
    deleteClose:"Schließen",
    sessionsLeft:"Sitzungen verbleibend",
    limitReachedTitle:"Sitzungslimit erreicht",
    limitReachedSub:"Ihr Abonnement erlaubt",
    limitReachedSub2:"Sitzungen pro Monat.",
    upgrade:"Upgraden →",
    tooShort:"Aufnahme zu kurz. Bitte erneut versuchen.",
    genError:"Fehler beim Erstellen:",
    micNeeded:"Mikrofon-Zugriff erforderlich",
    micSub:"Tippen Sie auf die Schaltfläche und erlauben Sie den Mikrofon-Zugriff.",
    micDenied:"Mikrofon-Zugriff verweigert. Bitte erlauben Sie den Zugriff in Ihrem Browser.",
    micNotFound:"Kein Mikrofon gefunden.",
    micError:"Mikrofonfehler:",
    micGrant:"🎙️ Mikrofon zulassen",
    iosHint:"📱 iOS: Einstellungen → Safari → Mikrofon → Zulassen",
    androidHint:"🤖 Android: 🔒 in Adressleiste tippen → Mikrofon → Zulassen",
  },
  fr: {
    welcomeBack:"Bon retour", loginSub:"Connectez-vous pour commencer",
    registerTitle:"Créer un compte", registerSub:"Gratuit pour commencer — sans carte bancaire",
    email:"Adresse e-mail", password:"Mot de passe", fullName:"Nom complet",
    login:"Connexion", register:"S'inscrire", loginBtn:"Se connecter →", registerBtn:"Créer un compte →",
    noAccount:"Pas encore de compte ?", alreadyAccount:"Déjà un compte ?", registerFree:"S'inscrire gratuitement", loginLink:"Se connecter",
    wrongCredentials:"E-mail ou mot de passe incorrect.",
    fillAll:"Veuillez remplir tous les champs.", fillName:"Veuillez entrer votre nom.",
    weakPassword:"Choisissez un mot de passe plus fort (min. 8 caractères, majuscule et chiffre).",
    confirmEmail:"Veuillez confirmer votre adresse e-mail via le lien de vérification.",
    emailPlaceholder:"vous@entreprise.fr", passwordPlaceholder:"••••••••",
    namePlaceholder:"Jean Dupont", minChars:"Min. 8 caractères",
    checkInbox:"Vérifiez votre boîte mail", verifySubA:"Un lien de vérification a été envoyé à",
    verifySubB:"Cliquez sur le lien pour activer votre compte. Vérifiez également vos spams.",
    toLogin:"Aller à la connexion →", resend:"📧 Renvoyer l'e-mail",
    resendCool:"Renvoyer", resendOk:"E-mail de vérification renvoyé.",
    meeting:"Réunion", archive:"Archives", plans:"Abonnements", account:"Compte",
    newMeeting:"Nouvelle réunion", micAccess:"Accès microphone",
    meetingActive:"Réunion active", transcribing:"Transcription…",
    generatingNotes:"Rédaction du compte rendu…", meetingDone:"Réunion terminée ✓",
    startSub:"Appuyez sur Démarrer pour commencer l'enregistrement",
    permSub:"Autorisation du microphone en cours…",
    recordingSub:"Enregistrement — appuyez sur Stop quand la réunion est terminée",
    transcribingSub:"L'audio est converti en texte par IA",
    generatingSub:"Claude IA rédige votre compte rendu…",
    doneSub:"Compte rendu prêt — modifiez, exportez ou démarrez une nouvelle réunion",
    meetingName:"Nom de la réunion (optionnel)",
    startMeeting:"🎙️ Démarrer la réunion", stopMeeting:"■ Stop & Générer le compte rendu",
    cancel:"Annuler", cancelShort:"✕",
    recordingActive:"Enregistrement actif — max.",
    micActive:"Microphone actif", readyToStart:"Prêt à démarrer",
    waitingSound:"En attente de son…", soundDetected:"Son détecté ✓",
    recording:"Enregistrement", transcription:"Transcription", notes:"Compte rendu",
    speechToText:"Conversion de la parole en texte…", patience:"Veuillez patienter",
    claudeWriting:"Claude rédige le compte rendu…", composing:"Compte rendu en cours",
    transcriptReady:"📝 Transcription prête",
    edit:"✏️ Modifier", editDone:"✓ Terminé",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Copier", newSession:"+ Nouveau",
    generatedBy:"Claude IA",
    archiveTitle:"Archives", archiveSub:"Aperçu de vos comptes rendus enregistrés",
    view:"Voir", participants:"participants",
    avgNote:"RGPD : Les comptes rendus sont conservés maximum 12 mois. Les enregistrements audio sont supprimés immédiatement après transcription.",
    plansTitle:"Abonnements", plansSub:"Choisissez le forfait qui correspond à votre usage",
    selectPlan:"Sélectionner", currentPlan:"✓ Forfait actuel",
    contactUs:"Nous contacter →", startFree:"Commencer →",
    perMonth:"/mois", users:"utilisateurs", sessionPerMonth:"séances par mois",
    maxPerSession:"Max.", perSession:"par séance",
    plansNote:"Tous les abonnements sont résiliables chaque mois · Prix HT · Paiement via Stripe",
    accountTitle:"Compte & Identité visuelle", accountSub:"Définissez votre logo et couleur pour les exports PDF et Word",
    logo:"📎 Logo d'entreprise", clickToUpload:"Cliquez pour télécharger le logo", maxSize:"PNG, JPG ou SVG · Max 2 Mo",
    logoLoaded:"Logo chargé", removeLogo:"✕ Supprimer",
    companyInfo:"🏢 Informations entreprise", name:"Nom", emailLabel:"E-mail",
    organization:"Organisation", orgPlaceholder:"Nom de votre entreprise",
    accentColor:"Couleur d'accent pour les exports",
    exportPreview:"👁️ Aperçu export", previewHint:"💡 Changez la couleur ou le logo — l'aperçu se met à jour instantanément",
    saveSettings:"Enregistrer", saved:"✓ Enregistré !",
    saveNote:"Les paramètres sont appliqués à tous les exports PDF et Word.",
    privacy:"🔒 Confidentialité & RGPD", yourRights:"✅ Vos droits (RGPD)",
    rightInspect:"Droit d'accès — demandez un aperçu de vos données stockées",
    rightCorrect:"Droit de rectification — faites corriger les données inexactes",
    rightDelete:"Droit à l'effacement — demandez la suppression définitive de votre compte",
    rightPortability:"Droit à la portabilité — recevez vos données dans un format lisible par machine",
    audioDeleted:"Les enregistrements audio sont supprimés immédiatement après transcription (jamais plus de 24 heures)",
    deleteData:"🗑️ Supprimer mes données (RGPD)", privacyContact:"✉️ Contact confidentialité",
    logoutBtn:"↩ Quitter", logoutMobile:"↩ Se déconnecter",
    logoutTitle:"Se déconnecter ?", logoutSub:"Vous serez déconnecté. Les comptes rendus non sauvegardés seront perdus.",
    logoutConfirm:"Se déconnecter", logoutCancel:"Annuler",
    avgTitle:"📋 Politique de confidentialité & Consentement RGPD",
    avgSub:"Lisez et acceptez notre politique de confidentialité pour continuer",
    avgScrollHint:"↓ Faites défiler vers le bas pour lire toutes les informations",
    avgRead:"✓ Politique lue",
    avgDecline:"Refuser", avgAccept:"Accepter & S'inscrire",
    deleteTitle:"🗑️ Supprimer mes données (RGPD)",
    deleteStep1:"Vous pouvez exercer votre droit à l'effacement (Article 17 RGPD). Toutes les données liées à votre compte seront définitivement supprimées.",
    deleteContinue:"Continuer", deleteCancel:"Annuler",
    deleteConfirmTitle:"⚠️ Suppression définitive",
    deleteConfirmText:"Cette action est irréversible. Votre compte sera supprimé dans 30 jours conformément au RGPD.",
    deleteConfirmBtn:"Oui, tout supprimer",
    deleteSuccessTitle:"✓ Demande reçue",
    deleteSuccessText:"Votre demande de suppression a été soumise. Vous recevrez un e-mail de confirmation dans 72 heures.",
    deleteClose:"Fermer",
    sessionsLeft:"séances restantes",
    limitReachedTitle:"Limite de séances atteinte",
    limitReachedSub:"Votre abonnement permet",
    limitReachedSub2:"séances par mois.",
    upgrade:"Mettre à niveau →",
    tooShort:"Enregistrement trop court. Veuillez réessayer.",
    genError:"Erreur de génération :",
    micNeeded:"Accès au microphone requis",
    micSub:"Appuyez sur le bouton ci-dessous et autorisez l'accès au microphone.",
    micDenied:"Accès au microphone refusé. Veuillez autoriser l'accès dans votre navigateur.",
    micNotFound:"Aucun microphone trouvé.",
    micError:"Erreur microphone :",
    micGrant:"🎙️ Autoriser le microphone",
    iosHint:"📱 iOS : Réglages → Safari → Microphone → Autoriser",
    androidHint:"🤖 Android : Appuyer sur 🔒 dans la barre d'adresse → Microphone → Autoriser",
  },
  es: {
    welcomeBack:"Bienvenido de nuevo", loginSub:"Inicia sesión para comenzar",
    registerTitle:"Crear cuenta", registerSub:"Gratis para empezar — sin tarjeta de crédito",
    email:"Correo electrónico", password:"Contraseña", fullName:"Nombre completo",
    login:"Iniciar sesión", register:"Registrarse", loginBtn:"Iniciar sesión →", registerBtn:"Crear cuenta →",
    noAccount:"¿No tienes cuenta?", alreadyAccount:"¿Ya tienes cuenta?", registerFree:"Regístrate gratis", loginLink:"Iniciar sesión",
    wrongCredentials:"Correo electrónico o contraseña incorrectos.",
    fillAll:"Por favor, rellena todos los campos.", fillName:"Por favor, introduce tu nombre.",
    weakPassword:"Elige una contraseña más fuerte (mín. 8 caracteres, mayúscula y número).",
    confirmEmail:"Por favor, confirma tu dirección de correo electrónico mediante el enlace de verificación.",
    emailPlaceholder:"tu@empresa.es", passwordPlaceholder:"••••••••",
    namePlaceholder:"Juan García", minChars:"Mín. 8 caracteres",
    checkInbox:"Revisa tu bandeja de entrada", verifySubA:"Se ha enviado un enlace de verificación a",
    verifySubB:"Haz clic en el enlace para activar tu cuenta. Revisa también tu carpeta de spam.",
    toLogin:"Ir al inicio de sesión →", resend:"📧 Reenviar correo",
    resendCool:"Reenviar", resendOk:"Correo de verificación reenviado.",
    meeting:"Reunión", archive:"Archivo", plans:"Planes", account:"Cuenta",
    newMeeting:"Nueva reunión", micAccess:"Acceso al micrófono",
    meetingActive:"Reunión activa", transcribing:"Transcribiendo…",
    generatingNotes:"Redactando actas…", meetingDone:"Reunión completada ✓",
    startSub:"Toca Iniciar para comenzar la grabación",
    permSub:"Se está solicitando permiso del micrófono…",
    recordingSub:"Grabando — pulsa Detener cuando la reunión haya terminado",
    transcribingSub:"El audio se está convirtiendo en texto mediante IA",
    generatingSub:"Claude IA está redactando tus actas…",
    doneSub:"Actas listas — edita, exporta o inicia una nueva reunión",
    meetingName:"Nombre de la reunión (opcional)",
    startMeeting:"🎙️ Iniciar reunión", stopMeeting:"■ Detener & Generar actas",
    cancel:"Cancelar", cancelShort:"✕",
    recordingActive:"Grabación activa — máx.",
    micActive:"Micrófono activo", readyToStart:"Listo para comenzar",
    waitingSound:"Esperando sonido…", soundDetected:"Sonido detectado ✓",
    recording:"Grabación", transcription:"Transcripción", notes:"Actas",
    speechToText:"Convirtiendo voz en texto…", patience:"Por favor, espera un momento",
    claudeWriting:"Claude está redactando las actas…", composing:"Las actas se están redactando",
    transcriptReady:"📝 Transcripción lista",
    edit:"✏️ Editar", editDone:"✓ Listo",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Copiar", newSession:"+ Nuevo",
    generatedBy:"Claude IA",
    archiveTitle:"Archivo", archiveSub:"Resumen de tus actas guardadas",
    view:"Ver", participants:"participantes",
    avgNote:"RGPD: Las actas se conservan un máximo de 12 meses. Las grabaciones de audio se eliminan inmediatamente después de la transcripción.",
    plansTitle:"Planes", plansSub:"Elige el plan que se adapte a tu uso",
    selectPlan:"Seleccionar plan", currentPlan:"✓ Plan actual",
    contactUs:"Contactar →", startFree:"Empezar ahora →",
    perMonth:"/mes", users:"usuarios", sessionPerMonth:"sesiones por mes",
    maxPerSession:"Máx.", perSession:"por sesión",
    plansNote:"Todos los planes son cancelables mensualmente · Precios sin IVA · Pago via Stripe",
    accountTitle:"Cuenta e identidad visual", accountSub:"Configura tu logo y color para exportaciones PDF y Word",
    logo:"📎 Logo de empresa", clickToUpload:"Haz clic para subir el logo", maxSize:"PNG, JPG o SVG · Máx. 2 MB",
    logoLoaded:"Logo cargado", removeLogo:"✕ Eliminar",
    companyInfo:"🏢 Datos de empresa", name:"Nombre", emailLabel:"Correo",
    organization:"Organización", orgPlaceholder:"Nombre de tu empresa",
    accentColor:"Color de acento para exportaciones",
    exportPreview:"👁️ Vista previa de exportación", previewHint:"💡 Cambia el color o logo — la vista previa se actualiza al instante",
    saveSettings:"Guardar", saved:"✓ ¡Guardado!",
    saveNote:"La configuración se aplica a todas las exportaciones PDF y Word.",
    privacy:"🔒 Privacidad & RGPD", yourRights:"✅ Tus derechos (RGPD)",
    rightInspect:"Derecho de acceso — solicita un resumen de tus datos almacenados",
    rightCorrect:"Derecho de rectificación — corrige datos personales incorrectos",
    rightDelete:"Derecho al olvido — solicita la eliminación definitiva de tu cuenta",
    rightPortability:"Derecho a la portabilidad — recibe tus datos en formato legible por máquina",
    audioDeleted:"Las grabaciones de audio se eliminan inmediatamente después de la transcripción (nunca más de 24 horas)",
    deleteData:"🗑️ Eliminar mis datos (RGPD)", privacyContact:"✉️ Contacto de privacidad",
    logoutBtn:"↩ Salir", logoutMobile:"↩ Cerrar sesión",
    logoutTitle:"¿Cerrar sesión?", logoutSub:"Se cerrará tu sesión. Las actas no guardadas se perderán.",
    logoutConfirm:"Cerrar sesión", logoutCancel:"Cancelar",
    avgTitle:"📋 Política de privacidad & Consentimiento RGPD",
    avgSub:"Lee y acepta nuestra política de privacidad para continuar",
    avgScrollHint:"↓ Desplázate hacia abajo para leer toda la información",
    avgRead:"✓ Política de privacidad leída",
    avgDecline:"Rechazar", avgAccept:"Aceptar & Registrarse",
    deleteTitle:"🗑️ Eliminar mis datos (RGPD)",
    deleteStep1:"Puedes ejercer tu derecho al olvido (Artículo 17 RGPD). Todos los datos vinculados a tu cuenta se eliminarán permanentemente.",
    deleteContinue:"Continuar", deleteCancel:"Cancelar",
    deleteConfirmTitle:"⚠️ Eliminación definitiva",
    deleteConfirmText:"Esta acción no se puede deshacer. Tu cuenta será eliminada en 30 días conforme al RGPD.",
    deleteConfirmBtn:"Sí, eliminar todo",
    deleteSuccessTitle:"✓ Solicitud recibida",
    deleteSuccessText:"Tu solicitud de eliminación ha sido enviada. Recibirás un correo de confirmación en 72 horas.",
    deleteClose:"Cerrar",
    sessionsLeft:"sesiones restantes",
    limitReachedTitle:"Límite de sesiones alcanzado",
    limitReachedSub:"Tu plan permite",
    limitReachedSub2:"sesiones por mes.",
    upgrade:"Mejorar plan →",
    tooShort:"Grabación demasiado corta. Por favor, inténtalo de nuevo.",
    genError:"Error al generar:",
    micNeeded:"Se necesita acceso al micrófono",
    micSub:"Toca el botón de abajo y permite el acceso al micrófono cuando tu navegador lo solicite.",
    micDenied:"Acceso al micrófono denegado. Permite el acceso en tu navegador.",
    micNotFound:"No se encontró ningún micrófono.",
    micError:"Error de micrófono:",
    micGrant:"🎙️ Permitir micrófono",
    iosHint:"📱 iOS: Ajustes → Safari → Micrófono → Permitir",
    androidHint:"🤖 Android: Toca 🔒 en la barra de direcciones → Micrófono → Permitir",
  },
  pt: {
    welcomeBack:"Bem-vindo de volta", loginSub:"Faça login para começar",
    registerTitle:"Criar conta", registerSub:"Grátis para começar — sem cartão de crédito",
    email:"Endereço de e-mail", password:"Senha", fullName:"Nome completo",
    login:"Entrar", register:"Registrar", loginBtn:"Entrar →", registerBtn:"Criar conta →",
    noAccount:"Ainda não tem conta?", alreadyAccount:"Já tem conta?", registerFree:"Registre-se gratuitamente", loginLink:"Entrar",
    wrongCredentials:"E-mail ou senha incorretos.",
    fillAll:"Por favor, preencha todos os campos.", fillName:"Por favor, insira seu nome.",
    weakPassword:"Escolha uma senha mais forte (mín. 8 caracteres, maiúscula e número).",
    confirmEmail:"Por favor, confirme seu endereço de e-mail através do link de verificação.",
    emailPlaceholder:"voce@empresa.com.br", passwordPlaceholder:"••••••••",
    namePlaceholder:"João Silva", minChars:"Mín. 8 caracteres",
    checkInbox:"Verifique sua caixa de entrada", verifySubA:"Um link de verificação foi enviado para",
    verifySubB:"Clique no link para ativar sua conta. Verifique também sua pasta de spam.",
    toLogin:"Ir para login →", resend:"📧 Reenviar e-mail",
    resendCool:"Reenviar", resendOk:"E-mail de verificação reenviado.",
    meeting:"Reunião", archive:"Arquivo", plans:"Planos", account:"Conta",
    newMeeting:"Nova reunião", micAccess:"Acesso ao microfone",
    meetingActive:"Reunião ativa", transcribing:"Transcrevendo…",
    generatingNotes:"Redigindo ata…", meetingDone:"Reunião concluída ✓",
    startSub:"Toque em Iniciar para começar a gravação",
    permSub:"Permissão do microfone sendo solicitada…",
    recordingSub:"Gravando — pressione Parar quando a reunião terminar",
    transcribingSub:"O áudio está sendo convertido em texto por IA",
    generatingSub:"Claude IA está redigindo sua ata…",
    doneSub:"Ata pronta — edite, exporte ou inicie uma nova reunião",
    meetingName:"Nome da reunião (opcional)",
    startMeeting:"🎙️ Iniciar reunião", stopMeeting:"■ Parar & Gerar ata",
    cancel:"Cancelar", cancelShort:"✕",
    recordingActive:"Gravação ativa — máx.",
    micActive:"Microfone ativo", readyToStart:"Pronto para começar",
    waitingSound:"Aguardando som…", soundDetected:"Som detectado ✓",
    recording:"Gravação", transcription:"Transcrição", notes:"Ata",
    speechToText:"Convertendo voz em texto…", patience:"Por favor, aguarde um momento",
    claudeWriting:"Claude está redigindo a ata…", composing:"Ata sendo redigida",
    transcriptReady:"📝 Transcrição pronta",
    edit:"✏️ Editar", editDone:"✓ Pronto",
    exportPDF:"📄 PDF", exportWord:"📝 Word", copy:"⎘ Copiar", newSession:"+ Novo",
    generatedBy:"Claude IA",
    archiveTitle:"Arquivo", archiveSub:"Visão geral das suas atas salvas",
    view:"Ver", participants:"participantes",
    avgNote:"LGPD/GDPR: As atas são mantidas por no máximo 12 meses. As gravações de áudio são excluídas imediatamente após a transcrição.",
    plansTitle:"Planos", plansSub:"Escolha o plano que se adapta ao seu uso",
    selectPlan:"Selecionar plano", currentPlan:"✓ Plano atual",
    contactUs:"Entre em contato →", startFree:"Começar agora →",
    perMonth:"/mês", users:"usuários", sessionPerMonth:"sessões por mês",
    maxPerSession:"Máx.", perSession:"por sessão",
    plansNote:"Todos os planos são canceláveis mensalmente · Preços sem impostos · Pagamento via Stripe",
    accountTitle:"Conta & Identidade visual", accountSub:"Configure seu logo e cor para exportações PDF e Word",
    logo:"📎 Logo da empresa", clickToUpload:"Clique para enviar o logo", maxSize:"PNG, JPG ou SVG · Máx. 2 MB",
    logoLoaded:"Logo carregado", removeLogo:"✕ Remover",
    companyInfo:"🏢 Dados da empresa", name:"Nome", emailLabel:"E-mail",
    organization:"Organização", orgPlaceholder:"Nome da sua empresa",
    accentColor:"Cor de destaque para exportações",
    exportPreview:"👁️ Pré-visualização da exportação", previewHint:"💡 Altere a cor ou o logo — a pré-visualização é atualizada instantaneamente",
    saveSettings:"Salvar", saved:"✓ Salvo!",
    saveNote:"As configurações são aplicadas a todas as exportações PDF e Word.",
    privacy:"🔒 Privacidade & LGPD/GDPR", yourRights:"✅ Seus direitos (LGPD/GDPR)",
    rightInspect:"Direito de acesso — solicite um resumo dos seus dados armazenados",
    rightCorrect:"Direito de retificação — corrija dados pessoais incorretos",
    rightDelete:"Direito ao esquecimento — solicite a exclusão definitiva da sua conta",
    rightPortability:"Direito à portabilidade — receba seus dados em formato legível por máquina",
    audioDeleted:"As gravações de áudio são excluídas imediatamente após a transcrição (nunca mais de 24 horas)",
    deleteData:"🗑️ Excluir meus dados (LGPD/GDPR)", privacyContact:"✉️ Contato de privacidade",
    logoutBtn:"↩ Sair", logoutMobile:"↩ Sair da conta",
    logoutTitle:"Sair da conta?", logoutSub:"Você será desconectado. As atas não salvas serão perdidas.",
    logoutConfirm:"Sair", logoutCancel:"Cancelar",
    avgTitle:"📋 Política de privacidade & Consentimento LGPD/GDPR",
    avgSub:"Leia e aceite nossa política de privacidade para continuar",
    avgScrollHint:"↓ Role para baixo para ler todas as informações",
    avgRead:"✓ Política lida",
    avgDecline:"Recusar", avgAccept:"Aceitar & Registrar",
    deleteTitle:"🗑️ Excluir meus dados (LGPD/GDPR)",
    deleteStep1:"Você pode exercer seu direito ao esquecimento (Art. 18 LGPD / Art. 17 GDPR). Todos os dados vinculados à sua conta serão permanentemente excluídos.",
    deleteContinue:"Continuar", deleteCancel:"Cancelar",
    deleteConfirmTitle:"⚠️ Exclusão definitiva",
    deleteConfirmText:"Esta ação não pode ser desfeita. Sua conta será excluída em 30 dias conforme a LGPD/GDPR.",
    deleteConfirmBtn:"Sim, excluir tudo",
    deleteSuccessTitle:"✓ Solicitação recebida",
    deleteSuccessText:"Sua solicitação de exclusão foi enviada. Você receberá um e-mail de confirmação em 72 horas.",
    deleteClose:"Fechar",
    sessionsLeft:"sessões restantes",
    limitReachedTitle:"Limite de sessões atingido",
    limitReachedSub:"Seu plano permite",
    limitReachedSub2:"sessões por mês.",
    upgrade:"Fazer upgrade →",
    tooShort:"Gravação muito curta. Por favor, tente novamente.",
    genError:"Erro ao gerar:",
    micNeeded:"É necessário acesso ao microfone",
    micSub:"Toque no botão abaixo e permita o acesso ao microfone quando seu navegador solicitar.",
    micDenied:"Acesso ao microfone negado. Por favor, permita o acesso no seu navegador.",
    micNotFound:"Nenhum microfone encontrado.",
    micError:"Erro de microfone:",
    micGrant:"🎙️ Permitir microfone",
    iosHint:"📱 iOS: Ajustes → Safari → Microfone → Permitir",
    androidHint:"🤖 Android: Toque em 🔒 na barra de endereços → Microfone → Permitir",
  },
};

// ─── DATE & PROMPT HELPERS ──────────────────────────────────────────────────
const LOCALES = {nl:"nl-NL",en:"en-GB",de:"de-DE",fr:"fr-FR",es:"es-ES",pt:"pt-BR"};

function getToday(lang) {
  const locale = LOCALES[lang] || "nl-NL";
  return new Date().toLocaleDateString(locale,{weekday:"long",day:"numeric",month:"long",year:"numeric"});
}

// eslint-disable-next-line no-unused-vars
function getTodayShort(lang) {
  const locale = LOCALES[lang] || "nl-NL";
  return new Date().toLocaleDateString(locale,{day:"numeric",month:"long",year:"numeric"});
}

const PROMPTS = {
  nl:(title,today)=>"Je bent een professionele notulist. Maak van onderstaand gesprek nette notulen in het Nederlands.\n\nBELANGRIJKE REGELS:\n- Pas de lengte en diepgang aan op het gesprek. Bij een kort gesprek (sollicitatie, intake, 1-op-1): maak een KORTE notule met alleen de relevante secties.\n- Bij een lang/zakelijk overleg: gebruik de volledige structuur.\n- Laat secties WEG die niet van toepassing zijn (bv. geen actiepunten? laat dat blok weg).\n- Maak ALTIJD iets bruikbaars, ook bij korte gesprekken van 1-5 minuten. Zeg NOOIT dat er te weinig is gezegd.\n- Vul ontbrekende info met de beste interpretatie uit de context.\n\nGebruik deze structuur als richtlijn (laat weg wat niet past):\n\n## "+(title||"Gesprek")+"\n\n**Datum:** "+today+"\n**Type gesprek:** [bepaal zelf: sollicitatie/intake/overleg/etc]\n**Aanwezig:** [namen indien herkenbaar, anders 'Niet vermeld']\n\n---\n\n### Samenvatting\n[2-5 zinnen met de kern]\n\n### Belangrijkste punten\n- [punt 1]\n- [punt 2]\n\n### Actiepunten *(alleen bij vermelding)*\n| Actie | Wie | Wanneer |\n|-------|-----|---------|\n| [actie] | [naam] | [datum] |\n\n### Beslissingen *(alleen bij vermelding)*\n- [beslissing]\n\n---\n\n*Gegenereerd door Notulist AI*\n\nGESPREKSTEKST:",
  en:(title,today)=>"You are a professional minute-taker. Create clean meeting notes from the conversation below in English.\n\nIMPORTANT RULES:\n- Adapt length and depth to the conversation. Short conversation (interview, intake, 1-on-1): create a SHORT note with only relevant sections.\n- Long/formal meeting: use the full structure.\n- OMIT sections that don't apply (no action items? leave that block out).\n- ALWAYS produce something useful, even for short conversations of 1-5 minutes. NEVER say there is too little content.\n- Fill missing info with best interpretation from context.\n\nUse this as guideline (omit what doesn't fit):\n\n## "+(title||"Conversation")+"\n\n**Date:** "+today+"\n**Type:** [determine: interview/intake/meeting/etc]\n**Present:** [names if identifiable, else 'Not mentioned']\n\n---\n\n### Summary\n[2-5 sentences with the essence]\n\n### Key points\n- [point 1]\n- [point 2]\n\n### Action items *(only if mentioned)*\n| Action | Who | When |\n|--------|-----|------|\n| [action] | [name] | [date] |\n\n### Decisions *(only if mentioned)*\n- [decision]\n\n---\n\n*Generated by Notulist AI*\n\nCONVERSATION TEXT:",
  de:(title,today)=>"Sie sind ein professioneller Protokollführer. Erstellen Sie ein sauberes Protokoll auf Deutsch.\n\nWICHTIGE REGELN:\n- Passen Sie Länge und Tiefe an das Gespräch an. Kurzes Gespräch (Vorstellung, Intake, 1:1): KURZE Notiz mit nur relevanten Abschnitten.\n- Langes formelles Meeting: volle Struktur verwenden.\n- Lassen Sie Abschnitte WEG die nicht zutreffen.\n- Erstellen Sie IMMER etwas Nützliches, auch bei kurzen Gesprächen. Sagen Sie NIE dass zu wenig gesagt wurde.\n\nLeitlinie (lassen Sie weg was nicht passt):\n\n## "+(title||"Gespräch")+"\n\n**Datum:** "+today+"\n**Art:** [bestimmen Sie selbst]\n**Anwesend:** [Namen falls erkennbar]\n\n---\n\n### Zusammenfassung\n[2-5 Sätze]\n\n### Kernpunkte\n- [Punkt 1]\n\n### Maßnahmen *(nur falls erwähnt)*\n| Maßnahme | Wer | Wann |\n|----------|-----|------|\n| [Maßnahme] | [Name] | [Datum] |\n\n### Entscheidungen *(nur falls erwähnt)*\n- [Entscheidung]\n\n---\n\n*Erstellt von Notulist AI*\n\nGESPRÄCHSTEXT:",
  fr:(title,today)=>"Vous êtes un secrétaire de réunion professionnel. Rédigez un compte rendu propre en français.\n\nRÈGLES IMPORTANTES:\n- Adaptez la longueur à la conversation. Courte conversation: note COURTE avec seulement les sections pertinentes.\n- Réunion formelle longue: structure complète.\n- OMETTEZ les sections non applicables.\n- TOUJOURS produire quelque chose d'utile, même pour de courtes conversations. Ne JAMAIS dire qu'il y a trop peu de contenu.\n\nGuide (omettre ce qui ne convient pas):\n\n## "+(title||"Conversation")+"\n\n**Date:** "+today+"\n**Type:** [déterminer]\n**Présents:** [noms si identifiables]\n\n---\n\n### Résumé\n[2-5 phrases]\n\n### Points clés\n- [point 1]\n\n### Actions *(si mentionnées)*\n| Action | Qui | Quand |\n|--------|-----|-------|\n| [action] | [nom] | [date] |\n\n### Décisions *(si mentionnées)*\n- [décision]\n\n---\n\n*Généré par Notulist AI*\n\nTEXTE:",
  es:(title,today)=>"Eres un secretario profesional. Redacta notas limpias en español.\n\nREGLAS IMPORTANTES:\n- Adapta la longitud a la conversación. Conversación corta: nota CORTA con solo las secciones relevantes.\n- Reunión formal larga: estructura completa.\n- OMITE secciones que no aplican.\n- SIEMPRE produce algo útil, incluso para conversaciones cortas. NUNCA digas que hay muy poco contenido.\n\nGuía (omitir lo que no encaje):\n\n## "+(title||"Conversación")+"\n\n**Fecha:** "+today+"\n**Tipo:** [determinar]\n**Asistentes:** [nombres si identificables]\n\n---\n\n### Resumen\n[2-5 frases]\n\n### Puntos clave\n- [punto 1]\n\n### Acciones *(si se mencionan)*\n| Acción | Quién | Cuándo |\n|--------|-------|--------|\n| [acción] | [nombre] | [fecha] |\n\n### Decisiones *(si se mencionan)*\n- [decisión]\n\n---\n\n*Generado por Notulist AI*\n\nTEXTO:",
  pt:(title,today)=>"Você é um secretário profissional. Elabore notas limpas em português.\n\nREGRAS IMPORTANTES:\n- Adapte o comprimento à conversa. Conversa curta: nota CURTA com apenas seções relevantes.\n- Reunião formal longa: estrutura completa.\n- OMITA seções não aplicáveis.\n- SEMPRE produza algo útil, mesmo para conversas curtas. NUNCA diga que há pouco conteúdo.\n\nGuia (omitir o que não encaixa):\n\n## "+(title||"Conversa")+"\n\n**Data:** "+today+"\n**Tipo:** [determinar]\n**Presentes:** [nomes se identificáveis]\n\n---\n\n### Resumo\n[2-5 frases]\n\n### Pontos chave\n- [ponto 1]\n\n### Ações *(se mencionadas)*\n| Ação | Quem | Quando |\n|------|------|--------|\n| [ação] | [nome] | [data] |\n\n### Decisões *(se mencionadas)*\n- [decisão]\n\n---\n\n*Gerado por Notulist AI*\n\nTEXTO:",
};

function getPrompt(lang, title) {
  const today = getToday(lang);
  const fn = PROMPTS[lang] || PROMPTS["nl"];
  return fn(title, today);
}

// Hook to use translations
function useTranslation() {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("notulist_lang") || "nl"; } catch { return "nl"; }
  });
  const changeLang = (code) => {
    setLang(code);
    try { localStorage.setItem("notulist_lang", code); } catch {}
  };
  const t = (key) => T[lang]?.[key] ?? T["nl"]?.[key] ?? key;
  return { lang, changeLang, t, langs: LANGUAGES };
}

// Language Switcher Component
function LangSwitcher({ lang, changeLang, compact=false }) {
  const [open, setOpen] = useState(false);
  const cur = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];
  return (
    <div style={{position:"relative",display:"inline-block"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{
        display:"flex",alignItems:"center",gap:6,
        background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",
        borderRadius:8,padding:compact?"5px 9px":"7px 12px",
        color:"#EDF1F7",fontFamily:"inherit",fontSize:compact?11:12.5,fontWeight:600,
        cursor:"pointer",transition:"all .15s",
      }}>
        <span style={{fontSize:compact?14:16}}>{cur.flag}</span>
        {!compact && <span>{cur.label}</span>}
        <span style={{fontSize:10,opacity:.6}}>▼</span>
      </button>
      {open && (
        <div style={{
          position:"absolute",top:"calc(100% + 6px)",right:0,
          background:"#141E2E",border:"1px solid #243350",
          borderRadius:10,overflow:"hidden",
          boxShadow:"0 12px 36px rgba(0,0,0,.5)",
          zIndex:9999,minWidth:160,
        }}>
          {LANGUAGES.map(l => (
            <button key={l.code} onClick={()=>{changeLang(l.code);setOpen(false);}} style={{
              display:"flex",alignItems:"center",gap:9,width:"100%",
              padding:"9px 14px",background:l.code===lang?"rgba(201,168,76,.12)":"none",
              border:"none",color:l.code===lang?"#E0C06A":"#9BAFC8",
              fontFamily:"inherit",fontSize:13,fontWeight:l.code===lang?600:400,
              cursor:"pointer",transition:"background .12s",textAlign:"left",
            }}
            onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,.06)"}
            onMouseLeave={e=>e.currentTarget.style.background=l.code===lang?"rgba(201,168,76,.12)":"none"}
            >
              <span style={{fontSize:18}}>{l.flag}</span>
              {l.label}
              {l.code===lang && <span style={{marginLeft:"auto",fontSize:12}}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}


// ─── ANTHROPIC API KEY ────────────────────────────────────────────
// API key zit veilig in Vercel environment variable ANTHROPIC_KEY

// ─── SUPABASE ────────────────────────────────────────────────────────────────
const SUPABASE_URL  = "https://emskozbnwhsucqevpcal.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtc2tvemJud2hzdWNxZXZwY2FsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyNDUwOTEsImV4cCI6MjA5MjgyMTA5MX0.QhQqSnqf0r5B-5pJajlaXG5qktjk2o5xbzWReVBm_HY";
const sb = {
  async signUp(email, password, name) {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/signup`, { method:"POST", headers:{"Content-Type":"application/json",apikey:SUPABASE_ANON}, body:JSON.stringify({email,password,data:{name,avg_consent:true,avg_consent_date:new Date().toISOString()}}) });
    return r.json();
  },
  async signIn(email, password) {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, { method:"POST", headers:{"Content-Type":"application/json",apikey:SUPABASE_ANON}, body:JSON.stringify({email,password}) });
    return r.json();
  },
  async refreshSession(refreshToken) {
    // Vraag een nieuwe access_token op met de refresh_token
    try {
      const r = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, { 
        method:"POST", 
        headers:{"Content-Type":"application/json", apikey:SUPABASE_ANON}, 
        body:JSON.stringify({refresh_token: refreshToken}) 
      });
      if (!r.ok) return null;
      return await r.json(); // { access_token, refresh_token, user, ... }
    } catch {
      return null;
    }
  },
  async signOut(token) {
    await fetch(`${SUPABASE_URL}/auth/v1/logout`, { method:"POST", headers:{"Content-Type":"application/json",apikey:SUPABASE_ANON,Authorization:`Bearer ${token}`} });
  },
  async resend(email) {
    const r = await fetch(`${SUPABASE_URL}/auth/v1/resend`, { method:"POST", headers:{"Content-Type":"application/json",apikey:SUPABASE_ANON}, body:JSON.stringify({type:"signup",email}) });
    return r.json();
  },
  
  // ─── NOTES (database opslag van notulen) ───
  async fetchNotes(token) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/notes?select=*&order=created_at.desc`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return [];
      return await r.json();
    } catch { return []; }
  },
  
  async saveNote(token, userId, ownerEmail, note, onTokenRefresh = null) {
    const doSave = async (useToken) => {
      return fetch(`${SUPABASE_URL}/rest/v1/notes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON,
          Authorization: `Bearer ${useToken}`,
          Prefer: "return=representation"
        },
        body: JSON.stringify({
          user_id: userId,
          owner_email: ownerEmail,
          title: note.title,
          notes: note.notes,
          transcript: note.transcript || "",
          duration_seconds: note.durSeconds || 0,
          duration_display: note.dur || "00:00:00",
          plan: note.plan || "basis",
          branding: note.branding || null
        })
      });
    };
    try {
      let r = await doSave(token);
      
      // Token verlopen? Probeer auto-refresh en retry
      if (r.status === 401 && onTokenRefresh) {
        console.log("Token verlopen — proberen te vernieuwen...");
        const newSession = await onTokenRefresh();
        if (newSession?.access_token) {
          r = await doSave(newSession.access_token);
        }
      }
      
      if (!r.ok) {
        const err = await r.text();
        console.error("Save note failed:", r.status, err);
        // Return error info zodat caller een nuttig bericht kan tonen
        return { error: true, status: r.status, message: err };
      }
      const data = await r.json();
      return Array.isArray(data) ? data[0] : data;
    } catch (e) {
      console.error("Save note error:", e);
      return { error: true, status: 0, message: e.message || String(e) };
    }
  },
  
  async deleteNote(token, noteId) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/notes?id=eq.${noteId}`, {
        method: "DELETE",
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      return r.ok;
    } catch { return false; }
  },
  
  // ─── SUBSCRIPTIONS (Stripe) ───
  async fetchSubscription(token, userId) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/subscriptions?user_id=eq.${userId}&status=in.(active,trialing)&order=created_at.desc&limit=1`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return null;
      const data = await r.json();
      return data && data.length > 0 ? data[0] : null;
    } catch { return null; }
  },
  
  // ─── SESSION USAGE (permanente teller, gebaseerd op billing cycle) ───
  // Periode key wordt afgeleid van Stripe subscription billing cycle:
  // - Met actief abo: 'cycle_YYYY-MM-DD' (current_period_start datum)
  // - Zonder abo: 'free_YYYY-MM' (kalendermaand fallback)
  // Dit zorgt dat de teller reset op de aankoopdatum, niet op de 1e
  getPeriodKey(subscription) {
    if (subscription?.current_period_start) {
      // Gebruik subscription start datum als period anchor
      const startDate = new Date(subscription.current_period_start);
      const y = startDate.getFullYear();
      const m = String(startDate.getMonth()+1).padStart(2,'0');
      const d = String(startDate.getDate()).padStart(2,'0');
      return `cycle_${y}-${m}-${d}`;
    }
    // Fallback voor users zonder abo: kalendermaand
    const now = new Date();
    return `free_${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`;
  },
  
  async fetchUsage(token, userId, subscription) {
    try {
      const period = this.getPeriodKey(subscription);
      const r = await fetch(`${SUPABASE_URL}/rest/v1/session_usage?user_id=eq.${userId}&period=eq.${period}&select=sessions_count,total_seconds`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return { sessions_count: 0, total_seconds: 0, period };
      const data = await r.json();
      if (!data || data.length === 0) return { sessions_count: 0, total_seconds: 0, period };
      return { ...data[0], period };
    } catch { return { sessions_count: 0, total_seconds: 0 }; }
  },
  
  async incrementUsage(token, userId, email, durationSeconds, subscription) {
    try {
      const period = this.getPeriodKey(subscription);
      const current = await this.fetchUsage(token, userId, subscription);
      const newCount = (current.sessions_count || 0) + 1;
      const newSeconds = (current.total_seconds || 0) + (durationSeconds || 0);
      
      const r = await fetch(`${SUPABASE_URL}/rest/v1/session_usage?on_conflict=user_id,period`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON,
          Authorization: `Bearer ${token}`,
          "Prefer": "resolution=merge-duplicates,return=minimal"
        },
        body: JSON.stringify({
          user_id: userId,
          email: email,
          period: period,
          sessions_count: newCount,
          total_seconds: newSeconds
        })
      });
      return r.ok;
    } catch (e) {
      console.error("incrementUsage error:", e);
      return false;
    }
  },
  
  // ─── FREE TRIAL ───
  // Haal trial status op (seconds_used, expires_at, status)
  async fetchTrialStatus(token, userId) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/trial_status?user_id=eq.${userId}&select=*`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return null;
      const data = await r.json();
      if (!data || data.length === 0) return null;
      const t = data[0];
      const now = Date.now();
      const expiresMs = new Date(t.expires_at).getTime();
      const daysRemaining = Math.max(0, Math.ceil((expiresMs - now) / (1000 * 60 * 60 * 24)));
      const secondsRemaining = Math.max(0, (t.seconds_limit || 600) - (t.seconds_used || 0));
      const expired = now > expiresMs;
      const limitReached = (t.seconds_used || 0) >= (t.seconds_limit || 600);
      return {
        ...t,
        daysRemaining,
        secondsRemaining,
        minutesRemaining: Math.floor(secondsRemaining / 60),
        expired,
        limitReached,
        canRecord: !expired && !limitReached && !t.upgraded_at,
      };
    } catch (e) {
      console.error("fetchTrialStatus error:", e);
      return null;
    }
  },
  
  // Verhoog trial gebruikte seconden (na opslaan van notule)
  async incrementTrialUsage(token, userId, durationSeconds) {
    try {
      // Eerst huidige status ophalen
      const current = await this.fetchTrialStatus(token, userId);
      if (!current) return false;
      
      const newSeconds = Math.max(0, (current.seconds_used || 0) + (durationSeconds || 0));
      
      const r = await fetch(`${SUPABASE_URL}/rest/v1/trial_status?user_id=eq.${userId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON,
          Authorization: `Bearer ${token}`,
          "Prefer": "return=minimal"
        },
        body: JSON.stringify({ seconds_used: newSeconds })
      });
      return r.ok;
    } catch (e) {
      console.error("incrementTrialUsage error:", e);
      return false;
    }
  },
  
  // ─── ADD-ON CREDITS ───
  // Haal alle nog-bruikbare credits op (niet verlopen, credits_remaining > 0)
  async fetchAvailableCredits(token, userId) {
    try {
      const nowIso = new Date().toISOString();
      // PostgREST: credits_remaining > 0 AND (valid_until IS NULL OR valid_until > now)
      const r = await fetch(`${SUPABASE_URL}/rest/v1/session_credits?user_id=eq.${userId}&credits_remaining=gt.0&or=(valid_until.is.null,valid_until.gt.${encodeURIComponent(nowIso)})&order=purchased_at.asc`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return [];
      return await r.json();
    } catch { return []; }
  },
  
  // Verbruik 1 credit (decrement de oudste credit-row met remaining > 0)
  async consumeCredit(token, creditRowId) {
    try {
      // Eerst huidige waarde ophalen voor optimistic update
      const getR = await fetch(`${SUPABASE_URL}/rest/v1/session_credits?id=eq.${creditRowId}&select=credits_remaining`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!getR.ok) return false;
      const rows = await getR.json();
      if (!rows || rows.length === 0 || rows[0].credits_remaining < 1) return false;
      const newRemaining = rows[0].credits_remaining - 1;
      
      const updR = await fetch(`${SUPABASE_URL}/rest/v1/session_credits?id=eq.${creditRowId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON,
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ credits_remaining: newRemaining })
      });
      return updR.ok;
    } catch { return false; }
  },
  
  // ─── TEAM MEMBERS ───
  async fetchTeam(token, ownerEmail) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/team_members?owner_email=eq.${encodeURIComponent(ownerEmail)}&select=*`, {
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      if (!r.ok) return [];
      return await r.json();
    } catch { return []; }
  },
  
  async inviteMember(token, ownerEmail, memberEmail) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/team_members`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: SUPABASE_ANON,
          Authorization: `Bearer ${token}`,
          Prefer: "return=representation"
        },
        body: JSON.stringify({
          owner_email: ownerEmail,
          member_email: memberEmail,
          status: "pending"
        })
      });
      if (!r.ok) {
        const err = await r.text();
        return { error: err };
      }
      const data = await r.json();
      return { data: Array.isArray(data) ? data[0] : data };
    } catch (e) {
      return { error: e.message };
    }
  },
  
  async removeMember(token, memberId) {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/team_members?id=eq.${memberId}`, {
        method: "DELETE",
        headers: { apikey: SUPABASE_ANON, Authorization: `Bearer ${token}` }
      });
      return r.ok;
    } catch { return false; }
  },
};
const SK = "notulist_v2_session";
const saveS  = s => { try { localStorage.setItem(SK, JSON.stringify(s)); } catch {} };
const loadS  = ()  => { try { return JSON.parse(localStorage.getItem(SK)); } catch { return null; } };
const clearS = ()  => { try { localStorage.removeItem(SK); } catch {} };

// ─── NATIVE APP DETECTIE ─────────────────────────────────────────────────────
// Detecteert of de app draait in een Capacitor native container (iOS/Android).
// In de native apps tonen we GEEN checkout-links (App Store / Play Store policy)
// maar een neutrale melding dat abonnementen via het web-account lopen.
const IS_NATIVE_APP = typeof window !== "undefined" && !!(window.Capacitor?.isNativePlatform?.());
const NATIVE_SUBSCRIPTION_MSG = "Abonnementen kunnen worden gestart en beheerd via uw account op notulistai.com";

// ─── STRIPE HELPERS ──────────────────────────────────────────────────────────
// Start een Stripe Checkout flow voor een specifiek plan + interval
async function stripeCheckout({ plan, interval, userId, email }) {
  try {
    const returnUrl = window.location.origin + window.location.pathname;
    const r = await fetch("/api/stripe-checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan, interval, userId, email, returnUrl })
    });
    const data = await r.json();
    if (!r.ok || !data.url) {
      throw new Error(data.error || "Kon checkout niet starten");
    }
    // Redirect naar Stripe Checkout
    window.location.href = data.url;
  } catch (e) {
    console.error("Stripe checkout error:", e);
    alert("Er ging iets mis met de afrekening:\n" + (e.message || "Onbekende fout") + "\n\nProbeer opnieuw of neem contact op met support@notulistai.com");
  }
}

// Open Stripe Customer Portal (voor opzeggen, betaalmethode wijzigen, facturen)
async function stripePortal({ email }) {
  try {
    const returnUrl = window.location.origin + window.location.pathname;
    const r = await fetch("/api/stripe-portal", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, returnUrl })
    });
    const data = await r.json();
    if (!r.ok || !data.url) {
      if (r.status === 404) {
        throw new Error("Geen abonnement gevonden. Sluit eerst een abonnement af om het beheer te kunnen openen.");
      }
      throw new Error(data.error || "Kon portal niet openen");
    }
    window.location.href = data.url;
  } catch (e) {
    console.error("Stripe portal error:", e);
    alert(e.message || "Er ging iets mis bij het openen van het abonnementsbeheer.");
  }
}

// Koop extra sessies (add-on credits) - eenmalige betaling
async function stripeAddonCheckout({ plan, quantity, userId, email }) {
  try {
    const returnUrl = window.location.origin + window.location.pathname;
    const r = await fetch("/api/stripe-addon-checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan, quantity, userId, email, returnUrl })
    });
    const data = await r.json();
    if (!r.ok || !data.url) {
      if (r.status === 403) {
        throw new Error("Extra sessies zijn alleen beschikbaar voor klanten met een actief abonnement. Sluit eerst een abonnement af.");
      }
      throw new Error(data.error || "Kon aankoop niet starten");
    }
    window.location.href = data.url;
  } catch (e) {
    console.error("Stripe addon checkout error:", e);
    alert(e.message || "Er ging iets mis bij het afrekenen.");
  }
}


// ─── PLANS ───────────────────────────────────────────────────────────────────
// Note: Stripe Price IDs zitten in /api/stripe-checkout.js en /api/stripe-webhook.js
// Frontend stuurt alleen { plan, interval } naar checkout endpoint
const PLANS = [
  {
    id: "trial", name: "Gratis proefperiode", price: "€0", priceNum: 0, period: "/7 dagen",
    yearlyPrice: "€0", yearlyNum: 0, yearlyMonthly: "€0", yearlyMonthlyNum: 0,
    users: 1, sessionsPerMonth: 999, maxMinutes: 10, canPause: false, canResume: false,
    label: "7 dagen · max 10 min totaal",
    tagline: "Probeer Notulist AI gratis — kies daarna een pakket",
    features: [
      "7 dagen gratis toegang",
      "10 minuten totale opnametijd",
      "Volledige notulen-generatie",
      "PDF & Word export",
      "Geen creditcard nodig",
    ],
    accent: "#3DAB72",
    badge: null,
    isTrial: true,
  },
  {
    id: "basis", name: "Basis", price: "€5,95", priceNum: 5.95, period: "/maand",
    yearlyPrice: "€64,26", yearlyNum: 64.26, yearlyMonthly: "€5,36", yearlyMonthlyNum: 5.355,
    users: 1, sessionsPerMonth: 10, maxMinutes: 30, canPause: false, canResume: false,
    label: "30 min per sessie",
    tagline: "Ideaal voor intakes & sollicitatiegesprekken",
    features: [
      "1 gebruiker",
      "10 notule-sessies per maand",
      "Max. 30 minuten per sessie",
      "PDF & Word export met logo",
      "AI samenvatting & actiepunten",
      "E-mail support",
    ],
    accent: "#5B8DB8",
    badge: null,
  },
  {
    id: "pro", name: "Pro", price: "€21,95", priceNum: 21.95, period: "/maand",
    yearlyPrice: "€237,06", yearlyNum: 237.06, yearlyMonthly: "€19,76", yearlyMonthlyNum: 19.755,
    users: 3, sessionsPerMonth: 15, maxMinutes: 60, canPause: false, canResume: false,
    label: "60 min per sessie",
    tagline: "Voor teams en klantgesprekken",
    features: [
      "3 gebruikers",
      "15 notule-sessies per maand",
      "Max. 60 minuten per sessie",
      "Team uitnodigingen",
      "Gedeeld team-archief",
      "PDF & Word export met logo",
      "Prioriteit e-mail support",
    ],
    accent: "#C9A84C",
    badge: "Meest gekozen",
    popular: true,
  },
  {
    id: "enterprise", name: "Enterprise", price: "€39,95", priceNum: 39.95, period: "/maand",
    yearlyPrice: "€431,46", yearlyNum: 431.46, yearlyMonthly: "€35,96", yearlyMonthlyNum: 35.955,
    users: 5, sessionsPerMonth: 20, maxMinutes: 180, canPause: true, canResume: true,
    label: "3 uur per sessie",
    tagline: "Voor trainingen, workshops & seminars",
    features: [
      "5 gebruikers",
      "20 notule-sessies per maand",
      "Max. 3 uur per sessie",
      "⏸ Pauze knop tijdens elke meeting",
      "▶ Hervat of splits meetings vanuit archief",
      "Team uitnodigingen",
      "Gedeeld team-archief",
      "Telefonische support",
    ],
    accent: "#9B8FC4",
    badge: null,
  },
];

// ─── AUDIO ───────────────────────────────────────────────────────────────────
function getBestMime() {
  return ["audio/mp4","audio/webm;codecs=opus","audio/webm","audio/ogg;codecs=opus","audio/ogg"]
    .find(t => { try { return MediaRecorder.isTypeSupported(t); } catch { return false; } }) || "";
}
// eslint-disable-next-line no-unused-vars
async function blobToBase64(blob) {
  return new Promise((res,rej) => { const r=new FileReader(); r.onload=()=>res(r.result.split(",")[1]); r.onerror=rej; r.readAsDataURL(blob); });
}

function useMicrophone(t) {
  const recRef=useRef(null), chunksRef=useRef([]), stmRef=useRef(null), ctxRef=useRef(null), rafRef=useRef(null);
  const [vol,setVol]=useState(0), [micErr,setMicErr]=useState("");
  const start = useCallback(async () => {
    setMicErr(""); chunksRef.current=[];
    let stream;
    try { stream=await navigator.mediaDevices.getUserMedia({audio:{echoCancellation:true,noiseSuppression:true,sampleRate:44100,channelCount:1},video:false}); }
    catch(e) { setMicErr(e.name==="NotAllowedError"?t("micDenied"):e.name==="NotFoundError"?t("micNotFound"):`${t("micError")} ${e.message}`); return false; }
    stmRef.current=stream;
    try {
      const ctx=new (window.AudioContext||window.webkitAudioContext)(); ctxRef.current=ctx;
      const src=ctx.createMediaStreamSource(stream), anl=ctx.createAnalyser();
      anl.fftSize=512; anl.smoothingTimeConstant=0.65; src.connect(anl);
      const tick=()=>{const b=new Uint8Array(anl.frequencyBinCount);anl.getByteFrequencyData(b);setVol(Math.min(100,Math.round((b.slice(0,80).reduce((a,c)=>a+c,0)/80/60)*100)));rafRef.current=requestAnimationFrame(tick);};
      tick();
    } catch {}
    const mime=getBestMime();
    try { const rec=new MediaRecorder(stream,mime?{mimeType:mime}:{}); rec.ondataavailable=e=>{if(e.data?.size>0)chunksRef.current.push(e.data);}; rec.start(500); recRef.current=rec; }
    catch { const rec=new MediaRecorder(stream); rec.ondataavailable=e=>{if(e.data?.size>0)chunksRef.current.push(e.data);}; rec.start(500); recRef.current=rec; }
    return true;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[t]);
  const stop = useCallback(()=>new Promise(res=>{
    cancelAnimationFrame(rafRef.current); setVol(0); try{ctxRef.current?.close();}catch{}
    const rec=recRef.current;
    if(!rec||rec.state==="inactive"){stmRef.current?.getTracks().forEach(t=>t.stop());res(null);return;}
    rec.onstop=()=>{const blob=new Blob(chunksRef.current,{type:rec.mimeType||"audio/webm"});chunksRef.current=[];stmRef.current?.getTracks().forEach(t=>t.stop());res(blob);};
    if(rec.state!=="inactive") rec.stop(); else res(null);
  }),[]);
  return {start,stop,vol,micErr};
}

// ─── CLAUDE ───────────────────────────────────────────────────────────────────
// Whisper transcriptie met chunking voor grote bestanden
// Vercel heeft een harde limiet van ~4.5MB per request, dus we splitsen 
// audio in chunks van ~2 minuten en transcriberen parallel.
// We decoderen audio en maken echte aparte WAV bestanden per chunk
// (byte-splitsen van WebM/Opus werkt niet — chunks missen header).
// Sample rate 16kHz mono is optimaal voor Whisper (interne sample rate)
// en houdt WAV chunks onder Vercel's 4.5 MB limiet.
const MAX_CHUNK_DURATION_SEC = 2 * 60; // 2 minuten per chunk
const MAX_CHUNK_SIZE = 4 * 1024 * 1024; // 4 MB harde limiet voor Vercel
const WHISPER_SAMPLE_RATE = 16000; // 16 kHz — Whisper standaard, kleinere bestanden
const MAX_PARALLEL_CHUNKS = 3; // Max 3 chunks tegelijk

// Encode AudioBuffer naar WAV blob (16-bit PCM)
function audioBufferToWav(buffer, sampleRate) {
  const numChannels = 1; // mono is voldoende voor speech-to-text
  const length = buffer.length * numChannels * 2 + 44;
  const arrayBuffer = new ArrayBuffer(length);
  const view = new DataView(arrayBuffer);
  
  // WAV header
  const writeString = (offset, str) => {
    for (let i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
  };
  
  writeString(0, 'RIFF');
  view.setUint32(4, length - 8, true);
  writeString(8, 'WAVE');
  writeString(12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true); // PCM
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numChannels * 2, true);
  view.setUint16(32, numChannels * 2, true);
  view.setUint16(34, 16, true);
  writeString(36, 'data');
  view.setUint32(40, length - 44, true);
  
  // Audio data — converteer naar mono indien stereo
  const channelData = numChannels === 1 && buffer.numberOfChannels > 1
    ? mixChannelsToMono(buffer)
    : buffer.getChannelData(0);
  
  let offset = 44;
  for (let i = 0; i < channelData.length; i++) {
    const sample = Math.max(-1, Math.min(1, channelData[i]));
    view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
    offset += 2;
  }
  
  return new Blob([arrayBuffer], { type: 'audio/wav' });
}

function mixChannelsToMono(buffer) {
  const len = buffer.length;
  const result = new Float32Array(len);
  const numCh = buffer.numberOfChannels;
  for (let i = 0; i < len; i++) {
    let sum = 0;
    for (let ch = 0; ch < numCh; ch++) {
      sum += buffer.getChannelData(ch)[i];
    }
    result[i] = sum / numCh;
  }
  return result;
}

// Knip een tijdsegment uit een AudioBuffer
function sliceAudioBuffer(audioCtx, buffer, startSec, endSec) {
  const sampleRate = buffer.sampleRate;
  const startSample = Math.floor(startSec * sampleRate);
  const endSample = Math.min(buffer.length, Math.floor(endSec * sampleRate));
  const length = endSample - startSample;
  if (length <= 0) return null;
  
  const numChannels = Math.min(buffer.numberOfChannels, 1); // mono output
  const slice = audioCtx.createBuffer(numChannels, length, sampleRate);
  
  for (let ch = 0; ch < numChannels; ch++) {
    const sourceData = buffer.getChannelData(ch);
    const targetData = slice.getChannelData(ch);
    for (let i = 0; i < length; i++) {
      targetData[i] = sourceData[startSample + i];
    }
  }
  return slice;
}

async function transcribeChunk(chunkBlob, mimeType, language, chunkIndex) {
  try {
    let extension = 'webm';
    if (mimeType?.includes('wav')) extension = 'wav';
    else if (mimeType?.includes('mp4')) extension = 'mp4';
    else if (mimeType?.includes('ogg')) extension = 'ogg';
    else if (mimeType?.includes('mpeg')) extension = 'mp3';

    const formData = new FormData();
    formData.append('file', chunkBlob, `chunk_${chunkIndex}.${extension}`);
    formData.append('model', 'whisper-1');
    formData.append('response_format', 'text');
    
    const langMap = { nl: 'nl', en: 'en', de: 'de', fr: 'fr', es: 'es', pt: 'pt' };
    const whisperLang = langMap[language];
    if (whisperLang) formData.append('language', whisperLang);

    const response = await fetch('/api/whisper', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error(`Chunk ${chunkIndex} error:`, response.status, errorData);
      throw new Error(errorData.error || `Chunk ${chunkIndex}: ${response.status}`);
    }

    const data = await response.json();
    return { index: chunkIndex, transcript: data.transcript || '' };
  } catch (error) {
    console.error(`Chunk ${chunkIndex} failed:`, error);
    throw error;
  }
}

async function transcribeWithWhisper(blob, lang = "nl", onProgress = null) {
  try {
    const totalSize = blob.size;
    const mimeType = blob.type || 'audio/webm';

    // Korte audio (<4 MB) — geen chunking nodig, stuur origineel
    if (totalSize <= MAX_CHUNK_SIZE) {
      if (onProgress) onProgress({ current: 0, total: 1, message: "Transcriberen..." });
      const result = await transcribeChunk(blob, mimeType, lang, 0);
      if (onProgress) onProgress({ current: 1, total: 1, message: "Klaar" });
      return result.transcript;
    }

    // Grote audio — decoderen en splitsen in tijd-segmenten (echte audio chunks)
    if (onProgress) onProgress({ current: 0, total: 1, message: "Audio voorbereiden..." });
    
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) {
      throw new Error("Web Audio API niet beschikbaar in deze browser");
    }
    
    // OfflineAudioContext met 16kHz target — automatische downsampling
    // We decoderen eerst met normale context (geen sample rate forcing voor decode),
    // daarna resamplen we naar 16kHz mono voor Whisper.
    const decodeCtx = new AudioContextClass();
    let originalBuffer;
    try {
      const arrayBuffer = await blob.arrayBuffer();
      originalBuffer = await decodeCtx.decodeAudioData(arrayBuffer);
    } catch (decodeError) {
      decodeCtx.close();
      console.error("Audio decode error:", decodeError);
      throw new Error("Kon audio niet decoderen. Bestand mogelijk corrupt of niet ondersteund.");
    }
    decodeCtx.close();
    
    // Resample naar 16kHz mono via OfflineAudioContext
    const targetSampleRate = WHISPER_SAMPLE_RATE;
    const offlineCtx = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(
      1, // mono
      Math.ceil(originalBuffer.duration * targetSampleRate),
      targetSampleRate
    );
    const source = offlineCtx.createBufferSource();
    source.buffer = originalBuffer;
    source.connect(offlineCtx.destination);
    source.start(0);
    const audioBuffer = await offlineCtx.startRendering();
    
    const totalDuration = audioBuffer.duration;
    const numChunks = Math.ceil(totalDuration / MAX_CHUNK_DURATION_SEC);
    console.log(`Audio is ${totalDuration.toFixed(1)}s (orig: ${(totalSize/1024/1024).toFixed(2)} MB) — resampled naar ${targetSampleRate}Hz mono, splitsen in ${numChunks} chunks van ~${MAX_CHUNK_DURATION_SEC}s`);
    
    if (onProgress) {
      onProgress({
        current: 0,
        total: numChunks,
        message: `Audio gesplitst in ${numChunks} delen. Transcriberen...`
      });
    }
    
    // Maak chunks: elke chunk is een geldig WAV bestand met eigen header
    const chunks = [];
    // Dummy audio context voor sliceAudioBuffer (createBuffer methode)
    const sliceCtx = new AudioContextClass();
    for (let i = 0; i < numChunks; i++) {
      const startSec = i * MAX_CHUNK_DURATION_SEC;
      const endSec = Math.min(startSec + MAX_CHUNK_DURATION_SEC, totalDuration);
      const slicedBuffer = sliceAudioBuffer(sliceCtx, audioBuffer, startSec, endSec);
      if (!slicedBuffer) continue;
      const wavBlob = audioBufferToWav(slicedBuffer, audioBuffer.sampleRate);
      // Veiligheidscheck: log chunk grootte voor debugging
      console.log(`Chunk ${i}: ${(wavBlob.size/1024/1024).toFixed(2)} MB (${(endSec-startSec).toFixed(1)}s)`);
      chunks.push({ blob: wavBlob, index: i });
    }
    sliceCtx.close();

    // Transcribe in batches
    const results = new Array(numChunks);
    const completedRef = { count: 0 };
    
    const processChunk = async (chunk) => {
      const result = await transcribeChunk(chunk.blob, 'audio/wav', lang, chunk.index);
      completedRef.count++;
      if (onProgress) {
        onProgress({ 
          current: completedRef.count, 
          total: numChunks, 
          message: `Deel ${completedRef.count} van ${numChunks} klaar` 
        });
      }
      return result;
    };
    
    for (let batchStart = 0; batchStart < chunks.length; batchStart += MAX_PARALLEL_CHUNKS) {
      const batch = chunks.slice(batchStart, batchStart + MAX_PARALLEL_CHUNKS);
      const batchResults = await Promise.all(batch.map(processChunk));
      batchResults.forEach(r => {
        results[r.index] = r.transcript;
      });
    }

    // Concatenate in juiste volgorde
    const fullTranscript = results.join(' ').trim();
    return fullTranscript;

  } catch (error) {
    console.error("Transcription failed:", error);
    throw error;
  }
}

// Backwards compat alias
const transcribeWithClaude = transcribeWithWhisper;
async function generateNotulen(transcript, title, onChunk, lang="nl") {
  const prompt = getPrompt(lang, title) + "\n" + transcript;
  const res=await fetch("/api/claude",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({model:"claude-sonnet-4-5-20250929",max_tokens:1500,stream:true,messages:[{role:"user",content:prompt}]})});
  if(!res.ok) throw new Error(`Claude ${res.status}`);
  const reader=res.body.getReader(); const dec=new TextDecoder(); let full="";
  while(true){const {done,value}=await reader.read();if(done)break;for(const line of dec.decode(value).split("\n").filter(l=>l.startsWith("data: "))){try{const j=JSON.parse(line.slice(6));if(j.type==="content_block_delta"&&j.delta?.text){full+=j.delta.text;onChunk(full);}}catch{}}}
  return full;
}

// ─── MD → HTML ────────────────────────────────────────────────────────────────
function mdToHtml(t) {
  return t
    .replace(/^## (.+)$/gm,"<h2>$1</h2>").replace(/^### (.+)$/gm,"<h3>$1</h3>")
    .replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>").replace(/^---$/gm,"<hr>")
    .replace(/^\| (.+) \|$/gm,(_,c)=>{const cols=c.split(" | ");if(cols.every(x=>/^[-:]+$/.test(x.trim())))return"";return"<tr>"+cols.map(x=>`<td>${x}</td>`).join("")+"</tr>";})
    .replace(/(<tr>[\s\S]*?<\/tr>\n?)+/g,m=>`<table><tbody>${m}</tbody></table>`)
    .replace(/^- (.+)$/gm,"<li>$1</li>").replace(/(<li>[\s\S]*?<\/li>\n?)+/g,m=>`<ul>${m}</ul>`)
    .replace(/^(?!<[htuli]).+$/gm,m=>m.trim()?`<p>${m}</p>`:"");
}

// ─── PDF / WORD ────────────────────────────────────────────────────────────────
function buildDocHeader(ac, meetingTitle, duration, logoHtml, cName, uName, lang="nl") {
  const today=new Date().toLocaleDateString("nl-NL",{weekday:"long",day:"numeric",month:"long",year:"numeric"});
  return {today,
    hdr:`<div style="background:${ac};padding:22pt 32pt;display:flex;align-items:center;justify-content:space-between"><div><div style="font-size:8pt;font-weight:700;text-transform:uppercase;letter-spacing:1.5px;color:rgba(255,255,255,.55);margin-bottom:3pt">${(T[lang]||T["nl"]).notes}</div><div style="font-size:18pt;font-weight:700;color:white">${meetingTitle||"Vergadering"}</div><div style="font-size:9pt;color:rgba(255,255,255,.65);margin-top:2pt">${today} &nbsp;·&nbsp; Duur: ${duration}</div></div><div style="background:white;border-radius:6pt;padding:6pt 10pt;display:inline-flex;align-items:center">${logoHtml}</div></div>`,
    meta:`<div style="background:${ac}22;border-left:4pt solid ${ac};border-radius:3pt;padding:10pt 14pt;margin-bottom:20pt;display:grid;grid-template-columns:1fr 1fr;gap:5pt 20pt"><div><div style="font-size:8pt;font-weight:700;text-transform:uppercase;color:${ac};letter-spacing:.5pt">Organisatie</div><div style="font-size:10pt">${cName||"—"}</div></div><div><div style="font-size:8pt;font-weight:700;text-transform:uppercase;color:${ac};letter-spacing:.5pt">Opgesteld door</div><div style="font-size:10pt">${uName}</div></div><div><div style="font-size:8pt;font-weight:700;text-transform:uppercase;color:${ac};letter-spacing:.5pt">Datum</div><div style="font-size:10pt">${today}</div></div><div><div style="font-size:8pt;font-weight:700;text-transform:uppercase;color:${ac};letter-spacing:.5pt">Vergaderduur</div><div style="font-size:10pt">${duration}</div></div></div>`
  };
}

function exportToPDF(md, title, dur, branding) {
  const {logoDataUrl,accentColor,name:uName,company:cName}=branding;
  const ac=accentColor||"#2E3F5C";
  const logo=logoDataUrl?`<img src="${logoDataUrl}" style="height:50px;max-width:170px;object-fit:contain;"/>`:`<b style="font-size:16px;font-weight:700;color:${ac};">${cName||"Notulist AI"}</b>`;
  const {today,hdr,meta}=buildDocHeader(ac,title,dur,logo,cName,uName,branding.lang||'nl');
  const html=`<!DOCTYPE html><html lang="nl"><head><meta charset="UTF-8"/><title>${(title||"Notulen").replace(/[<>"]/g,'')}</title><style>
    @page { size: A4; margin: 16mm 18mm 22mm 18mm;
      @bottom-left { content: "${(cName||"Notulist AI").replace(/"/g,'')} · ${today}"; font-size: 8pt; color: #9CA3AF; font-family: Calibri, Arial, sans-serif; }
      @bottom-center { content: "Gegenereerd door Notulist AI · AVG-conform"; font-size: 8pt; color: #9CA3AF; font-family: Calibri, Arial, sans-serif; }
      @bottom-right { content: "Pagina " counter(page) " van " counter(pages); font-size: 8pt; color: #9CA3AF; font-family: Calibri, Arial, sans-serif; }
    }
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:Calibri,Arial,sans-serif;font-size:11pt;color:#1A1A1A;line-height:1.6}
    h2{font-size:13pt;font-weight:700;color:${ac};margin:22pt 0 7pt;padding-bottom:4pt;border-bottom:2pt solid ${ac}22}
    h3{font-size:10pt;font-weight:700;color:${ac};text-transform:uppercase;letter-spacing:.6pt;margin:16pt 0 5pt}
    p{margin-bottom:7pt;line-height:1.7}
    strong{font-weight:600;color:#111}
    hr{border:none;border-top:1pt solid #E5E7EB;margin:13pt 0}
    ul{padding-left:16pt;margin-bottom:8pt}
    li{margin-bottom:3pt;line-height:1.6}
    table{width:100%;border-collapse:collapse;margin:8pt 0 14pt;font-size:10pt;page-break-inside:avoid}
    th{background:${ac};color:white;font-size:9pt;font-weight:600;text-transform:uppercase;letter-spacing:.4pt;padding:7pt 10pt;text-align:left}
    td{padding:7pt 10pt;border-bottom:1pt solid #E5E7EB}
    tr:nth-child(even) td{background:${ac}11}
    .content{padding:0}
    @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}
  </style></head><body>${hdr}<div class="content">${meta}${mdToHtml(md)}</div><script>window.onload=()=>{setTimeout(()=>window.print(),300);};</script></body></html>`;
  
  // Gebruik Blob URL in plaats van window.open("","_blank") — voorkomt "about:blank" in footer
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if(!win){ URL.revokeObjectURL(url); alert("Sta pop-ups toe."); return; }
  // Cleanup na 60 seconden
  setTimeout(()=>URL.revokeObjectURL(url), 60000);
}

function exportToWord(md, title, dur, branding) {
  const {logoDataUrl,accentColor,name:uName,company:cName}=branding;
  const ac=accentColor||"#2E3F5C"; const acH=ac.replace("#","");
  const logo=logoDataUrl?`<img src="${logoDataUrl}" style="max-height:44px;max-width:140px;object-fit:contain;"/>`:`<b style="font-size:14pt;color:#${acH};">${cName||"Notulist AI"}</b>`;
  const {today,hdr,meta}=buildDocHeader(ac,title,dur,logo,cName,uName,branding.lang||'nl');
  const body=md
    .replace(/^## (.+)$/gm,(_,t)=>`<h2 style="color:#${acH};font-size:14pt;border-bottom:2pt solid #${acH};padding-bottom:3pt;margin-top:16pt;">${t}</h2>`)
    .replace(/^### (.+)$/gm,(_,t)=>`<h3 style="color:#${acH};font-size:10pt;text-transform:uppercase;margin-top:12pt;">${t}</h3>`)
    .replace(/\*\*(.+?)\*\*/g,"<b>$1</b>").replace(/^---$/gm,"<hr style=\"border:1pt solid #E5E7EB;margin:10pt 0;\"/>")
    .replace(/^\| (.+) \|$/gm,(_,c)=>{const cols=c.split(" | ");if(cols.every(x=>/^[-:]+$/.test(x.trim())))return"";return"<tr>"+cols.map(x=>`<td style="padding:5pt 9pt;border-bottom:1pt solid #E5E7EB;">${x}</td>`).join("")+"</tr>";})
    .replace(/(<tr>[\s\S]*?<\/tr>\n?)+/g,m=>`<table style="width:100%;border-collapse:collapse;margin:8pt 0 14pt;">${m}</table>`)
    .replace(/^- (.+)$/gm,"<li>$1</li>").replace(/(<li>[\s\S]*?<\/li>\n?)+/g,m=>`<ul style="margin:0 0 8pt 18pt;">${m}</ul>`)
    .replace(/^(?!<[htuli]).+$/gm,m=>m.trim()?`<p style="margin:0 0 6pt;line-height:1.65;">${m}</p>`:"");
  const html=`<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"/><meta name="ProgId" content="Word.Document"/><style>@page{size:A4;margin:2cm 2.5cm}body{font-family:Calibri,Arial,sans-serif;font-size:11pt;color:#1A1A1A}table{border-collapse:collapse;width:100%}th{background:#${acH};color:white;padding:5pt 9pt;font-size:9pt;text-align:left}.ftr{border-top:1pt solid #E5E7EB;margin-top:22pt;padding-top:6pt;font-size:8.5pt;color:#9CA3AF}</style></head><body>${hdr}<div style="padding:0">${meta}${body}</div><div class="ftr">${cName||"Notulist AI"} &nbsp;·&nbsp; ${today} &nbsp;·&nbsp; Gegenereerd door Notulist AI · AVG-conform</div></body></html>`;
  const blob=new Blob(["\ufeff",html],{type:"application/msword"});
  Object.assign(document.createElement("a"),{href:URL.createObjectURL(blob),download:`notulen-${(title||"vergadering").toLowerCase().replace(/\s+/g,"-")}.doc`}).click();
}

// ─── TIMER ────────────────────────────────────────────────────────────────────
function useTimer(on, resetKey = 0) {
  const [s,setS]=useState(0);
  // Reset timer naar 0 wanneer resetKey verandert (bv. bij logout/login)
  useEffect(() => { setS(0); }, [resetKey]);
  useEffect(()=>{if(!on)return;const id=setInterval(()=>setS(x=>x+1),1000);return()=>clearInterval(id);},[on]);
  const fmt=n=>[Math.floor(n/3600),Math.floor((n%3600)/60),n%60].map(v=>String(v).padStart(2,"0")).join(":");
  return {display:fmt(s),seconds:s};
}

// ─── WAVEFORM ─────────────────────────────────────────────────────────────────
function Waveform({vol}) {
  const [h,setH]=useState(()=>Array.from({length:32},()=>4+Math.random()*8));
  useEffect(()=>{setH(p=>p.map(v=>{const t=vol>4?5+(vol/100)*30+(Math.random()-.5)*Math.max(3,vol*.3):3+Math.random()*4;return +(v+(t-v)*.4).toFixed(1);}));},[vol]);
  return <div style={{display:"flex",alignItems:"center",gap:3,height:40,marginBottom:6}}>{h.map((hv,i)=><div key={i} style={{width:3,height:Math.max(3,hv),borderRadius:2,background:"linear-gradient(180deg,#C9A84C,rgba(201,168,76,.12))",opacity:Math.min(1,.3+vol/110),transition:"height .09s ease"}}/>)}</div>;
}
function VolBar({vol,t}) {
  const c=vol>72?"#E87070":vol>35?"#C9A84C":"#3DAB72";
  return <div style={{marginBottom:16}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:5,fontSize:11,color:"#7A8FA8"}}><span>🎙️ Microfoon</span><span style={{color:c}}>{vol>5?t("soundDetected"):t("waitingSound")}</span></div><div style={{height:4,background:"#1C2A3E",borderRadius:2,overflow:"hidden"}}><div style={{height:"100%",width:`${vol}%`,background:`linear-gradient(90deg,#3DAB72,${c})`,borderRadius:2,transition:"width .08s ease"}}/></div></div>;
}
function MicScreen({onRequest,err,t}) {
  return <div style={{textAlign:"center",padding:"24px 8px"}}>
    <div style={{fontSize:44,marginBottom:12}}>🎙️</div>
    <div style={{fontSize:16,fontWeight:600,marginBottom:6}}>Microfoon toegang nodig</div>
    <div style={{fontSize:13,color:"#7A8FA8",marginBottom:20,lineHeight:1.6}}>Tik op de knop hieronder en sta microfoon toe wanneer uw browser hierom vraagt.</div>
    {err&&<div style={{background:"rgba(217,82,82,.1)",border:"1px solid rgba(217,82,82,.25)",borderRadius:10,padding:"11px 13px",fontSize:12.5,color:"#FF9090",marginBottom:16,textAlign:"left",lineHeight:1.6}}>{err}<div style={{marginTop:7,color:"#9BAFC8",fontSize:11.5}}>📱 iOS: Instellingen → Safari → Microfoon → Toestaan<br/>🤖 Android: Tik 🔒 adresbalk → Microfoon → Toestaan</div></div>}
    <button onClick={onRequest} style={{background:"linear-gradient(135deg,#3DAB72,#5DC98A)",color:"#0C1220",border:"none",borderRadius:11,padding:"13px 28px",fontSize:14,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>🎙️ Sta microfoon toe</button>
  </div>;
}

// ─── EDITOR ────────────────────────────────────────────────────────────────────
function NotulenEditor({value,onChange}) {
  const taRef=useRef(null);
  const wrap=(b,a)=>{const el=taRef.current;if(!el)return;const s=el.selectionStart,e=el.selectionEnd;onChange(value.slice(0,s)+b+value.slice(s,e)+a+value.slice(e));setTimeout(()=>{el.focus();el.setSelectionRange(s+b.length,e+b.length);},0);};
  const prefix=(p)=>{const el=taRef.current;if(!el)return;const s=el.selectionStart,ls=value.lastIndexOf("\n",s-1)+1,le=value.indexOf("\n",s);const line=value.slice(ls,le===-1?undefined:le);onChange(value.slice(0,ls)+(line.startsWith(p)?line.slice(p.length):p+line)+(le===-1?"":value.slice(le)));setTimeout(()=>el.focus(),0);};
  const tools=[
    {icon:"B",title:"Vet",bold:true,fn:()=>wrap("**","**")},
    {icon:"I",title:"Cursief",italic:true,fn:()=>wrap("*","*")},
    {icon:"H2",title:"Kop 2",sm:true,fn:()=>prefix("## ")},
    {icon:"H3",title:"Kop 3",sm:true,fn:()=>prefix("### ")},
    {icon:"•",title:"Bullet",fn:()=>prefix("- ")},
    {sep:true},
    {icon:"—",title:"Scheidingslijn",fn:()=>onChange(value+"\n\n---\n\n")},
  ];
  return <div style={{display:"flex",flexDirection:"column"}}>
    <div style={{display:"flex",alignItems:"center",gap:3,padding:"7px 12px",borderBottom:"1px solid #243350",background:"#1C2A3E",flexWrap:"wrap"}}>
      <span style={{fontSize:10,fontWeight:700,color:"#7A8FA8",marginRight:5,textTransform:"uppercase",letterSpacing:.7}}>Opmaak</span>
      {tools.map((t,i)=>t.sep?<div key={i} style={{width:1,height:14,background:"#243350",margin:"0 3px"}}/>:<button key={i} title={t.title} onClick={t.fn} style={{background:"#243350",border:"1px solid transparent",borderRadius:4,color:"#9BAFC8",cursor:"pointer",padding:"3px 7px",fontSize:t.sm?10:12,fontFamily:"inherit",fontWeight:t.bold?700:"inherit",fontStyle:t.italic?"italic":"inherit"}}>{t.icon}</button>)}
    </div>
    <textarea ref={taRef} value={value} onChange={e=>onChange(e.target.value)} spellCheck style={{width:"100%",minHeight:340,background:"#141E2E",border:"none",outline:"none",resize:"vertical",padding:"18px 22px",fontSize:13,lineHeight:1.75,color:"#EDF1F7",fontFamily:"'DM Sans',sans-serif"}}/>
  </div>;
}

// ─── PASSWORD STRENGTH ────────────────────────────────────────────────────────
function pwScore(pw) {
  if(!pw) return 0;
  let s=0;
  if(pw.length>=8)s++;if(pw.length>=12)s++;
  if(/[A-Z]/.test(pw))s++;if(/[0-9]/.test(pw))s++;if(/[^A-Za-z0-9]/.test(pw))s++;
  return Math.min(3,Math.ceil(s/1.5));
}
function PwBar({pw}) {
  const s=pwScore(pw); const c=["","#E87070","#C9A84C","#3DAB72"][s]; const l=["","Zwak","Matig","Sterk"][s];
  if(!pw) return null;
  return <div style={{marginTop:5}}><div style={{display:"flex",gap:3}}>{[1,2,3].map(i=><div key={i} style={{flex:1,height:3,borderRadius:2,background:i<=s?c:"#243350",transition:"background .2s"}}/>)}</div><div style={{fontSize:10,color:"#7A8FA8",marginTop:3}}>{l}</div></div>;
}

// ─── AVG CONSENT MODAL ────────────────────────────────────────────────────────
function AVGModal({onAccept,onDecline,t}) {
  const [read,setRead]=useState(false);
  const bodyRef=useRef(null);
  const onScroll=()=>{ const el=bodyRef.current; if(el&&el.scrollTop+el.clientHeight>=el.scrollHeight-20) setRead(true); };
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.72)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#141E2E",border:"1px solid #243350",borderRadius:18,width:"100%",maxWidth:520,maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 28px 72px rgba(0,0,0,.6)"}}>
        <div style={{padding:"24px 28px 16px",borderBottom:"1px solid #1C2A3E"}}>
          <div style={{fontSize:18,fontWeight:600,marginBottom:4}}>📋 Privacyverklaring & AVG-toestemming</div>
          <div style={{fontSize:12.5,color:"#7A8FA8"}}>Lees en accepteer ons privacybeleid om door te gaan</div>
        </div>
        <div ref={bodyRef} onScroll={onScroll} style={{flex:1,overflowY:"auto",padding:"20px 28px",fontSize:13,lineHeight:1.75,color:"#C0D0E0"}}>
          <p><strong style={{color:"#EDF1F7"}}>Verwerkingsverantwoordelijke</strong><br/>Notulist AI is de verwerkingsverantwoordelijke voor uw persoonsgegevens in de zin van de Algemene Verordening Gegevensbescherming (AVG / GDPR).</p>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Welke gegevens verwerken wij?</strong></p>
          <ul style={{paddingLeft:18,marginBottom:10}}>
            <li>E-mailadres en naam (voor uw account)</li>
            <li>Audio-opnames van vergaderingen (tijdelijk, alleen voor transcriptie)</li>
            <li>Gegenereerde notulen en transcripties</li>
            <li>Gebruik- en sessiegegevens (voor abonnementsbeheer)</li>
          </ul>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Doel van de verwerking</strong></p>
          <ul style={{paddingLeft:18,marginBottom:10}}>
            <li>Het leveren van de notuleerservice</li>
            <li>AI-transcriptie en samenvatting van vergaderingen</li>
            <li>Accountbeheer en abonnementsverwerking</li>
            <li>Verbetering van de dienstverlening (geanonimiseerd)</li>
          </ul>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Bewaartermijnen</strong><br/>Audio-opnames worden <strong style={{color:"#EDF1F7"}}>direct na transcriptie verwijderd</strong> en nooit langer dan 24 uur bewaard. Notulen worden maximaal 12 maanden bewaard, tenzij u eerder om verwijdering verzoekt.</p>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Derden en doorgifte</strong><br/>Wij maken gebruik van Anthropic (Claude AI) voor transcriptie en samenvatting. Uw audio wordt versleuteld verzonden en niet opgeslagen door Anthropic. Wij geven uw gegevens niet door buiten de EER zonder adequate waarborgen.</p>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Uw rechten onder de AVG</strong></p>
          <ul style={{paddingLeft:18,marginBottom:10}}>
            <li>Recht op inzage van uw persoonsgegevens</li>
            <li>Recht op correctie van onjuiste gegevens</li>
            <li>Recht op verwijdering ("recht op vergetelheid")</li>
            <li>Recht op bezwaar tegen verwerking</li>
            <li>Recht op dataportabiliteit</li>
            <li>Recht om toestemming in te trekken</li>
          </ul>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Contact & klachten</strong><br/>Voor vragen of het uitoefenen van uw rechten: <span style={{color:"#E0C06A"}}>privacy@notulistai.com</span><br/>U heeft ook het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens (autoriteitpersoonsgegevens.nl).</p>
          <p style={{marginTop:14}}><strong style={{color:"#EDF1F7"}}>Beveiliging</strong><br/>Wij verwerken uw gegevens met passende technische en organisatorische beveiligingsmaatregelen, waaronder TLS-versleuteling en toegangscontrole.</p>
          <div style={{marginTop:20,padding:"12px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:8,fontSize:12,color:"#9BAFC8"}}>
            Door te registreren geeft u toestemming voor de verwerking van uw persoonsgegevens zoals hierboven beschreven. U kunt uw toestemming te allen tijde intrekken via uw accountinstellingen.
          </div>
        </div>
        <div style={{padding:"16px 28px",borderTop:"1px solid #1C2A3E",display:"flex",gap:10,alignItems:"center"}}>
          {!read&&<div style={{fontSize:12,color:"#7A8FA8",flex:1}}>↓ Scroll naar beneden om alle informatie te lezen</div>}
          {read&&<div style={{fontSize:12,color:"#3DAB72",flex:1}}>✓ Privacyverklaring gelezen</div>}
          <button onClick={onDecline} style={{background:"none",border:"1px solid #243350",color:"#7A8FA8",borderRadius:9,padding:"10px 16px",fontSize:13,fontFamily:"inherit",cursor:"pointer"}}>Weigeren</button>
          <button onClick={onAccept} disabled={!read} style={{background:read?"linear-gradient(135deg,#C9A84C,#E0C06A)":"#243350",color:read?"#0C1220":"#7A8FA8",border:"none",borderRadius:9,padding:"10px 20px",fontSize:13,fontWeight:700,fontFamily:"inherit",cursor:read?"pointer":"not-allowed",transition:"all .2s"}}>
            Accepteren & Registreren
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── AUTH SCREEN ──────────────────────────────────────────────────────────────
function AuthScreen({onLogin,t,lang,changeLang,langs}) {
  const [tab,setTab]=useState("login");
  const [email,setEmail]=useState(""), [pw,setPw]=useState(""), [name,setName]=useState("");
  const [loading,setLoad]=useState(false), [err,setErr]=useState(""), [ok,setOk]=useState("");
  const [verifyEmail,setVE]=useState(""), [cool,setCool]=useState(0);
  const [showAVG,setShowAVG]=useState(false);

  useEffect(()=>{if(cool<=0)return;const id=setTimeout(()=>setCool(c=>c-1),1000);return()=>clearTimeout(id);},[cool]);

  const doLogin=async()=>{
    if(!email||!pw){setErr(t("fillAll"));return;}
    setLoad(true);setErr("");
    const d=await sb.signIn(email,pw);setLoad(false);
    if(d.error||d.error_description||d.msg){const m=d.error_description||d.msg||d.error||"Inloggen mislukt.";setErr(m.includes("Email not confirmed")?t("confirmEmail"):m);return;}
    saveS({token:d.access_token,refresh:d.refresh_token,user:d.user});
    onLogin({
      token:d.access_token,
      refresh:d.refresh_token,
      sessionUser:d.user,
      email:d.user.email,
      name:d.user.user_metadata?.name||d.user.email.split("@")[0],
      plan: d.user.user_metadata?.plan || "trial",
      initials:(d.user.user_metadata?.name||"U")[0].toUpperCase(),
      company:"",logoDataUrl:"",accentColor:"#2E3F5C"
    });
  };

  const startRegister=()=>{
    if(!name.trim()){setErr(t("fillName"));return;}
    if(!email){setErr("Vul uw e-mailadres in.");return;}
    if(pwScore(pw)<2){setErr(t("weakPassword"));return;}
    setErr("");
    setShowAVG(true);
  };

  const doRegister=async()=>{
    setShowAVG(false);setLoad(true);setErr("");
    const d=await sb.signUp(email,pw,name.trim());setLoad(false);
    if(d.error||d.error_description){setErr(d.error_description||d.error||"Registratie mislukt.");return;}
    setVE(email);setTab("verify");setCool(60);
  };

  const doResend=async()=>{if(cool>0)return;await sb.resend(verifyEmail);setCool(60);setOk(t("resendOk"));setTimeout(()=>setOk(""),4000);};

  const inp={width:"100%",background:"#1C2A3E",border:"1px solid #243350",borderRadius:10,padding:"10px 12px",color:"#EDF1F7",fontSize:13.5,fontFamily:"inherit",outline:"none"};

  return (
    <div>
      {showAVG ? <AVGModal onAccept={doRegister} onDecline={()=>setShowAVG(false)} t={t}/> : null}
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:20,background:"radial-gradient(ellipse 65% 55% at 50% -5%,rgba(201,168,76,.07) 0%,transparent 60%),#0C1220",position:"relative"}}>
        <div style={{position:"absolute",top:16,right:16}}>
          <LangSwitcher lang={lang} changeLang={changeLang}/>
        </div>
        <div style={{width:"100%",maxWidth:400,background:"#141E2E",border:"1px solid #243350",borderRadius:18,padding:"38px 32px",position:"relative",overflow:"hidden",boxShadow:"0 28px 72px rgba(0,0,0,.55)"}}>
          <div style={{position:"absolute",top:0,left:"10%",right:"10%",height:1,background:"linear-gradient(90deg,transparent,#C9A84C,transparent)"}}/>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:26}}>
            <div style={{width:34,height:34,borderRadius:8,background:"linear-gradient(135deg,#2E3F5C,#1C2A3E)",border:"1px solid rgba(255,255,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>📋</div>
            <div style={{fontSize:19,fontWeight:600,letterSpacing:"-.4px",color:"#EDF1F7"}}>Notul<em style={{fontStyle:"normal",color:"#C9A84C"}}>ist</em></div>
          </div>

          {tab==="verify"?(
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:46,marginBottom:14}}>📬</div>
              <div style={{fontSize:19,fontWeight:600,marginBottom:7}}>Controleer uw inbox</div>
              <div style={{fontSize:13,color:"#7A8FA8",lineHeight:1.65,marginBottom:22}}>Een verificatielink is verstuurd naar<br/><strong style={{color:"#E0C06A"}}>{verifyEmail}</strong><br/><br/>Klik op de link om uw account te activeren. Controleer ook uw spammap.</div>
              {ok&&<div style={{background:"rgba(61,171,114,.1)",border:"1px solid rgba(61,171,114,.25)",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#5DC98A",marginBottom:14}}>{ok}</div>}
              <button onClick={()=>setTab("login")} style={{width:"100%",background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:10,padding:12,fontSize:14,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>Naar inloggen →</button>
              <button onClick={doResend} disabled={cool>0} style={{width:"100%",marginTop:8,background:"none",border:"1px solid #243350",color:"#9BAFC8",borderRadius:10,padding:11,fontSize:13,fontWeight:500,fontFamily:"inherit",cursor:cool>0?"not-allowed":"pointer"}}>
                {cool>0?`Opnieuw versturen (${cool}s)`:t("resend")}
              </button>
            </div>
          ):(
            <div>
              <div style={{fontSize:21,fontWeight:600,marginBottom:4}}>{tab==="login"?t("welcomeBack"):t("registerTitle")}</div>
              <div style={{color:"#7A8FA8",fontSize:12.5,marginBottom:18}}>{tab==="login"?t("loginSub"):t("registerSub")}</div>
              <div style={{display:"flex",background:"#1C2A3E",borderRadius:9,padding:3,marginBottom:18,gap:3}}>
                {["login","register"].map(tabKey=><button key={tabKey} onClick={()=>{setTab(tabKey);setErr("");}} style={{flex:1,border:"none",borderRadius:7,padding:8,fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer",transition:"all .18s",color:tab===tabKey?"#EDF1F7":"#7A8FA8",background:tab===tabKey?"#141E2E":"none",boxShadow:tab===tabKey?"0 1px 4px rgba(0,0,0,.3)":"none"}}>{tabKey==="login"?t("login"):t("register")}</button>)}
              </div>
              {err&&<div style={{background:"rgba(217,82,82,.1)",border:"1px solid rgba(217,82,82,.25)",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#FF9090",marginBottom:14,lineHeight:1.5}}>{err}</div>}
              {tab==="register"&&<div style={{marginBottom:11}}><label style={{display:"block",fontSize:10,fontWeight:700,color:"#9BAFC8",textTransform:"uppercase",letterSpacing:.8,marginBottom:5}}>Volledige naam</label><input style={inp} type="text" placeholder={t("namePlaceholder")} value={name} onChange={e=>setName(e.target.value)} autoComplete="name"/></div>}
              <div style={{marginBottom:11}}><label style={{display:"block",fontSize:10,fontWeight:700,color:"#9BAFC8",textTransform:"uppercase",letterSpacing:.8,marginBottom:5}}>E-mailadres</label><input style={inp} type="email" placeholder={t("emailPlaceholder")} value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&(tab==="login"?doLogin():startRegister())} autoComplete="email"/></div>
              <div style={{marginBottom:11}}><label style={{display:"block",fontSize:10,fontWeight:700,color:"#9BAFC8",textTransform:"uppercase",letterSpacing:.8,marginBottom:5}}>Wachtwoord</label><input style={inp} type="password" placeholder={tab==="register"?t("minChars"):"••••••••"} value={pw} onChange={e=>setPw(e.target.value)} onKeyDown={e=>e.key==="Enter"&&(tab==="login"?doLogin():startRegister())} autoComplete={tab==="login"?"current-password":"new-password"}/>{tab==="register"&&<PwBar pw={pw}/>}</div>
              <button disabled={loading} onClick={tab==="login"?doLogin:startRegister} style={{width:"100%",background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:10,padding:12,fontSize:14,fontWeight:700,fontFamily:"inherit",cursor:"pointer",marginTop:6,display:"flex",alignItems:"center",justifyContent:"center",gap:7,opacity:loading?.6:1}}>
                {loading&&<div style={{width:14,height:14,border:"2px solid rgba(0,0,0,.3)",borderTopColor:"#0C1220",borderRadius:"50%",animation:"spin .8s linear infinite"}}/>}
                {tab==="login"?t("loginBtn"):tab==="register"?"Verder →":""}
              </button>
              {tab==="register"&&<div style={{fontSize:11,color:"#7A8FA8",textAlign:"center",marginTop:10,lineHeight:1.5}}>Bij registratie dient u onze <span style={{color:"#E0C06A"}}>privacyverklaring</span> te accepteren (AVG-conform)</div>}
              <div style={{textAlign:"center",marginTop:12,fontSize:12,color:"#7A8FA8"}}>
                {tab==="login"?t("noAccount")+" ":t("alreadyAccount")+" "}
                <span onClick={()=>{setTab(tab==="login"?"register":"login");setErr("");}} style={{color:"#E0C06A",cursor:"pointer",fontWeight:500}}>{tab==="login"?t("registerFree"):t("login")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── LOGOUT MODAL ─────────────────────────────────────────────────────────────
function LogoutModal({token,onConfirm,onCancel,t}) {
  const [l,setL]=useState(false);
  const go=async()=>{setL(true);try{await sb.signOut(token);}catch{}clearS();onConfirm();};
  return <div onClick={onCancel} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#141E2E",border:"1px solid #243350",borderRadius:18,padding:"26px 26px 22px",maxWidth:340,width:"100%",textAlign:"center",boxShadow:"0 24px 60px rgba(0,0,0,.5)"}}>
      <div style={{fontSize:16,fontWeight:600,marginBottom:7}}>Uitloggen?</div>
      <div style={{fontSize:12.5,color:"#7A8FA8",lineHeight:1.6,marginBottom:20}}>U wordt uitgelogd. Niet-opgeslagen notulen gaan verloren.</div>
      <div style={{display:"flex",gap:9}}>
        <button onClick={onCancel} style={{flex:1,background:"#1C2A3E",border:"1px solid #243350",color:"#9BAFC8",borderRadius:9,padding:11,fontSize:13.5,fontWeight:500,fontFamily:"inherit",cursor:"pointer"}}>Annuleren</button>
        <button onClick={go} disabled={l} style={{flex:1,background:"linear-gradient(135deg,#D95252,#E87070)",color:"white",border:"none",borderRadius:9,padding:11,fontSize:13.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>{l?"…":"Uitloggen"}</button>
      </div>
    </div>
  </div>;
}

// ─── DATA DELETE MODAL ────────────────────────────────────────────────────────
function DataDeleteModal({onClose,t}) {
  const [step,setStep]=useState(1);
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.65)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#141E2E",border:"1px solid #243350",borderRadius:18,padding:"26px 28px",maxWidth:440,width:"100%",boxShadow:"0 24px 60px rgba(0,0,0,.5)"}}>
      {step===1&&<><div style={{fontSize:16,fontWeight:600,marginBottom:6}}>🗑️ Gegevens verwijderen (AVG)</div>
        <div style={{fontSize:13,color:"#7A8FA8",lineHeight:1.65,marginBottom:18}}>U kunt gebruik maken van uw recht op verwijdering (artikel 17 AVG). Alle gegevens gekoppeld aan uw account worden permanent verwijderd, inclusief notulen, transcripties en accountgegevens.</div>
        <div style={{display:"flex",gap:9}}>
          <button onClick={onClose} style={{flex:1,background:"#1C2A3E",border:"1px solid #243350",color:"#9BAFC8",borderRadius:9,padding:10,fontSize:13,fontWeight:500,fontFamily:"inherit",cursor:"pointer"}}>Annuleren</button>
          <button onClick={()=>setStep(2)} style={{flex:1,background:"rgba(217,82,82,.15)",border:"1px solid rgba(217,82,82,.3)",color:"#FF9090",borderRadius:9,padding:10,fontSize:13,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>Doorgaan</button>
        </div>
      </>}
      {step===2&&<><div style={{fontSize:16,fontWeight:600,marginBottom:6,color:"#FF9090"}}>⚠️ Definitief verwijderen</div>
        <div style={{fontSize:13,color:"#7A8FA8",lineHeight:1.65,marginBottom:18}}>Dit kan niet ongedaan worden gemaakt. Uw account en alle bijbehorende gegevens worden binnen 30 dagen definitief verwijderd conform de AVG. U ontvangt een bevestiging per e-mail.</div>
        <div style={{display:"flex",gap:9}}>
          <button onClick={onClose} style={{flex:1,background:"#1C2A3E",border:"1px solid #243350",color:"#9BAFC8",borderRadius:9,padding:10,fontSize:13,fontWeight:500,fontFamily:"inherit",cursor:"pointer"}}>Annuleren</button>
          <button onClick={()=>setStep(3)} style={{flex:1,background:"linear-gradient(135deg,#D95252,#E87070)",color:"white",border:"none",borderRadius:9,padding:10,fontSize:13,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>Ja, verwijder alles</button>
        </div>
      </>}
      {step===3&&<><div style={{fontSize:16,fontWeight:600,marginBottom:6,color:"#5DC98A"}}>✓ Verzoek ontvangen</div>
        <div style={{fontSize:13,color:"#7A8FA8",lineHeight:1.65,marginBottom:18}}>Uw verwijderverzoek is ingediend. U ontvangt binnen 72 uur een bevestiging per e-mail. De verwijdering is uiterlijk binnen 30 dagen voltooid conform artikel 17 AVG.</div>
        <button onClick={onClose} style={{width:"100%",background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:9,padding:11,fontSize:13.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>Sluiten</button>
      </>}
    </div>
  </div>;
}

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS=`
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{--n0:#0C1220;--n1:#141E2E;--n2:#1C2A3E;--n3:#243350;--n4:#2E3F5C;--g:#C9A84C;--gl:#E0C06A;--gd:rgba(201,168,76,.12);--s:#7A8FA8;--sl:#9BAFC8;--w:#EDF1F7;--green:#3DAB72;--red:#D95252;--r:10px;--rl:18px;}
body{font-family:'DM Sans',sans-serif;background:var(--n0);color:var(--w);min-height:100vh;-webkit-font-smoothing:antialiased}
::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:var(--n1)}::-webkit-scrollbar-thumb{background:var(--n3);border-radius:3px}
@keyframes blink{0%,100%{opacity:1}50%{opacity:.3}}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes fade{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:none}}
@keyframes pring{0%{box-shadow:0 0 0 0 rgba(217,82,82,.4)}70%{box-shadow:0 0 0 14px rgba(217,82,82,0)}100%{box-shadow:0 0 0 0 rgba(217,82,82,0)}}
.app{display:flex;min-height:100vh}
.sidebar{width:224px;flex-shrink:0;position:fixed;top:0;left:0;bottom:0;background:var(--n1);border-right:1px solid rgba(255,255,255,.05);display:flex;flex-direction:column;padding:18px 0;z-index:100}
.sb-logo{padding:0 14px 22px}
.sb-nav{padding:0 7px;flex:1;overflow-y:auto}
.sb-sec{font-size:9px;text-transform:uppercase;letter-spacing:1.3px;color:var(--s);padding:0 9px;margin:10px 0 3px}
.nb{display:flex;align-items:center;gap:8px;width:100%;padding:9px 10px;border-radius:8px;background:none;border:none;color:var(--sl);font-size:13px;font-family:inherit;cursor:pointer;transition:all .15s;margin-bottom:1px;text-align:left;-webkit-tap-highlight-color:transparent}
.nb:hover{background:var(--n2);color:var(--w)}.nb.on{background:var(--gd);color:var(--gl)}
.nb .ic{width:17px;text-align:center;font-size:14px;flex-shrink:0}
.ldot{margin-left:auto;width:7px;height:7px;border-radius:50%;background:var(--red);animation:blink 1.2s ease-in-out infinite}
.bok{margin-left:auto;background:rgba(61,171,114,.15);color:#5DC98A;border-radius:20px;padding:2px 7px;font-size:9.5px;font-weight:700}
.sb-bot{padding:10px 7px;border-top:1px solid rgba(255,255,255,.05)}
.u-row{display:flex;align-items:center;gap:8px;padding:9px 10px;border-radius:8px;background:var(--n2)}
.av{width:27px;height:27px;border-radius:50%;flex-shrink:0;background:linear-gradient(135deg,var(--n4),var(--g));display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:var(--w)}
.u-info{overflow:hidden;flex:1;cursor:pointer}
.u-name{font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.u-plan{font-size:10px;color:var(--g);text-transform:capitalize}
.lo-btn{background:rgba(217,82,82,.08);border:1px solid rgba(217,82,82,.18);color:#FF9090;border-radius:7px;padding:5px 8px;font-size:11px;font-weight:600;font-family:inherit;cursor:pointer;white-space:nowrap;flex-shrink:0;-webkit-tap-highlight-color:transparent}
.lo-btn:hover{background:rgba(217,82,82,.18)}
.bottom-nav{display:none;position:fixed;bottom:0;left:0;right:0;background:var(--n1);border-top:1px solid rgba(255,255,255,.07);padding:8px 0 calc(8px + env(safe-area-inset-bottom));z-index:100}
.bottom-nav-inner{display:flex;justify-content:space-around}
.bn-btn{display:flex;flex-direction:column;align-items:center;gap:3px;background:none;border:none;color:var(--sl);font-size:10px;font-family:inherit;cursor:pointer;padding:4px 8px;border-radius:8px;transition:color .15s;-webkit-tap-highlight-color:transparent;position:relative;min-width:55px}
.bn-btn.on{color:var(--gl)}.bn-btn .bn-ic{font-size:19px;line-height:1}
.bn-ldot{position:absolute;top:2px;right:8px;width:6px;height:6px;border-radius:50%;background:var(--red);animation:blink 1.2s ease-in-out infinite}
.mobile-topbar{display:none;position:fixed;top:0;left:0;right:0;background:var(--n1);border-bottom:1px solid rgba(255,255,255,.06);padding:12px 16px;padding-top:calc(12px + env(safe-area-inset-top));align-items:center;justify-content:space-between;z-index:100}
.main{margin-left:224px;flex:1;padding:30px 36px;max-width:860px}
.page-hd{margin-bottom:20px}
.page-title{font-size:23px;font-weight:600;letter-spacing:-.5px}
.page-sub{color:var(--s);font-size:13px;margin-top:3px}
.mc{background:var(--n1);border:1px solid var(--n2);border-radius:var(--rl);padding:26px;position:relative;overflow:hidden;margin-bottom:18px;animation:fade .3s ease}
.mc::before{content:'';position:absolute;top:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.3),transparent)}
.rec-pill{display:inline-flex;align-items:center;gap:7px;background:rgba(217,82,82,.1);border:1px solid rgba(217,82,82,.2);border-radius:20px;padding:5px 12px;font-size:10.5px;font-weight:700;color:#FF9090;text-transform:uppercase;letter-spacing:.5px;margin-bottom:14px}
.rec-dot{width:6px;height:6px;border-radius:50%;background:var(--red);animation:blink 1.2s ease-in-out infinite}
.tmr{font-size:50px;font-weight:300;letter-spacing:-2px;font-variant-numeric:tabular-nums;background:linear-gradient(150deg,var(--w) 50%,var(--sl));-webkit-background-clip:text;-webkit-text-fill-color:transparent;line-height:1;margin-bottom:4px}
.tmr-sub{color:var(--s);font-size:13px;margin-bottom:20px}
.name-inp{width:100%;background:var(--n2);border:1px solid var(--n3);border-radius:var(--r);padding:10px 12px;color:var(--w);font-size:13px;font-family:inherit;outline:none;margin-bottom:18px;transition:border-color .2s;-webkit-appearance:none}
.name-inp:focus{border-color:rgba(201,168,76,.4)}.name-inp::placeholder{color:var(--s)}
.btn-row{display:flex;gap:9px}
.btn-start{flex:1;background:linear-gradient(135deg,var(--green),#5DC98A);color:var(--n0);border:none;border-radius:var(--r);padding:14px;font-size:14.5px;font-weight:700;font-family:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;-webkit-tap-highlight-color:transparent;box-shadow:0 0 20px rgba(61,171,114,.2);transition:all .2s}
.btn-start:active{opacity:.82;transform:scale(.98)}
.btn-stop{flex:1;background:linear-gradient(135deg,var(--red),#E87070);color:#fff;border:none;border-radius:var(--r);padding:14px;font-size:14.5px;font-weight:700;font-family:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;-webkit-tap-highlight-color:transparent;animation:pring 2s ease infinite}
.btn-stop:active{opacity:.82;transform:scale(.98)}
.btn-cancel{background:var(--n2);border:1px solid var(--n3);color:var(--sl);border-radius:var(--r);padding:14px 14px;font-size:13px;font-weight:500;font-family:inherit;cursor:pointer;-webkit-tap-highlight-color:transparent}
.steps{display:flex;align-items:center;margin-bottom:18px}
.step{display:flex;align-items:center;gap:5px;font-size:12px;color:var(--s)}.step.on{color:var(--gl)}.step.dn{color:var(--green)}
.sdot{width:20px;height:20px;border-radius:50%;background:var(--n3);border:1px solid var(--n4);display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;flex-shrink:0}
.step.on .sdot{background:var(--gd);border-color:var(--g);color:var(--g)}.step.dn .sdot{background:rgba(61,171,114,.15);border-color:rgba(61,171,114,.4);color:var(--green)}
.sline{width:22px;height:1px;background:var(--n3);margin:0 2px}
.gen-wrap{padding:30px 0;display:flex;flex-direction:column;align-items:center;gap:11px}
.gen-ring{width:40px;height:40px;border-radius:50%;border:2px solid var(--n3);border-top-color:var(--g);animation:spin .9s linear infinite}
.stream-box{background:var(--n2);border:1px solid var(--n3);border-radius:var(--r);padding:11px 13px;font-size:11px;color:var(--sl);font-family:'Courier New',monospace;max-height:90px;overflow-y:auto;line-height:1.6;width:100%;white-space:pre-wrap;margin-top:6px}
.cursor{display:inline-block;width:7px;height:11px;background:var(--g);margin-left:2px;animation:blink .8s step-end infinite;vertical-align:text-bottom}
.trans-lbl{font-size:9.5px;text-transform:uppercase;letter-spacing:.7px;color:var(--s);margin-bottom:5px;font-weight:600}
.trans-box{background:var(--n2);border:1px solid var(--n3);border-radius:var(--r);padding:10px 12px;font-size:11.5px;color:var(--sl);line-height:1.6;max-height:70px;overflow-y:auto;margin-bottom:11px;width:100%}
.limit-bar-wrap{margin-bottom:14px}
.limit-bar-inner{height:4px;background:var(--n3);border-radius:2px;overflow:hidden;margin-top:5px}
.nc{background:var(--n1);border:1px solid var(--n2);border-radius:var(--rl);overflow:hidden;animation:fade .4s ease}
.nhd{padding:14px 22px;border-bottom:1px solid var(--n2);background:var(--n2);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:9px}
.ntitle{font-size:13.5px;font-weight:600}.nmeta{font-size:11px;color:var(--s);margin-top:2px}
.nacts{display:flex;gap:5px;flex-wrap:wrap}
.ab{background:var(--n3);border:1px solid rgba(255,255,255,.07);color:var(--sl);border-radius:7px;padding:6px 10px;font-size:11.5px;font-weight:500;font-family:inherit;cursor:pointer;transition:all .15s;-webkit-tap-highlight-color:transparent}
.ab:hover,.ab:active{color:var(--w);border-color:rgba(201,168,76,.4)}
.ab.edit-on{background:var(--gd);border-color:rgba(201,168,76,.35);color:var(--gl);font-weight:600}
.ab.pdf{background:linear-gradient(135deg,#1B5E8A,#2573A7);color:white;border-color:transparent;font-weight:600}
.ab.word{background:linear-gradient(135deg,#1A5276,#2E86C1);color:white;border-color:transparent;font-weight:600}
.ed-tabs{display:flex;border-bottom:1px solid var(--n3);background:var(--n2)}
.ed-tab{flex:1;border:none;background:none;padding:10px 16px;font-size:12px;font-weight:500;font-family:inherit;cursor:pointer;color:var(--s);transition:all .15s;-webkit-tap-highlight-color:transparent}
.ed-tab.on{color:var(--w);border-bottom:2px solid var(--g);margin-bottom:-1px;background:var(--n1)}
.nb2{padding:22px 26px;max-height:460px;overflow-y:auto;font-size:13px;line-height:1.8;color:#C0D0E0}
.nb2 h2{font-size:15px;color:var(--w);font-weight:600;margin:18px 0 6px}.nb2 h3{font-size:12px;color:var(--gl);font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin:14px 0 5px}
.nb2 p{margin-bottom:8px}.nb2 ul{padding-left:16px;margin-bottom:8px}.nb2 li{margin-bottom:3px}.nb2 strong{color:var(--w)}
.nb2 hr{border:none;border-top:1px solid var(--n3);margin:12px 0}
.nb2 table{width:100%;border-collapse:collapse;margin:7px 0}.nb2 th{text-align:left;font-size:10px;text-transform:uppercase;color:var(--s);border-bottom:1px solid var(--n3);padding:5px 0}
.nb2 td{padding:6px 0;border-bottom:1px solid rgba(255,255,255,.04);font-size:12px}
.hl{display:flex;flex-direction:column;gap:8px}
.hi{background:var(--n1);border:1px solid var(--n2);border-radius:var(--r);padding:13px 17px;display:flex;align-items:center;justify-content:space-between;gap:12px;cursor:pointer;transition:border-color .15s}
.hi:hover{border-color:var(--n4)}.hn{font-size:13px;font-weight:500}.hm{font-size:11px;color:var(--s);margin-top:2px}
.dc{background:var(--n2);border-radius:6px;padding:3px 8px;font-size:11px;color:var(--sl);flex-shrink:0}
.plans-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
.pc{background:var(--n1);border:1px solid var(--n2);border-radius:var(--rl);padding:22px 18px;position:relative;transition:border-color .2s}
.pc:hover{border-color:var(--n4)}.pc.pop{border-color:var(--g)}
.pb{position:absolute;top:-9px;left:50%;transform:translateX(-50%);background:linear-gradient(135deg,var(--g),var(--gl));color:var(--n0);font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.7px;padding:3px 10px;border-radius:20px;white-space:nowrap}
.pn{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:var(--sl);margin-bottom:2px}
.plm{font-size:11px;color:var(--s);margin-bottom:12px}
.pp{font-size:28px;font-weight:700;letter-spacing:-1px;margin-bottom:2px}
.pp span{font-size:12px;font-weight:400;color:var(--s)}
.ptag{font-size:11.5px;color:var(--s);margin-bottom:12px;font-style:italic;line-height:1.45}
.pf{list-style:none;margin-bottom:16px}
.pf li{font-size:12px;color:var(--sl);padding:3px 0;display:flex;align-items:flex-start;gap:6px}
.pf li::before{content:'✓';color:var(--g);font-weight:700;flex-shrink:0;margin-top:1px}
.plan-btn{width:100%;background:var(--n2);border:1px solid var(--n3);color:var(--w);border-radius:var(--r);padding:10px;font-size:13px;font-weight:600;font-family:inherit;cursor:pointer;transition:all .2s}
.plan-btn:hover{border-color:var(--g)}.pc.pop .plan-btn{background:linear-gradient(135deg,var(--g),var(--gl));border-color:transparent;color:var(--n0)}
.ag{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.ac{background:var(--n1);border:1px solid var(--n2);border-radius:var(--rl);padding:22px;animation:fade .3s ease}
.ac.full{grid-column:1/-1}
.asec{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:var(--s);margin-bottom:14px}
.af{margin-bottom:13px}
.al{font-size:10px;font-weight:700;color:var(--sl);text-transform:uppercase;letter-spacing:.6px;margin-bottom:5px}
.ai{width:100%;background:var(--n2);border:1px solid var(--n3);border-radius:var(--r);padding:9px 11px;color:var(--w);font-size:13px;font-family:inherit;outline:none;transition:border-color .2s;-webkit-appearance:none}
.ai:focus{border-color:rgba(201,168,76,.4)}.ai::placeholder{color:var(--s)}
.luz{border:2px dashed var(--n3);border-radius:var(--r);padding:20px;text-align:center;cursor:pointer;transition:border-color .2s,background .2s;position:relative;overflow:hidden}
.luz:hover{border-color:var(--g);background:var(--gd)}
.luz input[type=file]{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}
.cr{display:flex;align-items:center;gap:9px}
.cs{width:34px;height:34px;border-radius:7px;border:2px solid rgba(255,255,255,.1);cursor:pointer;flex-shrink:0;overflow:hidden;position:relative}
.cs input[type=color]{position:absolute;inset:-4px;width:calc(100%+8px);height:calc(100%+8px);opacity:0;cursor:pointer}
.cv{font-size:12.5px;color:var(--sl);font-family:'Courier New',monospace}
.bsave{background:linear-gradient(135deg,var(--g),var(--gl));color:var(--n0);border:none;border-radius:var(--r);padding:10px 18px;font-size:13px;font-weight:700;font-family:inherit;cursor:pointer}
.bsave:hover{opacity:.9}.svok{font-size:12px;color:var(--green);margin-left:10px;animation:fade .3s ease}
.lang-sw{position:relative;display:inline-block}
.lang-btn{display:flex;align-items:center;gap:5px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);border-radius:7px;padding:5px 9px;color:var(--w);font-family:inherit;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s;white-space:nowrap}
.lang-btn:hover{background:rgba(255,255,255,.1)}
.lang-dd{position:absolute;bottom:calc(100% + 6px);left:0;background:var(--n1);border:1px solid var(--n3);border-radius:10px;overflow:hidden;box-shadow:0 12px 36px rgba(0,0,0,.5);z-index:9999;min-width:160px}
.lang-opt{display:flex;align-items:center;gap:8px;width:100%;padding:9px 13px;background:none;border:none;color:var(--sl);font-family:inherit;font-size:13px;font-weight:400;cursor:pointer;text-align:left;transition:background .12s}
.lang-opt:hover{background:rgba(255,255,255,.06)}
.lang-opt.on{background:var(--gd);color:var(--gl);font-weight:600}
.avg-section{background:rgba(61,171,114,.06);border:1px solid rgba(61,171,114,.18);border-radius:var(--r);padding:16px;margin-top:14px}
.avg-title{font-size:12px;font-weight:700;color:#5DC98A;margin-bottom:8px;display:flex;align-items:center;gap:6px}
.avg-item{font-size:12px;color:var(--sl);margin-bottom:6px;display:flex;align-items:flex-start;gap:7px;line-height:1.5}
.avg-item::before{content:'→';color:var(--green);flex-shrink:0}
@media(max-width:768px){
  .sidebar{display:none}.mobile-topbar{display:flex}.bottom-nav{display:block}
  .main{margin-left:0;padding:14px;padding-top:calc(78px + env(safe-area-inset-top));padding-bottom:calc(74px + env(safe-area-inset-bottom));max-width:100%}
  .page-hd{margin-top:8px;margin-bottom:20px}
  .page-title{font-size:20px}.tmr{font-size:42px}.plans-grid{grid-template-columns:1fr;gap:18px}
  .ag{grid-template-columns:1fr}.ac.full{grid-column:1}.nb2{padding:14px}.nhd{padding:12px 14px}.mc{padding:18px 14px}
  .nacts{gap:4px}.ab{padding:5px 8px;font-size:11px}
  /* Archive items: stapel acties onder de titel ipv naast (anders overlapt op smal scherm) */
  .hi{flex-direction:column;align-items:stretch;gap:10px;padding:14px}
  .hi > div:first-child{width:100%}
  .hi > div:last-child{justify-content:flex-start;width:100%;padding-top:8px;border-top:1px solid rgba(255,255,255,.05)}
}
@media(min-width:769px) and (max-width:1024px){.plans-grid{grid-template-columns:repeat(2,1fr)}.sidebar{width:200px}.main{margin-left:200px;padding:26px}}
`;

// ─── APP ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [user,setUser]=useState(null), [session,setSess]=useState(null);
  
  // Token refresh helper — vernieuwt access_token via refresh_token wanneer 401 ontstaat
  const refreshAccessToken = useCallback(async () => {
    if (!session?.refresh) return null;
    try {
      const newData = await sb.refreshSession(session.refresh);
      if (newData?.access_token) {
        const newSession = {
          token: newData.access_token,
          refresh: newData.refresh_token || session.refresh,
          user: newData.user || session.user
        };
        setSess(newSession);
        saveS(newSession);
        return newData;
      }
      return null;
    } catch (e) {
      console.error("Refresh failed:", e);
      return null;
    }
  }, [session]);
  
  // Proactieve token refresh — elke 50 minuten (Supabase JWT duurt 60 min)
  useEffect(() => {
    if (!session?.refresh) return;
    const interval = setInterval(() => {
      refreshAccessToken();
    }, 50 * 60 * 1000); // 50 min
    return () => clearInterval(interval);
  }, [session?.refresh, refreshAccessToken]);
  const [page,setPage]=useState("meeting"), [showLogout,setShowLogout]=useState(false), [showDelete,setShowDelete]=useState(false), [showCancelSub,setShowCancelSub]=useState(false);
  const [showAddonModal, setShowAddonModal] = useState(false); // modal voor extra sessies kopen
  const [billingCycle, setBillingCycle] = useState("monthly"); // "monthly" of "yearly"
  
  // Team members (Pro & Enterprise) — uit Supabase database
  const [teamMembers, setTeamMembers] = useState([]);
  useEffect(()=>{
    if(!user?.email || !session?.token) { setTeamMembers([]); return; }
    let cancelled = false;
    (async ()=>{
      const team = await sb.fetchTeam(session.token, user.email);
      if(!cancelled) setTeamMembers(team);
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.email, session?.token]);

  // Subscription (Stripe) — uit Supabase subscriptions tabel
  // Update user.plan automatisch zodra subscription wijzigt
  // Bewaar ook full subscription object voor billing cycle berekeningen
  const [currentSubscription, setCurrentSubscription] = useState(null);
  useEffect(()=>{
    if(!user?.email || !session?.token || !session?.user?.id) {
      setCurrentSubscription(null);
      return;
    }
    let cancelled = false;
    (async ()=>{
      const sub = await sb.fetchSubscription(session.token, session.user.id);
      if(cancelled) return;
      setCurrentSubscription(sub);
      const newPlan = sub?.plan && ['active','trialing'].includes(sub.status) ? sub.plan : 'trial';
      if(user.plan !== newPlan) {
        setUser(u => u ? {...u, plan: newPlan} : u);
      }
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.email, session?.token, session?.user?.id]);

  // ─── TRIAL STATUS ───
  // Voor trial users: track resterende seconden + dagen
  const [trialStatus, setTrialStatus] = useState(null);
  const [refreshTrialKey, setRefreshTrialKey] = useState(0);
  useEffect(() => {
    if(!user?.email || !session?.token || !session?.user?.id) {
      setTrialStatus(null);
      return;
    }
    // Alleen trial gebruikers hebben trial status nodig
    if(user.plan !== 'trial') {
      setTrialStatus(null);
      return;
    }
    let cancelled = false;
    (async () => {
      const ts = await sb.fetchTrialStatus(session.token, session.user.id);
      if(!cancelled) setTrialStatus(ts);
    })();
    return () => { cancelled = true; };
  }, [user?.email, user?.plan, session?.token, session?.user?.id, refreshTrialKey]);

  // Add-on credits — beschikbare extra sessies (one-time purchases)
  const [availableCredits, setAvailableCredits] = useState([]); // rows met credits_remaining > 0
  const [refreshCreditsKey, setRefreshCreditsKey] = useState(0); // verhoog om opnieuw op te halen
  useEffect(()=>{
    if(!session?.token || !session?.user?.id) { setAvailableCredits([]); return; }
    let cancelled = false;
    (async ()=>{
      const credits = await sb.fetchAvailableCredits(session.token, session.user.id);
      if(!cancelled) setAvailableCredits(credits);
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[session?.token, session?.user?.id, refreshCreditsKey]);
  
  // Totaal aantal beschikbare extra credits voor het huidige plan
  const totalAvailableCredits = availableCredits
    .filter(c => c.plan === user?.plan)
    .reduce((sum, c) => sum + (c.credits_remaining || 0), 0);

  // Checkout success/cancel handling — als gebruiker terugkomt van Stripe
  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    const checkout = params.get('checkout');
    const addon = params.get('addon');
    if (checkout === 'success') {
      window.history.replaceState({}, '', window.location.pathname);
      setTimeout(async () => {
        if (session?.token && session?.user?.id) {
          const sub = await sb.fetchSubscription(session.token, session.user.id);
          if (sub?.plan) {
            setUser(u => u ? {...u, plan: sub.plan} : u);
            alert(`🎉 Welkom bij Notulist ${sub.plan.charAt(0).toUpperCase() + sub.plan.slice(1)}!\n\nUw abonnement is geactiveerd. U kunt direct alle features gebruiken.`);
          }
        }
      }, 3000);
    } else if (checkout === 'cancel') {
      window.history.replaceState({}, '', window.location.pathname);
    } else if (addon === 'success') {
      window.history.replaceState({}, '', window.location.pathname);
      // Refresh credits na ~3s (webhook tijd nodig)
      setTimeout(() => {
        setRefreshCreditsKey(k => k + 1);
        alert("🎉 Bedankt voor uw aankoop!\n\nUw extra sessies zijn toegevoegd aan uw account.");
      }, 3000);
    } else if (addon === 'cancel') {
      window.history.replaceState({}, '', window.location.pathname);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[session?.token, session?.user?.id]);

  const [newMemberEmail, setNewMemberEmail] = useState("");
  const [memberError, setMemberError] = useState("");
  const [mState,setMS]=useState("idle"), [mtitle,setTitle]=useState(""), [transcript,setT]=useState(""), [stream,setSt]=useState(""), [notulen,setNot]=useState(""), [err,setErr]=useState("");
  const [transcribeProgress, setTranscribeProgress] = useState(null); // {current, total, message} of null
  const [timerReset, setTimerReset] = useState(0); // verhoog om timer naar 0 te resetten
  const [editMode,setEdit]=useState(false), [editTab,setEditTab]=useState("preview");
  const [company,setCompany]=useState(""), [logoUrl,setLogoUrl]=useState(""), [logoName,setLogoName]=useState(""), [accent,setAccent]=useState("#2E3F5C"), [saveOk,setSaveOk]=useState(false);
  const {lang,changeLang,t,langs}=useTranslation();
  const {start,stop,vol,micErr}=useMicrophone(t);
  const timer=useTimer(mState==="recording", timerReset);
  
  // Plan limieten indicator — MOET vóór useEffects komen die het gebruiken
  const curPlan=PLANS.find(p=>p.id===(user?.plan||"trial"))||PLANS[0];
  
  // Auto-stop wanneer maximum opnametijd bereikt is
  useEffect(() => {
    if(mState === "recording" && timer.seconds > 0) {
      const maxSeconds = curPlan.maxMinutes * 60;
      if(timer.seconds >= maxSeconds) {
        // Stop automatisch en toon waarschuwing
        alert(`Maximum opnametijd bereikt (${curPlan.maxMinutes} minuten). De opname wordt nu gestopt.`);
        handleStop();
      }
    }
  }, [timer.seconds, mState, curPlan.maxMinutes]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    const s=loadS();
    if(s?.token&&s?.user){setSess(s);setUser({token:s.token,email:s.user.email,name:s.user.user_metadata?.name||s.user.email?.split("@")[0]||"Gebruiker",plan:s.user.user_metadata?.plan||"trial",initials:(s.user.user_metadata?.name||"U")[0].toUpperCase(),company:"",logoDataUrl:"",accentColor:"#2E3F5C"});}
  },[]);

  const handleLogin=(u)=>{
    setUser(u);
    setCompany(u.company||"");
    setLogoUrl(u.logoDataUrl||"");
    setAccent(u.accentColor||"#2E3F5C");
    // Direct session state setten met meegegeven tokens (geen race condition met localStorage)
    if(u.token && u.sessionUser) {
      setSess({
        token: u.token,
        refresh: u.refresh,
        user: u.sessionUser
      });
    }
    // ── BELANGRIJK: reset alle meeting state bij fresh login ──
    // (anders blijft vorige timer/transcript/notulen van vorige user/sessie staan)
    setMS("idle");
    setT("");
    setNot("");
    setSt("");
    setErr("");
    setTitle("");
    setSavedToArchive(false);
    setResumeFromId(null);
    setPausedBlobs([]);
    setIsPaused(false);
    setTranscribeProgress(null);
    setTimerReset(k => k + 1); // Reset timer naar 0
    setPage("meeting");
  };
  const handleLogout=()=>{
    setUser(null);
    setSess(null);
    setPage("meeting");
    setShowLogout(false);
    // Reset alle meeting state om data leakage tussen gebruikers te voorkomen
    setMS("idle");
    setT("");
    setNot("");
    setSt("");
    setErr("");
    setTitle("");
    setSavedToArchive(false);
    setResumeFromId(null);
    setPausedBlobs([]);
    setIsPaused(false);
    setTranscribeProgress(null);
    setTimerReset(k => k + 1);
  };
  const handleLogoUpload=(e)=>{const f=e.target.files?.[0];if(!f)return;if(f.size>2*1024*1024){alert(t("maxSize"));return;}setLogoName(f.name);const r=new FileReader();r.onload=ev=>setLogoUrl(ev.target.result);r.readAsDataURL(f);};
  const handleSave=()=>{setUser(u=>({...u,company,logoDataUrl:logoUrl,accentColor:accent}));setSaveOk(true);setTimeout(()=>setSaveOk(false),2500);};
  
  // ── MEETING FLOW ──────────────────────────────────────────────
  const [savedToArchive, setSavedToArchive] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [pausedBlobs, setPausedBlobs] = useState([]); // bewaar geconverteerde blobs voor enterprise hervatten
  const [resumeFromId, setResumeFromId] = useState(null);
  
  const handleStart=async(resumeData=null)=>{
    // ─── TRIAL CHECK ───
    // Voor trial gebruikers: check of de trial nog geldig is
    if(user?.plan === 'trial') {
      if(!trialStatus) {
        setErr("Proefperiode wordt geladen, probeer het opnieuw...");
        return;
      }
      if(trialStatus.expired) {
        setErr("Uw proefperiode van 7 dagen is verstreken. Kies een pakket om door te gaan met opnemen.");
        return;
      }
      if(trialStatus.limitReached) {
        setErr("U heeft de 10 minuten opname van uw proefperiode bereikt. Kies een pakket om door te gaan.");
        return;
      }
    }
    
    // Sessie limiet check: monthly verbruikt + addon credits beschikbaar?
    if(sessionsDone >= curPlan.sessionsPerMonth) {
      // Check of er addon credits beschikbaar zijn voor dit plan
      if (totalAvailableCredits > 0) {
        // OK — addon credit zal worden verbruikt bij save
        // (we tonen het in de UI als info)
      } else {
        // Limiet bereikt EN geen credits — toon optie tot bijkopen (alleen voor abonnees)
        if (user?.plan && user.plan !== "basis_free" && curPlan.id !== "basis_free") {
          // User heeft een abonnement — toon addon modal
          // Maar alleen als ze een echte abo hebben (niet trial of free)
          const hasActiveSub = user?.plan && ["basis","pro","enterprise"].includes(user.plan);
          if (hasActiveSub) {
            setShowAddonModal(true);
            return;
          }
        }
        setErr(`Sessielimiet bereikt voor deze maand (${curPlan.sessionsPerMonth} sessies). Upgrade voor meer of koop extra sessies bij.`);
        return;
      }
    }
    setErr("");setT("");setSt("");setNot("");setEdit(false);setSavedToArchive(false);
    if(resumeData) {
      setTitle(resumeData.title || "");
      setResumeFromId(resumeData.id);
      setPausedBlobs(resumeData.previousBlobs || []);
    } else {
      setResumeFromId(null);
      setPausedBlobs([]);
    }
    setMS("perm");const ok=await start();if(ok)setMS("recording");else setMS("idle");
  };
  
  // Pauze tijdens opname (alleen enterprise)
  const handlePause = async () => {
    if(!curPlan.canPause) return;
    const blob = await stop();
    if(blob) setPausedBlobs(prev => [...prev, blob]);
    setIsPaused(true);
    setMS("paused");
  };
  
  const handleResumeRecording = async () => {
    setIsPaused(false);
    setMS("perm");
    const ok = await start();
    if(ok) setMS("recording");
    else setMS("idle");
  };
  
  const handleStop=async()=>{
    setMS("transcribing");
    let allBlobs;
    if(isPaused) {
      // We zaten al in pauze, gebruik alleen de bestaande pausedBlobs
      allBlobs = [...pausedBlobs];
    } else {
      // Stop huidige opname en voeg toe aan eventuele eerdere segmenten
      const blob = await stop();
      allBlobs = pausedBlobs.length > 0 ? [...pausedBlobs, blob] : [blob];
    }
    
    const validBlobs = allBlobs.filter(b => b && b.size > 0);
    
    if(validBlobs.length === 0 || (validBlobs.length === 1 && validBlobs[0].size < 800)) {
      setErr(t("tooShort"));setMS("idle");return;
    }
    
    setT(""); // transcripttekst leeg maken
    setTranscribeProgress(null);
    let tx="";
    try{
      // Transcribe elk segment apart en voeg samen
      const segments = [];
      const segCount = validBlobs.filter(x=>x.size>=800).length;
      const validBlobsToProcess = validBlobs.filter(x => x.size >= 800);
      
      // Progress callback factory (buiten loop om no-loop-func te vermijden)
      const makeProgressCallback = (segIdx, segTotal) => (info) => {
        setTranscribeProgress({
          segment: segIdx,
          segmentTotal: segTotal,
          chunk: info.current,
          chunkTotal: info.total,
          message: info.message
        });
      };
      
      for (let i = 0; i < validBlobsToProcess.length; i++) {
        const b = validBlobsToProcess[i];
        const onProgress = makeProgressCallback(i + 1, segCount);
        const r = await transcribeWithClaude(b, lang, onProgress);
        if(r && r.trim().length > 0) segments.push(r.trim());
      }
      setTranscribeProgress(null);
      tx = segments.join("\n\n");
      if(!tx || tx.length < 5) {
        throw new Error("Geen tekst herkend in de opname. Spreek duidelijker of zorg voor een rustige omgeving.");
      }
      setT(tx);
    }
    catch(e){
      setTranscribeProgress(null);
      setErr(e.message||"Transcriptie mislukt");
      setMS("idle");
      return;
    }
    
    setMS("generating");
    try{
      // Bij hervatten: combineer met bestaande transcriptie
      let fullTx = tx;
      if(resumeFromId) {
        const prev = history.find(h => h.id === resumeFromId);
        if(prev && prev.transcript) fullTx = prev.transcript + "\n\n[--- Vervolg ---]\n\n" + tx;
      }
      const r=await generateNotulen(fullTx, mtitle, chunk=>setSt(chunk), lang);
      setNot(r);setMS("done");
      // Reset pause state
      setPausedBlobs([]);
      setIsPaused(false);
    }
    catch(e){setErr(t("genError")+" "+e.message);setMS("idle");}
  };
  
  // Sla op in archief (Supabase database)
  const [savingToDb, setSavingToDb] = useState(false);
  const handleSaveToArchive = async () => {
    if(!user || !notulen || savedToArchive || savingToDb) return;
    if(!session?.token) { 
      // Debug info — zo zien we WAAROM session leeg is
      const localSession = loadS();
      console.error("Session expired in handleSaveToArchive", {
        hasUser: !!user,
        hasSessionState: !!session,
        sessionToken: session?.token ? "present" : "missing",
        sessionRefresh: session?.refresh ? "present" : "missing",
        localStorageSession: localSession ? "present" : "missing",
        localStorageToken: localSession?.token ? "present" : "missing"
      });
      
      // Probeer eerst session uit localStorage te herstellen (mocht state pollution zijn)
      if (localSession?.token && localSession?.user) {
        console.log("Restoring session from localStorage...");
        setSess(localSession);
        alert("Even opnieuw proberen op te slaan — sessie hersteld.");
        return;
      }
      
      alert("Sessie verlopen, log opnieuw in."); 
      return; 
    }
    
    setSavingToDb(true);
    const now = new Date();
    const title = mtitle || `Notule ${now.toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB")}`;
    
    const noteData = {
      title: title,
      notes: notulen,
      transcript: transcript || "",
      dur: timer.display || "00:00:00",
      durSeconds: timer.seconds || 0,
      plan: user?.plan || "trial",
      branding: getBranding(),
    };
    
    const saved = await sb.saveNote(session.token, session?.user?.id, user.email, noteData, refreshAccessToken);
    setSavingToDb(false);
    
    if(saved && !saved.error) {
      // Voeg toe aan history met de echte database ID
      const newEntry = {
        id: saved.id,
        title: saved.title,
        notes: saved.notes,
        transcript: saved.transcript,
        dur: saved.duration_display,
        durSeconds: saved.duration_seconds,
        plan: saved.plan,
        branding: saved.branding,
        timestamp: saved.created_at,
        date: new Date(saved.created_at).toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB", {day:"numeric",month:"long",year:"numeric"}),
      };
      setHistory(prev => [newEntry, ...prev]);
      setSavedToArchive(true);
      setResumeFromId(null);
      
      // ⚡ PERMANENTE teller bijwerken in session_usage tabel
      // Dit blijft staan, ook als gebruiker de notule later verwijdert
      // Period is gebaseerd op Stripe billing cycle (current_period_start)
      if (session?.token && session?.user?.id) {
        await sb.incrementUsage(
          session.token,
          session.user.id,
          user.email,
          saved.duration_seconds || 0,
          currentSubscription
        );
        setRefreshUsageKey(k => k + 1); // refresh teller in UI
        
        // ⏱️ TRIAL: voor trial users ook de trial seconds bijwerken
        if (user.plan === 'trial') {
          await sb.incrementTrialUsage(
            session.token,
            session.user.id,
            saved.duration_seconds || 0
          );
          setRefreshTrialKey(k => k + 1); // refresh trial UI
        }
      }
      
      // Verbruik addon credit als deze sessie boven de maandelijkse limiet zit
      const wasOverLimit = sessionsDone >= curPlan.sessionsPerMonth;
      if (wasOverLimit && totalAvailableCredits > 0 && session?.token) {
        const planCredits = availableCredits
          .filter(c => c.plan === user.plan)
          .sort((a,b) => new Date(a.purchased_at) - new Date(b.purchased_at));
        if (planCredits.length > 0) {
          const oldestCredit = planCredits[0];
          await sb.consumeCredit(session.token, oldestCredit.id);
          setRefreshCreditsKey(k => k + 1);
        }
      }
    } else {
      // Save mislukt — gedetailleerde error info
      const err = saved?.error ? saved : { status: 0, message: "Onbekende fout" };
      console.error("Save failed:", err);
      
      if (err.status === 401) {
        // Token compleet verlopen, refresh ook gefaald
        const refreshResult = await refreshAccessToken();
        if (!refreshResult) {
          alert("Uw sessie is verlopen. Log opnieuw in.\n\nGoed nieuws: uw notulen blijven in dit scherm bewaard. Na opnieuw inloggen kunt u op 'Opslaan' klikken om alsnog op te slaan.");
        } else {
          alert("Sessie is vernieuwd. Probeer nogmaals op te slaan.");
        }
      } else if (err.status === 403) {
        alert("Toegang geweigerd door de database (403). Dit kan een rechten-probleem zijn. Stuur een screenshot van de console (F12) naar support@notulistai.com.\n\nDetails: " + err.message);
      } else if (err.status === 400) {
        alert("Ongeldige data (400). Mogelijk ontbreekt een verplicht veld of klopt het formaat niet.\n\nDetails: " + err.message);
      } else if (err.status === 409) {
        alert("Conflict (409) — deze notule lijkt al opgeslagen te zijn.");
      } else if (err.status === 0) {
        alert("Geen verbinding met de server. Controleer uw internet en probeer opnieuw.\n\nDetails: " + err.message);
      } else {
        alert(`Opslaan mislukt (${err.status || "?"}).\n\nDetails: ${err.message}\n\nProbeer het opnieuw of neem contact op met support.`);
      }
    }
  };
  
  // Hervat een bestaande meeting (alleen enterprise) - opens keuze dialoog
  const [resumeDialog, setResumeDialog] = useState(null); // { entry, newTitle }
  
  const handleResumeMeeting = (entry) => {
    if(!curPlan.canResume) {
      alert("Meeting hervatten is alleen beschikbaar in Enterprise.");
      return;
    }
    // Open dialoog met keuze: hervatten met zelfde titel OF nieuwe notule met nieuwe naam
    setResumeDialog({ entry, newTitle: entry.title });
  };
  
  // Hervat en voeg toe aan bestaande notule
  const confirmResumeAppend = () => {
    if(!resumeDialog) return;
    const entry = resumeDialog.entry;
    setPage("meeting");
    setTitle(entry.title);
    setResumeDialog(null);
    handleStart({
      id: entry.id,
      title: entry.title,
      previousTranscript: entry.transcript
    });
  };
  
  // Hervat en maak NIEUWE notule met nieuwe naam (gebruikt vorige transcriptie als basis)
  const confirmResumeNew = () => {
    if(!resumeDialog) return;
    const entry = resumeDialog.entry;
    const newTitle = (resumeDialog.newTitle || "").trim() || `${entry.title} (vervolg)`;
    setPage("meeting");
    setTitle(newTitle);
    setResumeDialog(null);
    handleStart({
      id: null, // null = nieuwe notule, niet appenden
      title: newTitle,
      previousTranscript: entry.transcript
    });
  };
  
  const reset=()=>{setMS("idle");setNot("");setTitle("");setSt("");setErr("");setT("");setEdit(false);setEditTab("preview");setSavedToArchive(false);setPausedBlobs([]);setIsPaused(false);setResumeFromId(null);setTimerReset(k => k + 1);};
  const sc=n=>{const o=["recording","transcribing","generating","done"],c=o.indexOf(mState),i=n-1;return c>i?"dn":c===i?"on":"";};
  const getBranding=()=>({logoDataUrl:user?.logoDataUrl||logoUrl,accentColor:user?.accentColor||accent,name:user?.name||"",company:user?.company||company,lang});

  // Geschiedenis uit Supabase database
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  
  // Laad notulen bij login (en herlaad als user wijzigt)
  useEffect(()=>{
    if(!user || !session?.token) { setHistory([]); return; }
    let cancelled = false;
    setHistoryLoading(true);
    (async ()=>{
      const notes = await sb.fetchNotes(session.token);
      if(cancelled) return;
      // Map database velden naar UI velden
      const mapped = notes.map(n => ({
        id: n.id,
        title: n.title,
        notes: n.notes,
        transcript: n.transcript || "",
        dur: n.duration_display || "00:00:00",
        durSeconds: n.duration_seconds || 0,
        plan: n.plan || "basis",
        branding: n.branding,
        timestamp: n.created_at,
        date: new Date(n.created_at).toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB", {day:"numeric",month:"long",year:"numeric"}),
        owner_email: n.owner_email,
      }));
      setHistory(mapped);
      setHistoryLoading(false);
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.email, session?.token]);
  
  const [deleteId, setDeleteId] = useState(null);
  
  // ─── SESSIE VERBRUIK ──
  // Gebruik permanente teller in session_usage tabel (NIET afgeleid van history)
  // Verwijderen van notule beïnvloedt deze NIET (anti-misbruik)
  const [usageStats, setUsageStats] = useState({ sessions_count: 0, total_seconds: 0 });
  const [refreshUsageKey, setRefreshUsageKey] = useState(0);
  
  useEffect(()=>{
    if (!session?.token || !session?.user?.id) {
      setUsageStats({ sessions_count: 0, total_seconds: 0 });
      return;
    }
    let cancelled = false;
    (async ()=>{
      const usage = await sb.fetchUsage(session.token, session.user.id, currentSubscription);
      if (!cancelled) setUsageStats(usage);
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[session?.token, session?.user?.id, refreshUsageKey, currentSubscription?.current_period_start]);
  
  const sessionsDone = usageStats.sessions_count || 0;
  // totalMinutesThisMonth wordt elders in code gebruikt voor Enterprise tracking
  
  const pct=Math.min(100,Math.round((sessionsDone/curPlan.sessionsPerMonth)*100));

  const navItems=[{id:"meeting",icon:"🎙️",label:t("meeting")},{id:"history",icon:"📁",label:t("archive")},{id:"plans",icon:"💎",label:t("plans")},{id:"account",icon:"⚙️",label:t("account")}];

  const BrandMark=()=><div style={{display:"flex",alignItems:"center",gap:10}}>
    <div style={{width:34,height:34,borderRadius:8,background:"linear-gradient(135deg,#2E3F5C,#1C2A3E)",border:"1px solid rgba(255,255,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>📋</div>
    <div style={{fontSize:19,fontWeight:600,letterSpacing:"-.4px",color:"#EDF1F7"}}>Notul<em style={{fontStyle:"normal",color:"#C9A84C"}}>ist</em></div>
  </div>;

  if(!user) return <div><style>{CSS}</style><AuthScreen onLogin={handleLogin} t={t} lang={lang} changeLang={changeLang} langs={langs}/></div>;

  return (
    <div>
      <style>{CSS}</style>
      {showLogout ? <LogoutModal token={session?.token||user.token} onConfirm={handleLogout} onCancel={()=>setShowLogout(false)} t={t}/> : null}
      {showDelete ? <DataDeleteModal onClose={()=>setShowDelete(false)} t={t}/> : null}
      
      {/* Extra sessies kopen modal */}
      {showAddonModal ? (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:"#1C2A3E",border:"1px solid rgba(255,255,255,.08)",borderRadius:16,padding:28,maxWidth:480,width:"100%",boxShadow:"0 30px 80px rgba(0,0,0,.5)"}}>
            <div style={{fontSize:36,marginBottom:12,textAlign:"center"}}>💳</div>
            <div style={{fontSize:20,fontWeight:700,color:"#EDF1F7",marginBottom:8,textAlign:"center"}}>Extra sessies bijkopen</div>
            <div style={{fontSize:13.5,color:"#9BAFC8",lineHeight:1.6,marginBottom:14,textAlign:"center"}}>
              Kies hoeveel extra <strong style={{color:curPlan.accent}}>{curPlan.name}</strong> sessies u wilt kopen.<br/>
              <span style={{fontSize:12,color:"#7A8FA8"}}>Per sessie: max. {curPlan.maxMinutes < 60 ? `${curPlan.maxMinutes} min` : `${curPlan.maxMinutes/60} uur`}{curPlan.canPause ? " · pauze/hervat" : ""}</span>
            </div>
            
            {/* Aantallen knoppen */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
              {[1,2,5,10].map(qty => {
                const priceEx = curPlan.id === "basis" ? 1.20 : curPlan.id === "pro" ? 2.30 : 6.00;
                const totalEx = (priceEx * qty).toFixed(2).replace(".",",");
                return (
                  <button 
                    key={qty}
                    onClick={()=>{
                      // ── NATIVE APP: geen checkout, neutrale melding (store policy) ──
                      if (IS_NATIVE_APP) {
                        setShowAddonModal(false);
                        alert(NATIVE_SUBSCRIPTION_MSG);
                        return;
                      }
                      if (!session?.user?.id || !user?.email) {
                        alert("Sessie verlopen. Log opnieuw in.");
                        return;
                      }
                      setShowAddonModal(false);
                      stripeAddonCheckout({
                        plan: curPlan.id,
                        quantity: qty,
                        userId: session.user.id,
                        email: user.email
                      });
                    }}
                    style={{
                      background: "rgba(46,79,124,.12)",
                      border: "1px solid rgba(46,79,124,.4)",
                      borderRadius: 10,
                      padding: "14px 8px",
                      cursor: "pointer",
                      transition: "all .15s",
                      fontFamily: "inherit"
                    }}
                    onMouseEnter={e=>{e.currentTarget.style.background="rgba(46,79,124,.25)"; e.currentTarget.style.borderColor="rgba(46,79,124,.7)";}}
                    onMouseLeave={e=>{e.currentTarget.style.background="rgba(46,79,124,.12)"; e.currentTarget.style.borderColor="rgba(46,79,124,.4)";}}
                  >
                    <div style={{fontSize:22,fontWeight:700,color:"#EDF1F7",marginBottom:4}}>{qty}×</div>
                    <div style={{fontSize:10.5,color:"#7A8FA8",marginBottom:2}}>{qty === 1 ? "sessie" : "sessies"}</div>
                    <div style={{fontSize:12.5,color:curPlan.accent,fontWeight:600}}>€{totalEx}</div>
                  </button>
                );
              })}
            </div>
            
            <div style={{padding:"10px 14px",background:"rgba(232,154,60,.06)",border:"1px solid rgba(232,154,60,.2)",borderRadius:9,marginBottom:14,fontSize:11.5,color:"#9BAFC8",lineHeight:1.55}}>
              ℹ️ Prijzen exclusief BTW. Extra sessies vervallen aan einde van uw huidige betaalperiode. Tip: bij meer dan 5 extra sessies per maand kan een upgrade voordeliger zijn.
            </div>
            
            <button onClick={()=>setShowAddonModal(false)} style={{width:"100%",padding:"11px",background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:9,color:"#9BAFC8",fontFamily:"inherit",fontSize:13.5,fontWeight:600,cursor:"pointer"}}>Annuleren</button>
          </div>
        </div>
      ) : null}
      
      {/* Abonnement opzeggen / beheren modal */}
      {showCancelSub ? (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:"#1C2A3E",border:"1px solid rgba(255,255,255,.08)",borderRadius:16,padding:28,maxWidth:460,width:"100%",boxShadow:"0 30px 80px rgba(0,0,0,.5)"}}>
            <div style={{fontSize:36,marginBottom:12,textAlign:"center"}}>⚙️</div>
            <div style={{fontSize:20,fontWeight:700,color:"#EDF1F7",marginBottom:8,textAlign:"center"}}>Abonnementsbeheer</div>
            <div style={{fontSize:13.5,color:"#9BAFC8",lineHeight:1.6,marginBottom:14,textAlign:"center"}}>
              U wordt doorgestuurd naar het beveiligde Stripe Customer Portal voor uw <span style={{color:curPlan.accent,fontWeight:600}}>{curPlan.name}</span> abonnement.
            </div>
            <div style={{padding:"12px 14px",background:"rgba(46,79,124,.12)",border:"1px solid rgba(46,79,124,.3)",borderRadius:9,marginBottom:18,fontSize:12.5,color:"#9BAFC8",lineHeight:1.6,textAlign:"left"}}>
              Daar kunt u:<br/>
              • <strong style={{color:"#EDF1F7"}}>Abonnement opzeggen</strong> (eindigt aan einde betaalperiode)<br/>
              • Betaalmethode wijzigen<br/>
              • Facturen downloaden<br/>
              • Adres- en BTW-gegevens aanpassen
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setShowCancelSub(false)} style={{flex:1,padding:"12px",background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:9,color:"#9BAFC8",fontFamily:"inherit",fontSize:14,fontWeight:600,cursor:"pointer"}}>Annuleren</button>
              <button onClick={()=>{setShowCancelSub(false); if(IS_NATIVE_APP){alert(NATIVE_SUBSCRIPTION_MSG);return;} stripePortal({ email: user.email });}} style={{flex:1,padding:"12px",background:"linear-gradient(135deg,#2E3F5C,#3D5277)",border:"none",borderRadius:9,color:"#fff",fontFamily:"inherit",fontSize:14,fontWeight:700,cursor:"pointer"}}>Beheer openen →</button>
            </div>
            <div style={{marginTop:14,fontSize:11,color:"#7A8FA8",textAlign:"center",lineHeight:1.5}}>
              🔒 Veilig beheer via Stripe — uw betaalgegevens worden niet door Notulist opgeslagen.
            </div>
          </div>
        </div>
      ) : null}
      {deleteId !== null ? (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:"#1C2A3E",border:"1px solid rgba(255,255,255,.08)",borderRadius:16,padding:28,maxWidth:420,width:"100%",boxShadow:"0 30px 80px rgba(0,0,0,.5)"}}>
            <div style={{fontSize:36,marginBottom:12,textAlign:"center"}}>🗑️</div>
            <div style={{fontSize:20,fontWeight:700,color:"#EDF1F7",marginBottom:8,textAlign:"center"}}>Notule verwijderen?</div>
            <div style={{fontSize:14,color:"#9BAFC8",lineHeight:1.6,marginBottom:24,textAlign:"center"}}>Deze notule wordt permanent verwijderd. Deze actie kan niet ongedaan worden gemaakt.</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setDeleteId(null)} style={{flex:1,padding:"12px",background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",borderRadius:9,color:"#9BAFC8",fontFamily:"inherit",fontSize:14,fontWeight:600,cursor:"pointer"}}>Annuleren</button>
              <button onClick={async()=>{
                if(session?.token) {
                  await sb.deleteNote(session.token, deleteId);
                }
                setHistory(history.filter(h=>h.id!==deleteId));
                setDeleteId(null);
              }} style={{flex:1,padding:"12px",background:"linear-gradient(135deg,#D95252,#E87070)",border:"none",borderRadius:9,color:"#fff",fontFamily:"inherit",fontSize:14,fontWeight:700,cursor:"pointer"}}>Ja, verwijder</button>
            </div>
          </div>
        </div>
      ) : null}
      
      {/* RESUME DIALOG (Enterprise) */}
      {resumeDialog ? (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",backdropFilter:"blur(8px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,padding:20}}>
          <div style={{background:"#1C2A3E",border:"1px solid rgba(255,255,255,.08)",borderRadius:16,padding:28,maxWidth:480,width:"100%",boxShadow:"0 30px 80px rgba(0,0,0,.5)"}}>
            <div style={{fontSize:36,marginBottom:12,textAlign:"center"}}>▶</div>
            <div style={{fontSize:20,fontWeight:700,color:"#EDF1F7",marginBottom:8,textAlign:"center"}}>Meeting hervatten</div>
            <div style={{fontSize:13.5,color:"#9BAFC8",lineHeight:1.6,marginBottom:20,textAlign:"center"}}>Hoe wilt u verder gaan met "<span style={{color:"#E0C06A"}}>{resumeDialog.entry.title}</span>"?</div>
            
            {/* Optie 1: Toevoegen aan bestaande */}
            <div style={{padding:"14px 16px",background:"rgba(91,193,137,.06)",border:"1px solid rgba(91,193,137,.18)",borderRadius:11,marginBottom:12}}>
              <div style={{fontSize:14,fontWeight:700,color:"#5BC189",marginBottom:4}}>📝 Verder gaan met deze notule</div>
              <div style={{fontSize:12.5,color:"#9BAFC8",lineHeight:1.5,marginBottom:10}}>Voegt de nieuwe opname toe aan de bestaande notule. De originele notule wordt bijgewerkt.</div>
              <button onClick={confirmResumeAppend} style={{width:"100%",padding:"10px",background:"linear-gradient(135deg,#3DAB72,#5BC189)",border:"none",borderRadius:8,color:"#fff",fontFamily:"inherit",fontSize:13,fontWeight:700,cursor:"pointer"}}>▶ Verder met dezelfde notule</button>
            </div>
            
            {/* Optie 2: Nieuwe notule met nieuwe naam */}
            <div style={{padding:"14px 16px",background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.18)",borderRadius:11,marginBottom:16}}>
              <div style={{fontSize:14,fontWeight:700,color:"#E0C06A",marginBottom:4}}>📄 Nieuwe notule met nieuwe naam</div>
              <div style={{fontSize:12.5,color:"#9BAFC8",lineHeight:1.5,marginBottom:10}}>Maak een aparte notule met aparte PDF. De vorige blijft ongewijzigd in het archief.</div>
              <input type="text" value={resumeDialog.newTitle} onChange={e=>setResumeDialog({...resumeDialog, newTitle: e.target.value})} placeholder="Naam van de nieuwe notule" style={{width:"100%",background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.1)",borderRadius:7,padding:"9px 12px",color:"#EDF1F7",fontFamily:"inherit",fontSize:13,marginBottom:10,outline:"none"}}/>
              <button onClick={confirmResumeNew} style={{width:"100%",padding:"10px",background:"linear-gradient(135deg,#C9A84C,#E0C06A)",border:"none",borderRadius:8,color:"#0C1220",fontFamily:"inherit",fontSize:13,fontWeight:700,cursor:"pointer"}}>📄 Maak nieuwe notule</button>
            </div>
            
            <button onClick={()=>setResumeDialog(null)} style={{width:"100%",padding:"10px",background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)",borderRadius:8,color:"#7A8FA8",fontFamily:"inherit",fontSize:13,fontWeight:600,cursor:"pointer"}}>Annuleren</button>
          </div>
        </div>
      ) : null}
      <div className="app">
        {/* SIDEBAR */}
        <aside className="sidebar">
          <div className="sb-logo"><BrandMark/></div>
          <nav className="sb-nav">
            <div className="sb-sec">Menu</div>
            {navItems.map(item=>(
              <button key={item.id} className={`nb ${page===item.id?"on":""}`} onClick={()=>setPage(item.id)}>
                <span className="ic">{item.icon}</span>{item.label}
                {item.id==="meeting"&&mState==="recording"&&<span className="ldot"/>}
                {item.id==="meeting"&&mState==="done"&&<span className="bok">✓</span>}
              </button>
            ))}
            <div className="sb-sec" style={{marginTop:16}}>Gebruik</div>
            {user?.plan === 'trial' && trialStatus ? (
              // ─── TRIAL: toon opnametijd ipv sessies ───
              (() => {
                const secUsed = trialStatus.seconds_used || 0;
                const secLimit = trialStatus.seconds_limit || 600;
                const tPct = Math.min(100, Math.round((secUsed / secLimit) * 100));
                const minUsed = Math.floor(secUsed / 60);
                const minLimit = Math.floor(secLimit / 60);
                return (
                  <div style={{padding:"8px 10px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#7A8FA8",marginBottom:4}}>
                      <span>Proefperiode</span>
                      <span style={{color:tPct>80?"#E87070":tPct>60?"#C9A84C":"#7A8FA8"}}>{minUsed}/{minLimit} min</span>
                    </div>
                    <div style={{height:4,background:"#1C2A3E",borderRadius:2,overflow:"hidden"}}>
                      <div style={{height:"100%",width:`${tPct}%`,background:tPct>80?"linear-gradient(90deg,#C9A84C,#E87070)":tPct>60?"#C9A84C":"#3DAB72",borderRadius:2,transition:"width .3s ease"}}/>
                    </div>
                    <div style={{fontSize:10,color:"#7A8FA8",marginTop:3}}>nog {trialStatus.minutesRemaining} min · {trialStatus.daysRemaining}d</div>
                  </div>
                );
              })()
            ) : (
              // ─── BETAALDE PLANNEN: sessies tracker ───
              <div style={{padding:"8px 10px"}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#7A8FA8",marginBottom:4}}>
                  <span>{curPlan.name}</span>
                  <span style={{color:pct>80?"#E87070":pct>60?"#C9A84C":"#7A8FA8"}}>{sessionsDone}/{curPlan.sessionsPerMonth}</span>
                </div>
                <div style={{height:4,background:"#1C2A3E",borderRadius:2,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${pct}%`,background:pct>80?"linear-gradient(90deg,#C9A84C,#E87070)":pct>60?"#C9A84C":"#3DAB72",borderRadius:2,transition:"width .3s ease"}}/>
                </div>
                <div style={{fontSize:10,color:"#7A8FA8",marginTop:3}}>{curPlan.sessionsPerMonth-sessionsDone} sessies resterend</div>
              </div>
            )}
          </nav>
          <div className="sb-bot">
            <div style={{padding:"6px 7px 8px"}}><LangSwitcher lang={lang} changeLang={changeLang}/></div>
            <div className="u-row">
              <div className="av">{user.initials}</div>
              <div className="u-info" onClick={()=>setPage("account")}><div className="u-name">{user.name}</div><div className="u-plan">{curPlan.name}</div></div>
              <button className="lo-btn" onClick={()=>setShowLogout(true)}>↩ Uit</button>
            </div>
          </div>
        </aside>

        {/* MOBILE TOP */}
        <div className="mobile-topbar">
          <BrandMark/>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
          <LangSwitcher lang={lang} changeLang={changeLang} compact={true}/>
          <button onClick={()=>setShowLogout(true)} style={{background:"rgba(217,82,82,.08)",border:"1px solid rgba(217,82,82,.2)",color:"#FF9090",borderRadius:8,padding:"7px 11px",fontSize:12,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>{t("logoutMobile")}</button>
        </div>
        </div>
        <nav className="bottom-nav"><div className="bottom-nav-inner">{navItems.map(item=><button key={item.id} className={`bn-btn ${page===item.id?"on":""}`} onClick={()=>setPage(item.id)}><span className="bn-ic">{item.icon}</span>{item.label}{item.id==="meeting"&&mState==="recording"&&<span className="bn-ldot"/>}</button>)}</div></nav>

        <main className="main">

          {/* ── TRIAL BANNER ── */}
          {user?.plan === 'trial' && trialStatus && (
            <div style={{
              background: trialStatus.canRecord 
                ? 'linear-gradient(135deg, rgba(61,171,114,.15), rgba(91,193,137,.08))'
                : 'linear-gradient(135deg, rgba(232,112,112,.15), rgba(232,112,112,.05))',
              border: `1px solid ${trialStatus.canRecord ? 'rgba(61,171,114,.3)' : 'rgba(232,112,112,.4)'}`,
              borderRadius: 12,
              padding: '14px 18px',
              marginBottom: 20,
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              flexWrap: 'wrap',
            }}>
              <div style={{fontSize: 22}}>
                {trialStatus.canRecord ? '🎁' : trialStatus.expired ? '⏰' : '🛑'}
              </div>
              <div style={{flex: 1, minWidth: 200}}>
                <div style={{fontSize: 14, fontWeight: 600, color: '#EDF1F7', marginBottom: 2}}>
                  {trialStatus.canRecord 
                    ? `Gratis proefperiode actief`
                    : trialStatus.expired 
                      ? `Proefperiode verstreken`
                      : `Proefperiode limiet bereikt`
                  }
                </div>
                <div style={{fontSize: 12.5, color: '#9BAFC8', lineHeight: 1.5}}>
                  {trialStatus.canRecord 
                    ? `Nog ${trialStatus.minutesRemaining} min opnametijd over · ${trialStatus.daysRemaining} ${trialStatus.daysRemaining === 1 ? 'dag' : 'dagen'} resterend`
                    : trialStatus.expired
                      ? `Uw 7-daagse proefperiode is afgelopen. Kies een pakket om door te gaan met opnemen.`
                      : `U heeft de 10 minuten opnametijd benut. Upgrade naar een betaald pakket om door te gaan.`
                  }
                </div>
              </div>
              <button
                onClick={() => setPage('plans')}
                style={{
                  background: 'linear-gradient(135deg, #C9A84C, #E0C06A)',
                  color: '#0C1220',
                  border: 'none',
                  borderRadius: 8,
                  padding: '10px 18px',
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                ✨ Bekijk pakketten
              </button>
            </div>
          )}

          {/* ── MEETING ── */}
          {page==="meeting"&&<>
            <div className="page-hd">
              <div className="page-title">{mState==="idle"?t("newMeeting"):mState==="perm"?t("micAccess"):mState==="recording"?t("meetingActive"):mState==="transcribing"?t("transcribing"):mState==="generating"?t("generatingNotes"):t("meetingDone")}</div>
              <div className="page-sub">{mState==="idle"?t("startSub"):mState==="perm"?t("permSub"):mState==="recording"?t("recordingSub"):mState==="transcribing"?t("transcribingSub"):mState==="generating"?t("generatingSub"):t("doneSub")}</div>
            </div>

            {/* Gebruik deze maand — prominente tracker */}
            {mState==="idle" && (() => {
              // ─── TRIAL USERS: aparte simpele tracker ───
              if(user?.plan === 'trial' && trialStatus) {
                const secUsed = trialStatus.seconds_used || 0;
                const secLimit = trialStatus.seconds_limit || 600;
                const minUsed = Math.floor(secUsed / 60);
                const secRemainder = secUsed % 60;
                const minLimit = Math.floor(secLimit / 60);
                const tPct = Math.min(100, Math.round((secUsed / secLimit) * 100));
                
                return (
                  <div style={{
                    background: "linear-gradient(135deg, rgba(61,171,114,.06), rgba(28,42,62,.5))",
                    border: "1px solid rgba(61,171,114,.18)",
                    borderRadius: 12,
                    padding: "14px 18px",
                    marginBottom: 16
                  }}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
                      <div style={{fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:1,color:"#5DC98A"}}>📊 Gebruik proefperiode</div>
                      <div style={{fontSize:11,color:"#7A8FA8"}}>Plan: <span style={{color:"#EDF1F7",fontWeight:600}}>Gratis proefperiode</span></div>
                    </div>
                    
                    <div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginBottom:5}}>
                        <span style={{color:"#9BAFC8"}}>⏱️ Opnametijd</span>
                        <span style={{color: tPct > 80 ? "#FF9090" : tPct > 60 ? "#E0C06A" : "#9BAFC8", fontWeight: 600}}>
                          {minUsed}m {secRemainder}s / {minLimit}m
                          <span style={{color:"#7A8FA8",fontWeight:400,marginLeft:6}}>· nog {trialStatus.minutesRemaining}m</span>
                        </span>
                      </div>
                      <div style={{height:6,background:"rgba(255,255,255,.04)",borderRadius:3,overflow:"hidden"}}>
                        <div style={{
                          height:"100%",
                          width: `${tPct}%`,
                          background: tPct > 80 ? "linear-gradient(90deg,#C9A84C,#E87070)" : tPct > 60 ? "#C9A84C" : "linear-gradient(90deg,#3DAB72,#5DC98A)",
                          borderRadius: 3,
                          transition: "width .3s ease"
                        }}/>
                      </div>
                    </div>
                    
                    <div style={{
                      marginTop: 12,
                      padding: "8px 12px",
                      background: "rgba(91,193,137,.08)",
                      borderRadius: 6,
                      fontSize: 12,
                      color: "#9BAFC8",
                      display: "flex",
                      alignItems: "center",
                      gap: 8
                    }}>
                      <span>🎁</span>
                      <span>Proefperiode loopt af op <strong style={{color:"#EDF1F7"}}>{new Date(trialStatus.expires_at).toLocaleDateString("nl-NL",{day:"numeric",month:"long"})}</strong> · nog {trialStatus.daysRemaining} {trialStatus.daysRemaining === 1 ? 'dag' : 'dagen'}</span>
                    </div>
                  </div>
                );
              }
              
              // ─── BETAALDE PLANNEN: normale tracker met sessies ───
              // Gebruik permanente teller (NIET afgeleid van history)
              const totalSecondsThisMonth = usageStats.total_seconds || 0;
              const totalMinutesThisMonth = Math.floor(totalSecondsThisMonth / 60);
              
              // Voor enterprise: totale beschikbare minuten = sessies × maxMinutes
              const totalMinutesAvailable = curPlan.sessionsPerMonth * curPlan.maxMinutes;
              const minutesPct = Math.min(100, Math.round((totalMinutesThisMonth / totalMinutesAvailable) * 100));
              const minutesLeft = Math.max(0, totalMinutesAvailable - totalMinutesThisMonth);
              const hoursLeft = Math.floor(minutesLeft / 60);
              const remainingMin = minutesLeft % 60;
              
              return (
                <div style={{
                  background: "linear-gradient(135deg, rgba(201,168,76,.06), rgba(28,42,62,.5))",
                  border: "1px solid rgba(201,168,76,.18)",
                  borderRadius: 12,
                  padding: "14px 18px",
                  marginBottom: 16
                }}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
                    <div style={{fontSize:12,fontWeight:700,textTransform:"uppercase",letterSpacing:1,color:"#E0C06A"}}>📊 Gebruik deze periode</div>
                    <div style={{fontSize:11,color:"#7A8FA8"}}>Plan: <span style={{color:"#EDF1F7",fontWeight:600}}>{curPlan.name}</span></div>
                  </div>
                  
                  {/* Sessies tracker */}
                  <div style={{marginBottom: curPlan.canPause ? 12 : 0}}>
                    <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginBottom:5}}>
                      <span style={{color:"#9BAFC8"}}>🎙️ Sessies</span>
                      <span style={{color: pct > 80 ? "#FF9090" : pct > 60 ? "#E0C06A" : "#9BAFC8", fontWeight: 600}}>
                        {sessionsDone}/{curPlan.sessionsPerMonth}
                        <span style={{color:"#7A8FA8",fontWeight:400,marginLeft:6}}>· nog {Math.max(0, curPlan.sessionsPerMonth - sessionsDone)}</span>
                        {totalAvailableCredits > 0 && (
                          <span style={{color:"#5DC98A",fontWeight:600,marginLeft:6}}>+{totalAvailableCredits} extra</span>
                        )}
                      </span>
                    </div>
                    <div style={{height:6,background:"rgba(255,255,255,.04)",borderRadius:3,overflow:"hidden"}}>
                      <div style={{
                        height:"100%",
                        width: `${pct}%`,
                        background: pct > 80 ? "linear-gradient(90deg,#C9A84C,#E87070)" : pct > 60 ? "#C9A84C" : "linear-gradient(90deg,#3DAB72,#5DC98A)",
                        borderRadius: 3,
                        transition: "width .3s ease"
                      }}/>
                    </div>
                  </div>
                  
                  {/* Minuten tracker (alleen voor plans met pauze/hervat = enterprise) */}
                  {curPlan.canPause && (
                    <div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginBottom:5}}>
                        <span style={{color:"#9BAFC8"}}>⏱️ Opnametijd</span>
                        <span style={{color: minutesPct > 80 ? "#FF9090" : minutesPct > 60 ? "#E0C06A" : "#9BAFC8", fontWeight: 600}}>
                          {Math.floor(totalMinutesThisMonth/60)}u {totalMinutesThisMonth%60}m / {Math.floor(totalMinutesAvailable/60)}u
                          <span style={{color:"#7A8FA8",fontWeight:400,marginLeft:6}}>· nog {hoursLeft}u {remainingMin}m</span>
                        </span>
                      </div>
                      <div style={{height:6,background:"rgba(255,255,255,.04)",borderRadius:3,overflow:"hidden"}}>
                        <div style={{
                          height:"100%",
                          width: `${minutesPct}%`,
                          background: minutesPct > 80 ? "linear-gradient(90deg,#C9A84C,#E87070)" : minutesPct > 60 ? "#C9A84C" : "linear-gradient(90deg,#3DAB72,#5DC98A)",
                          borderRadius: 3,
                          transition: "width .3s ease"
                        }}/>
                      </div>
                    </div>
                  )}
                  
                  {/* Reset datum — duidelijk en mobielvriendelijk */}
                  {currentSubscription?.current_period_end && (() => {
                    const endDate = new Date(currentSubscription.current_period_end);
                    const today = new Date();
                    const msPerDay = 1000 * 60 * 60 * 24;
                    const daysLeft = Math.max(0, Math.ceil((endDate - today) / msPerDay));
                    const resetDateStr = endDate.toLocaleDateString("nl-NL",{day:"numeric",month:"long"});
                    return (
                      <div style={{
                        marginTop:12,
                        paddingTop:11,
                        borderTop:"1px solid rgba(255,255,255,.05)",
                        fontSize:11.5,
                        color:"#7A8FA8",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:8,
                        flexWrap:"wrap"
                      }}>
                        <span>🔄 Vernieuwt over <strong style={{color:"#9BAFC8"}}>{daysLeft} {daysLeft === 1 ? "dag" : "dagen"}</strong></span>
                        <span>op <strong style={{color:"#9BAFC8"}}>{resetDateStr}</strong></span>
                      </div>
                    );
                  })()}
                </div>
              );
            })()}

            {/* PROACTIEVE WAARSCHUWING bij 80%+ gebruik (alleen betalende klanten, vóór limiet) */}
            {mState==="idle"&&user?.plan && ["basis","pro","enterprise"].includes(user.plan) && sessionsDone < curPlan.sessionsPerMonth && (() => {
              const sessionsLeft = curPlan.sessionsPerMonth - sessionsDone;
              const usagePct = (sessionsDone / curPlan.sessionsPerMonth) * 100;
              
              // 95%+: Urgent oranje banner (1 sessie of minder over)
              if (sessionsLeft <= 1 || usagePct >= 95) {
                return (
                  <div style={{background:"rgba(232,154,60,.12)",border:"1px solid rgba(232,154,60,.4)",borderRadius:12,padding:"14px 16px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
                    <div style={{flex:"1 1 220px"}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#FFB840",marginBottom:2}}>
                        ⚠️ Nog {sessionsLeft === 1 ? "1 sessie" : `${sessionsLeft} sessies`} over deze maand
                      </div>
                      <div style={{fontSize:12,color:"#9BAFC8"}}>
                        Koop nu extra sessies om verrassingen te voorkomen, of upgrade voor meer.
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <button onClick={()=>setShowAddonModal(true)} style={{background:"rgba(232,154,60,.15)",border:"1px solid rgba(232,154,60,.5)",color:"#FFB840",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>+ Extra sessie</button>
                      <button onClick={()=>setPage("plans")} style={{background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>Upgrade →</button>
                    </div>
                  </div>
                );
              }
              
              // 80-94%: Gele info banner
              if (usagePct >= 80) {
                return (
                  <div style={{background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.3)",borderRadius:12,padding:"14px 16px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
                    <div style={{flex:"1 1 220px"}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#E0C06A",marginBottom:2}}>
                        💡 Nog {sessionsLeft} {sessionsLeft === 1 ? "sessie" : "sessies"} over deze maand
                      </div>
                      <div style={{fontSize:12,color:"#9BAFC8"}}>
                        Wilt u zekerheid? Koop nu vast extra sessies bij voor uw {curPlan.name} abonnement.
                      </div>
                    </div>
                    <button onClick={()=>setShowAddonModal(true)} style={{background:"rgba(46,79,124,.15)",border:"1px solid rgba(46,79,124,.4)",color:"#9BAFC8",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>+ Bijkopen</button>
                  </div>
                );
              }
              
              return null;
            })()}

            {/* Sessielimiet bereikt: toon addon credits + bijkoop optie */}
            {mState==="idle"&&sessionsDone>=curPlan.sessionsPerMonth&&(
              <>
                {totalAvailableCredits > 0 ? (
                  /* Heeft nog addon credits — toon positief */
                  <div style={{background:"rgba(61,171,114,.08)",border:"1px solid rgba(61,171,114,.25)",borderRadius:12,padding:"14px 16px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
                    <div style={{flex:"1 1 220px"}}>
                      <div style={{fontSize:13,fontWeight:600,color:"#5DC98A",marginBottom:2}}>✓ Maandelijkse sessies op</div>
                      <div style={{fontSize:12,color:"#9BAFC8"}}>U heeft nog <strong style={{color:"#EDF1F7"}}>{totalAvailableCredits} extra {totalAvailableCredits === 1 ? "sessie" : "sessies"}</strong> beschikbaar.</div>
                    </div>
                    <button onClick={()=>setShowAddonModal(true)} style={{background:"rgba(46,79,124,.15)",border:"1px solid rgba(46,79,124,.4)",color:"#9BAFC8",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>+ Meer bijkopen</button>
                  </div>
                ) : (
                  /* Geen credits meer — toon waarschuwing + opties */
                  <div style={{background:"rgba(217,82,82,.1)",border:"1px solid rgba(217,82,82,.25)",borderRadius:12,padding:"14px 16px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
                    <div style={{flex:"1 1 220px"}}><div style={{fontSize:13,fontWeight:600,color:"#FF9090",marginBottom:2}}>Sessielimiet bereikt</div><div style={{fontSize:12,color:"#7A8FA8"}}>Uw {curPlan.name} abonnement staat {curPlan.sessionsPerMonth} sessies per maand toe.</div></div>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                      <button onClick={()=>setShowAddonModal(true)} style={{background:"rgba(46,79,124,.15)",border:"1px solid rgba(46,79,124,.4)",color:"#9BAFC8",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>+ Extra sessie</button>
                      <button onClick={()=>setPage("plans")} style={{background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>Upgrade →</button>
                    </div>
                  </div>
                )}
              </>
            )}
            
            {/* Addon credits indicator wanneer NIET over limiet (info-strookje) */}
            {mState==="idle"&&sessionsDone<curPlan.sessionsPerMonth&&totalAvailableCredits>0&&(
              <div style={{background:"rgba(46,79,124,.08)",border:"1px solid rgba(46,79,124,.2)",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:12.5,color:"#9BAFC8",display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
                <span>💳 <strong style={{color:"#EDF1F7"}}>{totalAvailableCredits} extra {totalAvailableCredits === 1 ? "sessie" : "sessies"}</strong> bovenop uw maandbundel beschikbaar</span>
                <button onClick={()=>setShowAddonModal(true)} style={{background:"transparent",border:"1px solid rgba(255,255,255,.15)",color:"#7A8FA8",borderRadius:6,padding:"5px 10px",fontSize:11.5,fontFamily:"inherit",cursor:"pointer"}}>+ Meer kopen</button>
              </div>
            )}

            {!["idle","perm","done"].includes(mState)&&<div className="steps">{[{n:1,l:t("recording")},{n:2,l:t("transcription")},{n:3,l:t("notes")}].map((s,i)=><div key={s.n} style={{display:"flex",alignItems:"center"}}><div className={`step ${sc(s.n)}`}><div className="sdot">{sc(s.n)==="dn"?"✓":s.n}</div><span style={{whiteSpace:"nowrap"}}>{s.l}</span></div>{i<2&&<div className="sline"/>}</div>)}</div>}

            {mState!=="done"&&<div className="mc">
              {(mState==="perm"||(mState==="idle"&&micErr))&&<MicScreen onRequest={handleStart} err={micErr} t={t}/>}
              {(mState==="transcribing"||mState==="generating")&&<div className="gen-wrap">
                <div className="gen-ring"/>
                <div style={{fontSize:14,fontWeight:500}}>{mState==="transcribing"?t("speechToText"):t("claudeWriting")}</div>
                <div style={{fontSize:13,color:"var(--s)"}}>{mState==="transcribing"?t("patience"):t("composing")}</div>
                {mState==="transcribing" && transcribeProgress && transcribeProgress.chunkTotal > 1 && (
                  <div style={{marginTop:14,padding:"10px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:8,fontSize:12.5,color:"#E0C06A",textAlign:"center",lineHeight:1.5}}>
                    📦 Lange opname — opgesplitst in {transcribeProgress.chunkTotal} delen<br/>
                    <span style={{fontWeight:600}}>Deel {transcribeProgress.chunk} van {transcribeProgress.chunkTotal} verwerkt</span>
                    <div style={{marginTop:8,height:4,background:"rgba(255,255,255,.05)",borderRadius:2,overflow:"hidden"}}>
                      <div style={{height:"100%",width:`${Math.round((transcribeProgress.chunk/transcribeProgress.chunkTotal)*100)}%`,background:"linear-gradient(90deg,#C9A84C,#E0C06A)",transition:"width .3s"}}/>
                    </div>
                  </div>
                )}
                {transcript&&mState==="generating"&&<><div className="trans-lbl">📝 Transcriptie gereed</div><div className="trans-box">{transcript}</div></>}
                {stream&&<div className="stream-box">{stream}<span className="cursor"/></div>}
              </div>}
              {(mState==="idle"||mState==="recording")&&!micErr&&<>
                {mState==="recording"&&<div className="rec-pill"><div className="rec-dot"/>{t("recordingActive")} {curPlan.maxMinutes >= 60 ? `${curPlan.maxMinutes/60} uur` : `${curPlan.maxMinutes} min`}</div>}
                <div className="tmr">{timer.display}</div>
                <div className="tmr-sub">{mState==="idle"?t("readyToStart"):t("micActive")}</div>
                {mState==="recording"&&<><VolBar vol={vol} t={t}/><Waveform vol={vol}/></>}
                {mState==="idle"&&<input className="name-inp" placeholder={t("meetingName")} value={mtitle} onChange={e=>setTitle(e.target.value)}/>}
                {err&&<div style={{background:"rgba(217,82,82,.1)",border:"1px solid rgba(217,82,82,.25)",borderRadius:8,padding:"9px 12px",fontSize:13,color:"#FF9090",marginBottom:14,lineHeight:1.5}}>{err}</div>}
                <div className="btn-row">
                  {mState==="idle"&&<button className="btn-start" onClick={()=>handleStart()} disabled={sessionsDone>=curPlan.sessionsPerMonth}><span style={{fontSize:17}}>🎙️</span> Start Meeting</button>}
                  {mState==="recording"&&<>
                    <button className="btn-stop" onClick={handleStop}><span>■</span> Stop & Maak Notulen</button>
                    {curPlan.canPause && <button onClick={handlePause} title="Pauze" style={{background:"linear-gradient(135deg,#E89A3C,#F0B05C)",color:"#fff",border:"none",borderRadius:11,padding:"14px 18px",fontSize:14.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>⏸</button>}
                    <button className="btn-cancel" onClick={async()=>{await stop();setPausedBlobs([]);setIsPaused(false);setMS("idle");}}>✕</button>
                  </>}
                  {mState==="paused"&&<>
                    <button onClick={handleResumeRecording} style={{flex:1,background:"linear-gradient(135deg,#3DAB72,#5BC189)",color:"#fff",border:"none",borderRadius:11,padding:14,fontSize:14.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>▶ Hervat opname</button>
                    <button className="btn-stop" onClick={handleStop} style={{flex:"none",padding:"14px 18px"}}>■ Beëindig & maak notulen</button>
                    <button className="btn-cancel" onClick={()=>{setPausedBlobs([]);setIsPaused(false);setMS("idle");}}>✕</button>
                  </>}
                </div>
                {mState==="paused"&&<div style={{marginTop:14,padding:"10px 14px",background:"rgba(232,154,60,.1)",border:"1px solid rgba(232,154,60,.25)",borderRadius:8,fontSize:13,color:"#F0B05C",textAlign:"center"}}>⏸ Opname gepauzeerd · {pausedBlobs.length} segment{pausedBlobs.length!==1?"en":""} opgenomen</div>}
              </>}
            </div>}

            {mState==="done"&&notulen&&<div className="nc">
              {/* Succes-banner direct na opslaan — prominente Nieuwe Meeting knop */}
              {savedToArchive && (
                <div style={{
                  background:"linear-gradient(135deg, rgba(61,171,114,.12), rgba(91,193,137,.06))",
                  border:"1px solid rgba(61,171,114,.3)",
                  borderRadius:14,
                  padding:"16px 18px",
                  marginBottom:16,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"space-between",
                  gap:14,
                  flexWrap:"wrap"
                }}>
                  <div style={{flex:"1 1 220px"}}>
                    <div style={{fontSize:14.5,fontWeight:700,color:"#5DC98A",marginBottom:3,display:"flex",alignItems:"center",gap:7}}>
                      <span style={{fontSize:18}}>✓</span> Notule opgeslagen in archief
                    </div>
                    <div style={{fontSize:12.5,color:"#9BAFC8",lineHeight:1.5}}>
                      U kunt deze notule altijd terugvinden via Archief. Klaar voor een nieuwe meeting?
                    </div>
                  </div>
                  <button 
                    onClick={reset} 
                    style={{
                      background:"linear-gradient(135deg,#3DAB72,#5BC189)",
                      border:"none",
                      borderRadius:9,
                      padding:"11px 18px",
                      color:"#fff",
                      fontFamily:"inherit",
                      fontSize:13.5,
                      fontWeight:700,
                      cursor:"pointer",
                      whiteSpace:"nowrap",
                      boxShadow:"0 4px 12px rgba(61,171,114,.3)"
                    }}
                  >
                    🎙️ Nieuwe meeting starten
                  </button>
                </div>
              )}
              <div className="nhd">
                <div><div className="ntitle">{mtitle||t("meeting")}</div><div className="nmeta">{new Date().toLocaleDateString("nl-NL",{day:"numeric",month:"long",year:"numeric"})} · {timer.display} · Claude AI</div></div>
                <div className="nacts">
                  <button className={`ab ${editMode?"edit-on":""}`} onClick={()=>{setEdit(e=>!e);setEditTab("preview");}}>
                    {editMode?t("editDone"):t("edit")}
                  </button>
                  {!savedToArchive ? (
                    <button className="ab" onClick={handleSaveToArchive} disabled={savingToDb} style={{background:savingToDb?"rgba(61,171,114,.4)":"linear-gradient(135deg,#3DAB72,#5BC189)",color:"#fff",border:"none",fontWeight:700,cursor:savingToDb?"wait":"pointer"}}>{savingToDb?"⏳ Opslaan...":"💾 Opslaan"}</button>
                  ) : (
                    <button className="ab" disabled style={{background:"rgba(61,171,114,.15)",color:"#5BC189",border:"1px solid rgba(61,171,114,.3)",cursor:"default"}}>✓ Opgeslagen</button>
                  )}
                  <button className="ab pdf" onClick={()=>exportToPDF(notulen,mtitle,timer.display,getBranding())}>📄 PDF</button>
                  <button className="ab word" onClick={()=>exportToWord(notulen,mtitle,timer.display,getBranding())}>📝 Word</button>
                  <button className="ab" onClick={()=>navigator.clipboard?.writeText(notulen)}>⎘ Kopieer</button>
                  <button className="ab" onClick={reset}>+ Nieuw</button>
                </div>
              </div>
              {editMode&&<><div className="ed-tabs"><button className={`ed-tab ${editTab==="preview"?"on":""}`} onClick={()=>setEditTab("preview")}>👁 Voorbeeld</button><button className={`ed-tab ${editTab==="source"?"on":""}`} onClick={()=>setEditTab("source")}>✏️ Bewerken</button></div>{editTab==="source"&&<NotulenEditor value={notulen} onChange={setNot}/>}{editTab==="preview"&&<div className="nb2" dangerouslySetInnerHTML={{__html:mdToHtml(notulen)}}/>}</>}
              {!editMode&&<div className="nb2" dangerouslySetInnerHTML={{__html:mdToHtml(notulen)}}/>}
            </div>}
          </>}

          {/* ── ARCHIEF ── */}
          {page==="history"&&<>
            <div className="page-hd"><div className="page-title">Archief</div><div className="page-sub">Overzicht van uw opgeslagen notule-sessies</div></div>
            <div className="hl">
              {historyLoading ? (
                <div style={{padding:"40px 20px",textAlign:"center",color:"#7A8FA8"}}>
                  <div style={{fontSize:24,marginBottom:8}}>⏳</div>
                  <div style={{fontSize:13}}>Notulen laden...</div>
                </div>
              ) : history.length === 0 ? (
                <div style={{padding:"40px 20px",textAlign:"center",color:"#7A8FA8",background:"rgba(255,255,255,.02)",borderRadius:12,border:"1px dashed rgba(255,255,255,.08)"}}>
                  <div style={{fontSize:32,marginBottom:8}}>📭</div>
                  <div style={{fontSize:14,fontWeight:600,color:"#9BAFC8",marginBottom:4}}>Nog geen notulen</div>
                  <div style={{fontSize:12.5}}>Start een nieuwe meeting om uw eerste notule te maken.</div>
                </div>
              ) : history.map(h=>{const p=PLANS.find(x=>x.id===h.plan)||PLANS[0];return <div key={h.id} className="hi">
                <div><div className="hn">{h.title}</div><div className="hm">📅 {h.date} · ⏱ {h.dur} · <span style={{color:p.accent}}>{p.name}</span></div></div>
                <div style={{display:"flex",alignItems:"center",gap:7,flexShrink:0,flexWrap:"wrap"}}>
                  {curPlan.canResume && (
                    <button className="ab" onClick={()=>handleResumeMeeting(h)} style={{color:"#5BC189",borderColor:"rgba(91,193,137,.3)"}} title="Hervat deze meeting">▶ Hervatten</button>
                  )}
                  <button className="ab pdf" onClick={()=>exportToPDF(h.notes,h.title,h.dur,h.branding||getBranding())}>📄 PDF</button>
                  <button className="ab word" onClick={()=>exportToWord(h.notes,h.title,h.dur,h.branding||getBranding())}>📝 Word</button>
                  <button className="ab" onClick={()=>{setNot(h.notes);setTitle(h.title);setMS("done");setPage("meeting");}}>👁 Bekijk</button>
                  <button className="ab" onClick={()=>setDeleteId(h.id)} style={{color:"#E87070",borderColor:"rgba(232,112,112,.3)"}} title="Verwijderen">🗑️</button>
                </div>
              </div>;})}
            </div>
            <div style={{marginTop:16,padding:"12px 16px",background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.15)",borderRadius:10,fontSize:12,color:"#7A8FA8",lineHeight:1.6}}>
              🔒 <strong style={{color:"#9BAFC8"}}>AVG:</strong> Opgeslagen notulen worden maximaal 12 maanden bewaard. Audio-opnames worden direct na transcriptie verwijderd.
            </div>
          </>}

          {/* ── ABONNEMENTEN ── */}
          {page==="plans"&&<>
            <div className="page-hd"><div className="page-title">Abonnementen</div><div className="page-sub">Kies het pakket dat bij uw gebruik past</div></div>
            
            {/* Billing cycle toggle */}
            <div style={{display:"flex",justifyContent:"center",marginBottom:24}}>
              <div style={{display:"inline-flex",background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)",borderRadius:11,padding:4,position:"relative"}}>
                <button onClick={()=>setBillingCycle("monthly")} style={{padding:"9px 22px",background:billingCycle==="monthly"?"linear-gradient(135deg,#2E3F5C,#243350)":"transparent",border:"none",borderRadius:8,color:billingCycle==="monthly"?"#EDF1F7":"#7A8FA8",fontFamily:"inherit",fontSize:13,fontWeight:600,cursor:"pointer",transition:"all .2s"}}>Maandelijks</button>
                <button onClick={()=>setBillingCycle("yearly")} style={{padding:"9px 22px",background:billingCycle==="yearly"?"linear-gradient(135deg,#C9A84C,#E0C06A)":"transparent",border:"none",borderRadius:8,color:billingCycle==="yearly"?"#0C1220":"#7A8FA8",fontFamily:"inherit",fontSize:13,fontWeight:700,cursor:"pointer",transition:"all .2s",position:"relative"}}>
                  Jaarlijks
                  <span style={{position:"absolute",top:-9,right:-10,background:"linear-gradient(135deg,#3DAB72,#5BC189)",color:"#fff",fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:10,whiteSpace:"nowrap"}}>-10%</span>
                </button>
              </div>
            </div>
            
            <div className="plans-grid">
              {PLANS.map(p=>{
                const isYearly = billingCycle === "yearly";
                const displayPrice = isYearly ? p.yearlyMonthly : p.price;
                const yearlyTotal = p.yearlyPrice;
                const yearlySaving = (p.priceNum * 12 - p.yearlyNum).toFixed(2).replace(".",",");
                return (
                <div key={p.id} className={`pc ${p.popular?"pop":""}`}>
                  {p.badge&&<div className="pb">{p.badge}</div>}
                  <div className="pn">{p.name}</div>
                  <div className="plm">{p.label}</div>
                  <div className="pp" style={{color:p.accent}}>{displayPrice}<span>/maand</span></div>
                  {isYearly && (
                    <div style={{fontSize:12,color:"#5BC189",fontWeight:600,marginTop:-8,marginBottom:8,lineHeight:1.4}}>
                      €{yearlyTotal.replace("€","")}/jaar · bespaart €{yearlySaving}
                    </div>
                  )}
                  <div className="ptag">{p.tagline}</div>
                  <ul className="pf">{p.features.map((f,i)=><li key={i}>{f}</li>)}</ul>
                  <button 
                    className="plan-btn" 
                    onClick={() => {
                      if (user.plan === p.id) return; // huidige plan, niets doen
                      // ── NATIVE APP: geen checkout, neutrale melding (store policy) ──
                      if (IS_NATIVE_APP) {
                        alert(NATIVE_SUBSCRIPTION_MSG);
                        return;
                      }
                      if (!user.email || !session?.user?.id) {
                        alert("Sessie verlopen. Log opnieuw in.");
                        return;
                      }
                      stripeCheckout({
                        plan: p.id,
                        interval: billingCycle === "yearly" ? "yearly" : "monthly",
                        userId: session.user.id,
                        email: user.email
                      });
                    }}
                    disabled={user.plan === p.id}
                    style={user.plan===p.id?{opacity:0.6,cursor:"default"}:{}}
                  >
                    {user.plan===p.id?t("currentPlan"):"Start nu →"}
                  </button>
                </div>
                );
              })}
            </div>
            
            {/* Custom solution callout */}
            <div style={{marginTop:24,padding:"20px 22px",background:"linear-gradient(135deg,rgba(201,168,76,.08),rgba(155,143,196,.04))",border:"1px solid rgba(201,168,76,.2)",borderRadius:14,display:"flex",alignItems:"center",justifyContent:"space-between",gap:16,flexWrap:"wrap"}}>
              <div style={{flex:"1 1 280px"}}>
                <div style={{fontSize:15,fontWeight:700,color:"#EDF1F7",marginBottom:4}}>💼 Geen pakket dat aansluit bij uw wensen?</div>
                <div style={{fontSize:13,color:"#9BAFC8",lineHeight:1.55}}>Voor grotere teams, custom integraties of speciale wensen maken we graag een persoonlijk voorstel.</div>
              </div>
              <a href={`mailto:info@notulistai.com?subject=${encodeURIComponent("Maatwerk Notulist AI")}&body=${encodeURIComponent("Hallo,\n\nIk ben geïnteresseerd in een maatwerk Notulist AI oplossing.\n\nMijn wensen:\n- Aantal gebruikers: \n- Aantal sessies per maand: \n- Specifieke wensen: \n\nGraag hoor ik van u.\n\nMet vriendelijke groet,\n")}`} style={{background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:10,padding:"12px 22px",fontSize:13.5,fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap",textDecoration:"none",display:"inline-block"}}>✉️ Neem contact op</a>
            </div>
            
            <div style={{marginTop:16,padding:"14px 18px",background:"rgba(61,171,114,.05)",border:"1px solid rgba(61,171,114,.15)",borderRadius:12,fontSize:12.5,color:"#7A8FA8",lineHeight:1.7}}>
              <strong style={{color:"#5DC98A"}}>ℹ️ Abonnementsinformatie</strong><br/>
              Alle abonnementen worden maandelijks gefactureerd en zijn maandelijks opzegbaar. Betaling verloopt via Stripe. Prijzen zijn exclusief BTW.
            </div>
          </>}

          {/* ── ACCOUNT ── */}
          {page==="account"&&<>
            <div className="page-hd"><div className="page-title">Account & Huisstijl</div><div className="page-sub">Beheer uw profiel, bedrijfslogo en exportinstellingen</div></div>
            <div className="ag">
              {/* Logo */}
              <div className="ac">
                <div className="asec">📎 Bedrijfslogo</div>
                <div className="luz"><input type="file" accept="image/png,image/jpeg,image/svg+xml,image/webp" onChange={handleLogoUpload}/>
                  {logoUrl?<><img src={logoUrl} alt="Logo" style={{width:"100%",height:72,objectFit:"contain",marginBottom:8,borderRadius:6}}/><div style={{fontSize:12,color:"#E0C06A"}}>✓ {logoName||"Logo geladen"}</div></>:<><div style={{fontSize:26,marginBottom:7}}>🏢</div><div style={{fontSize:13,color:"#9BAFC8",fontWeight:500}}>Klik om logo te uploaden</div><div style={{fontSize:11.5,color:"#7A8FA8"}}>PNG, JPG of SVG · Max 2MB</div></>}
                </div>
                {logoUrl&&<button onClick={()=>{setLogoUrl("");setLogoName("");}} style={{marginTop:9,background:"none",border:"1px solid #243350",color:"#7A8FA8",borderRadius:7,padding:"5px 11px",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>✕ Verwijderen</button>}
              </div>

              {/* Bedrijfsinfo */}
              <div className="ac">
                <div className="asec">🏢 Bedrijfsgegevens</div>
                <div className="af"><div className="al">Naam</div><input className="ai" value={user.name} readOnly style={{opacity:.55}}/></div>
                <div className="af"><div className="al">E-mail</div><input className="ai" value={user.email} readOnly style={{opacity:.55}}/></div>
                <div className="af"><div className="al">Organisatie</div><input className="ai" placeholder={t("orgPlaceholder")} value={company} onChange={e=>setCompany(e.target.value)}/></div>
                <div className="af"><div className="al">Accentkleur exports</div>
                  <div className="cr">
                    <div className="cs"><div style={{width:34,height:34,borderRadius:5,background:accent}}/><input type="color" value={accent} onChange={e=>setAccent(e.target.value)}/></div>
                    <span className="cv">{accent}</span>
                    <div style={{display:"flex",gap:5,marginLeft:"auto"}}>{["#2E3F5C","#C47A0A","#1B4D3E","#5B2D8E","#B71C1C"].map(c=><div key={c} onClick={()=>setAccent(c)} style={{width:20,height:20,borderRadius:4,background:c,cursor:"pointer",border:accent===c?"2px solid white":"2px solid transparent",transition:"border .12s"}}/>)}</div>
                  </div>
                </div>
              </div>

              {/* PDF preview */}
              <div className="ac full">
                <div className="asec">👁️ Export Voorbeeld</div>
                <div style={{background:"white",borderRadius:10,overflow:"hidden",boxShadow:"0 6px 28px rgba(0,0,0,.3)"}}>
                  <div style={{background:accent,padding:"14px 20px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div><div style={{fontSize:7.5,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,color:"rgba(255,255,255,.55)",marginBottom:2}}>Vergadernotulen</div><div style={{fontSize:14,fontWeight:700,color:"white"}}>Naam van de meeting</div><div style={{fontSize:9,color:"rgba(255,255,255,.65)",marginTop:2}}>{new Date().toLocaleDateString("nl-NL",{weekday:"long",day:"numeric",month:"long",year:"numeric"})} · 00:00:00</div></div>
                    <div style={{background:"white",borderRadius:6,padding:"6px 9px",display:"flex",alignItems:"center",minWidth:65,justifyContent:"center"}}>{logoUrl?<img src={logoUrl} alt="logo" style={{height:26,maxWidth:100,objectFit:"contain"}}/>:<div style={{fontSize:10.5,fontWeight:700,color:accent}}>{company||"Uw logo"}</div>}</div>
                  </div>
                  <div style={{padding:"12px 20px",fontSize:10.5,color:"#333",lineHeight:1.6}}>
                    <div style={{background:accent+"22",borderLeft:`3px solid ${accent}`,borderRadius:3,padding:"8px 12px",marginBottom:10,display:"grid",gridTemplateColumns:"1fr 1fr",gap:"4px 16px"}}>{[[t("organization"),company||"—"],["Opgesteld door",user.name],["Datum",new Date().toLocaleDateString("nl-NL")],["Vergaderduur","00:00:00"]].map(([l,v])=><div key={l}><div style={{fontSize:7,fontWeight:700,textTransform:"uppercase",color:accent,letterSpacing:.5}}>{l}</div><div>{v}</div></div>)}</div>
                    <div style={{fontSize:10.5,fontWeight:700,color:accent,paddingBottom:3,borderBottom:`2pt solid ${accent}22`,marginBottom:6}}>Samenvatting</div>
                    <div style={{color:"#555",fontSize:10}}>Hier verschijnt de AI-samenvatting van uw vergadering…</div>
                  </div>
                </div>
                <div style={{marginTop:9,fontSize:12,color:"#7A8FA8"}}>💡 Wijzig kleur of logo — het voorbeeld wordt direct bijgewerkt</div>
              </div>

              {/* Opslaan */}
              <div className="ac full" style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
                <div style={{fontSize:13,color:"#9BAFC8"}}>Instellingen worden toegepast op alle PDF- en Word-exports.</div>
                <div style={{display:"flex",alignItems:"center"}}><button className="bsave" onClick={handleSave}>Opslaan</button>{saveOk&&<span className="svok">✓ Opgeslagen!</span>}</div>
              </div>

              {/* Team beheer — alleen Pro & Enterprise */}
              {curPlan.users > 1 && (
                <div className="ac full">
                  <div className="asec">👥 Teamleden ({teamMembers.length + 1}/{curPlan.users})</div>
                  <div style={{fontSize:13,color:"#9BAFC8",marginBottom:14,lineHeight:1.55}}>
                    Nodig collega's uit om uw {curPlan.name} abonnement te delen. Zij ontvangen een e-mail met een uitnodiging om zelf een account aan te maken. Het gedeelde archief is voor alle leden zichtbaar.
                  </div>
                  
                  {/* Lijst bestaande leden */}
                  <div style={{marginBottom:14}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:9,marginBottom:8}}>
                      <div style={{width:34,height:34,borderRadius:"50%",background:"linear-gradient(135deg,#C9A84C,#E0C06A)",display:"flex",alignItems:"center",justifyContent:"center",color:"#0C1220",fontWeight:700,fontSize:13}}>
                        {(user.name||user.email||"?").charAt(0).toUpperCase()}
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:13.5,fontWeight:600,color:"#EDF1F7",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user.name||"U"}</div>
                        <div style={{fontSize:11.5,color:"#7A8FA8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user.email}</div>
                      </div>
                      <div style={{fontSize:11,color:"#E0C06A",fontWeight:700,background:"rgba(201,168,76,.12)",padding:"3px 9px",borderRadius:5}}>EIGENAAR</div>
                    </div>
                    
                    {teamMembers.map((m,i)=>(
                      <div key={m.id||i} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:"rgba(255,255,255,.03)",border:"1px solid rgba(255,255,255,.06)",borderRadius:9,marginBottom:8}}>
                        <div style={{width:34,height:34,borderRadius:"50%",background:"linear-gradient(135deg,#2E3F5C,#1C2A3E)",display:"flex",alignItems:"center",justifyContent:"center",color:"#9BAFC8",fontWeight:700,fontSize:13}}>
                          {(m.member_email||m.email||"?").charAt(0).toUpperCase()}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:13.5,fontWeight:600,color:"#EDF1F7",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.member_email||m.email}</div>
                          <div style={{fontSize:11.5,color:m.status==="pending"?"#E89A3C":"#5DC98A"}}>{m.status==="pending"?"⏳ Uitnodiging verzonden":"✓ Lid"}</div>
                        </div>
                        <button onClick={async()=>{
                          const memberEmail = m.member_email||m.email;
                          if(window.confirm(`${memberEmail} verwijderen uit team?`)) {
                            if(m.id && session?.token) {
                              await sb.removeMember(session.token, m.id);
                            }
                            setTeamMembers(prev => prev.filter(tm => (tm.id||tm.email) !== (m.id||m.email)));
                          }
                        }} style={{background:"none",border:"1px solid rgba(255,255,255,.1)",color:"#7A8FA8",borderRadius:6,padding:"5px 10px",fontSize:12,fontFamily:"inherit",cursor:"pointer"}} title="Verwijderen">✕</button>
                      </div>
                    ))}
                  </div>
                  
                  {/* Nieuw lid toevoegen */}
                  {teamMembers.length + 1 < curPlan.users ? (
                    <div>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                        <input 
                          className="ai" 
                          type="email" 
                          placeholder="collega@bedrijf.nl" 
                          value={newMemberEmail}
                          onChange={e=>{setNewMemberEmail(e.target.value);setMemberError("");}}
                          style={{flex:"1 1 240px"}}
                        />
                        <button 
                          onClick={async()=>{
                            const email = newMemberEmail.trim().toLowerCase();
                            if(!email || !email.includes("@")) {
                              setMemberError("Voer een geldig e-mailadres in.");
                              return;
                            }
                            if(email === user.email.toLowerCase()) {
                              setMemberError("U bent al de eigenaar.");
                              return;
                            }
                            if(teamMembers.find(m=>(m.member_email||m.email||"").toLowerCase()===email)) {
                              setMemberError("Dit e-mailadres is al toegevoegd.");
                              return;
                            }
                            if(!session?.token) {
                              setMemberError("Sessie verlopen. Log opnieuw in.");
                              return;
                            }
                            
                            // Sla op in Supabase database
                            const result = await sb.inviteMember(session.token, user.email, newMemberEmail.trim());
                            if(result.error) {
                              setMemberError("Uitnodigen mislukt. Probeer opnieuw.");
                              return;
                            }
                            
                            setTeamMembers(prev => [...prev, result.data]);
                            // Open mail client met uitnodiging
                            const subject = encodeURIComponent(`Uitnodiging voor Notulist AI van ${user.name||user.email}`);
                            const body = encodeURIComponent(`Hallo,\n\n${user.name||user.email} nodigt je uit om gebruik te maken van Notulist AI — een ${curPlan.name} abonnement.\n\nMaak een account aan op https://app.notulistai.com met dit e-mailadres (${newMemberEmail.trim()}) om automatisch toegang te krijgen tot het gedeelde team-archief.\n\nMet vriendelijke groet,\n${user.name||user.email}`);
                            window.location.href = `mailto:${newMemberEmail.trim()}?subject=${subject}&body=${body}`;
                            setNewMemberEmail("");
                            setMemberError("");
                          }}
                          style={{background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:8,padding:"10px 18px",fontSize:13,fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}
                        >
                          ✉ Uitnodigen
                        </button>
                      </div>
                      {memberError && <div style={{marginTop:8,fontSize:12,color:"#FF9090"}}>{memberError}</div>}
                      <div style={{marginTop:8,fontSize:11.5,color:"#7A8FA8",lineHeight:1.5}}>
                        Bij het klikken op "Uitnodigen" opent uw e-mailprogramma met een voorbereide uitnodiging. Het lid maakt zelf een account aan met het uitgenodigde e-mailadres.
                      </div>
                    </div>
                  ) : (
                    <div style={{padding:"12px 14px",background:"rgba(232,154,60,.08)",border:"1px solid rgba(232,154,60,.2)",borderRadius:9,fontSize:12.5,color:"#F0B05C"}}>
                      ⚠️ Maximum aantal leden bereikt ({curPlan.users}). Upgrade voor meer plekken.
                    </div>
                  )}
                </div>
              )}

              {/* Abonnement beheer */}
              <div className="ac full">
                <div className="asec">💎 Abonnement</div>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap",padding:"14px 16px",background:`linear-gradient(135deg,${curPlan.accent}15,${curPlan.accent}05)`,border:`1px solid ${curPlan.accent}40`,borderRadius:11,marginBottom:14}}>
                  <div>
                    <div style={{fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,color:curPlan.accent,marginBottom:4}}>Huidig abonnement</div>
                    <div style={{fontSize:18,fontWeight:700,color:"#EDF1F7",marginBottom:3}}>{curPlan.name}</div>
                    <div style={{fontSize:12.5,color:"#9BAFC8"}}>{curPlan.price}{curPlan.period} · {curPlan.sessionsPerMonth} sessies/maand · max. {curPlan.maxMinutes >= 60 ? `${curPlan.maxMinutes/60} uur` : `${curPlan.maxMinutes} min`} per sessie</div>
                  </div>
                  {user.plan !== "enterprise" && (
                    <button onClick={()=>setPage("plans")} style={{background:"linear-gradient(135deg,#C9A84C,#E0C06A)",color:"#0C1220",border:"none",borderRadius:8,padding:"10px 18px",fontSize:13,fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>⬆ Upgrade</button>
                  )}
                </div>
                
                <div style={{display:"flex",gap:9,flexWrap:"wrap",alignItems:"center"}}>
                  <button onClick={()=>setShowCancelSub(true)} style={{background:"rgba(46,79,124,.12)",border:"1px solid rgba(46,79,124,.35)",color:"#9BAFC8",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>⚙️ Abonnement beheren</button>
                  <div style={{fontSize:11.5,color:"#7A8FA8",flex:"1 1 200px"}}>U behoudt toegang tot het einde van de huidige betaalperiode. Geen opzegtermijn.</div>
                </div>
              </div>

              {/* AVG rechten */}
              <div className="ac full">
                <div className="asec">🔒 Privacy & AVG</div>
                <div className="avg-section">
                  <div className="avg-title">✅ Uw privacyrechten (AVG / GDPR)</div>
                  <div className="avg-item">{t("rightInspect")}</div>
                  <div className="avg-item">{t("rightCorrect")}</div>
                  <div className="avg-item">{t("rightDelete")}</div>
                  <div className="avg-item">{t("rightPortability")}</div>
                  <div className="avg-item">{t("audioDeleted")}</div>
                </div>
                <div style={{marginTop:14,display:"flex",gap:9,flexWrap:"wrap"}}>
                  <button onClick={()=>setShowDelete(true)} style={{background:"rgba(217,82,82,.08)",border:"1px solid rgba(217,82,82,.2)",color:"#FF9090",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>🗑️ Gegevens verwijderen (AVG)</button>
                  <a href="mailto:privacy@notulistai.com" style={{background:"var(--n2)",border:"1px solid var(--n3)",color:"var(--sl)",borderRadius:8,padding:"9px 14px",fontSize:12.5,fontWeight:500,textDecoration:"none",display:"inline-flex",alignItems:"center"}}>✉️ Privacy contact</a>
                </div>
              </div>
            </div>
          </>}

        </main>
      </div>
    </div>
  );
}